{
  "% к прошлой неделе": "% zur Vorwoche",
  ". STEOS ID и финансовые квитанции сохраняются.": ". STEOS ID und Finanzbelege bleiben erhalten.",
  ". Готовые голоса доступны в разделе «Озвучка» → «Мои».": ". Fertige Stimmen sind unter „Sprachausgabe“ → „Meine“ verfügbar.",
  ". Он не меняет голос озвучки чата.": ". Sie ändert nicht die Stimme für die Sprachausgabe im Chat.",
  ". После подтверждения обновите профиль.": ". Aktualisieren Sie nach der Bestätigung Ihr Profil.",
  ". Проверьте папку «Спам».": ". Überprüfen Sie den Spam-Ordner.",
  "Circle каждый месяц по подписке": "Circle im Monatsabo",
  "Circle по подписке на этот месяц потрачены": "Die Abo-Circle für diesen Monat sind aufgebraucht",
  "STEOS ID · {0}": "STEOS ID · {0}",
  "STEOS ID · Не подключён": "STEOS ID · Nicht verbunden",
  "Telegram ID скопирован.": "Telegram-ID kopiert.",
  "{0} {1} C сгорят {2}": "{0} {1} C verfallen am {2}",
  "{0} из {1}": "{0} von {1}",
  "{0} фото хватит для сходства": "{0} Fotos reichen für eine Ähnlichkeit",
  "{0}: {1} работ": "{0}: {1} Werke",
  "{0}: пока недоступно": "{0}: derzeit nicht verfügbar",
  "· Вы и варианты": "· Sie und Varianten",
  "· Новое": "· Neu",
  "· занято": "· belegt",
  "· отменена": "· storniert",
  "». Обучение начнётся после отдельного нажатия «Повторить обработку» в карточке.": "». Das Training beginnt, nachdem Sie in der Karte separat auf „Erneut verarbeiten“ geklickt haben.",
  "Автовоспроизведение примеров": "Beispiele automatisch abspielen",
  "Аккаунт": "Konto",
  "Аккаунт подключён": "Konto verbunden",
  "Архив недоступен или срок ссылки истёк. Можно запросить новую выгрузку.": "Archiv nicht verfügbar oder Link abgelaufen. Sie können einen neuen Export anfordern.",
  "Бабушка": "Oma",
  "Баланс и вывод доступны в STEOS ID.": "Guthaben und Auszahlung sind in STEOS ID verfügbar.",
  "Баланс и награды": "Guthaben und Prämien",
  "Без имени": "Ohne Namen",
  "Бесплатный план": "Kostenloser Tarif",
  "Ближайшие": "Bevorstehende",
  "Близкие": "Liebste",
  "Близкий исчезнет из профиля. Его фото больше не будут доступны для новых работ.": "Die Person verschwindet aus Ihrem Profil. Ihre Fotos stehen für neue Werke nicht mehr zur Verfügung.",
  "Близкий удалён.": "Person gelöscht.",
  "Близких пока нет.": "Noch keine Angehörigen vorhanden.",
  "Брат": "Bruder",
  "В Steos с": "Bei Steos seit",
  "В избранное": "Zu Favoriten hinzufügen",
  "Валюта": "Währung",
  "Вариант будет удалён. Исходные фото и STEOS ID сохранятся.": "Die Variante wird gelöscht. Originalfotos und STEOS ID bleiben erhalten.",
  "Вариантов: {0}": "Varianten: {0}",
  "Варианты": "Varianten",
  "Ваш собственный голос": "Ihre eigene Stimme",
  "Введите УДАЛИТЬ": "УДАЛИТЬ eingeben",
  "Введите пароль": "Passwort eingeben",
  "Введите почту": "E-Mail-Adresse eingeben",
  "Вернуться ко входу": "Zurück zur Anmeldung",
  "Версия": "Version",
  "Версия согласия изменилась. Обновите страницу и подтвердите актуальный текст.": "Die Zustimmungsversion hat sich geändert. Aktualisieren Sie die Seite und bestätigen Sie den aktuellen Text.",
  "Версия согласия изменилась. Обновите страницу.": "Die Zustimmungsversion hat sich geändert. Aktualisieren Sie die Seite.",
  "Версия:": "Version:",
  "Взрослый": "Erwachsener",
  "Включаем микрофон…": "Mikrofon wird aktiviert…",
  "Включено": "Aktiviert",
  "Возраст": "Alter",
  "Войти": "Anmelden",
  "Восстановить пароль": "Passwort wiederherstellen",
  "Все Circle на балансе без срока": "Ihre Circle verfallen nicht",
  "Вы": "Sie",
  "Вы и близкие": "Sie und Angehörige",
  "Вы и варианты": "Du & deine Looks",
  "Выберите голос": "Stimme auswählen",
  "Выберите инструмент и заполните его форму. Готовая работа сохранится в истории.": "Wählen Sie ein Tool aus und füllen Sie das Formular aus. Das fertige Werk wird im Verlauf gespeichert.",
  "Выбран": "Ausgewählt",
  "Выбрать голос": "Stimme auswählen",
  "Выбрать голос по умолчанию": "Standardstimme auswählen",
  "Выбрать из работ": "Aus Werken auswählen",
  "Выгрузить мои данные": "Meine Daten exportieren",
  "Выгрузка:": "Export:",
  "Выключено": "Deaktiviert",
  "Голос": "Stimme",
  "Голос готов. Он доступен на вкладке «Мои» в озвучке.": "Stimme fertig. Sie ist im Tab „Meine“ unter Sprachausgabe verfügbar.",
  "Голос и клон": "Stimme und Klon",
  "Голос изменился. Данные обновлены — проверьте их перед сохранением.": "Die Stimme hat sich geändert. Die Daten wurden aktualisiert – prüfen Sie sie vor dem Speichern.",
  "Голос изменился. Проверьте обновлённые данные перед повторной обработкой.": "Die Stimme hat sich geändert. Prüfen Sie die aktualisierten Daten, bevor Sie die Verarbeitung erneut starten.",
  "Голос исчезнет из вашего списка. Это действие нельзя отменить.": "Die Stimme wird aus Ihrer Liste entfernt. Diese Aktion kann nicht rückgängig gemacht werden.",
  "Голос по умолчанию для создания:": "Standardstimme für die Erstellung:",
  "Голос принят в обработку. Здесь появится его статус.": "Stimme zur Verarbeitung angenommen. Ihr Status wird hier angezeigt.",
  "Голос уже удалён или недоступен.": "Stimme bereits gelöscht oder nicht verfügbar.",
  "Голос:": "Stimme:",
  "Голоса не найдены. Откройте каталог или измените поиск.": "Keine Stimmen gefunden. Öffnen Sie den Katalog oder ändern Sie die Suche.",
  "Горизонтальное": "Horizontal",
  "Готов": "Fertig",
  "Готовим образцы": "Beispiele werden vorbereitet",
  "Готово": "Fertig",
  "Готовые работы": "Fertige Werke",
  "Далее": "Weiter",
  "Данные Telegram обновлены.": "Telegram-Daten aktualisiert.",
  "Данные баланса временно недоступны": "Guthabendaten vorübergehend nicht verfügbar",
  "Данные переносятся в подтверждённый аккаунт. Старые сессии закрыты; квитанция позволяет продолжить проверку после перезагрузки.": "Die Daten werden in das bestätigte Konto übertragen. Alte Sitzungen wurden geschlossen; mit dem Beleg können Sie die Prüfung nach einem Neuladen fortsetzen.",
  "Дедушка": "Opa",
  "До 5 фото: лицо крупно, при хорошем свете": "Bis zu 5 Fotos: Gesicht groß und bei gutem Licht",
  "До пяти фото. Они будут использоваться как ваш образ.": "Bis zu fünf Fotos. Sie werden als Ihr Erscheinungsbild verwendet.",
  "Добавить близкого": "Angehörige hinzufügen",
  "Добавить фото": "Foto hinzufügen",
  "Добавьте ещё": "Weitere hinzufügen",
  "Добавьте от 2 секунд до 1,5 минуты вашей речи. Говорите естественно, без музыки и других голосов.": "Fügen Sie 2 Sekunden bis 1,5 Minuten Ihrer Sprache hinzu. Sprechen Sie natürlich, ohne Musik oder andere Stimmen.",
  "Дочь": "Tochter",
  "Друг": "Freund",
  "Если аккаунт существует, ссылка для нового пароля отправлена на": "Falls das Konto existiert, wurde der Link für ein neues Passwort gesendet an",
  "Ещё варианты": "Weitere Varianten",
  "Ещё операции": "Weitere Vorgänge",
  "Ещё работы": "Weitere Werke",
  "Жена": "Ehefrau",
  "ЗАМЕНА ОБРАЗЦОВ": "BEISPIELE ERSETZEN",
  "Забыли пароль?": "Passwort vergessen?",
  "Загружаем аккаунт…": "Konto wird geladen …",
  "Загружаем варианты…": "Varianten werden geladen …",
  "Загружаем ваши голоса…": "Ihre Stimmen werden geladen …",
  "Загружаем голоса…": "Stimmen werden geladen …",
  "Загружаем настройки…": "Einstellungen werden geladen …",
  "Загружаем обновления…": "Updates werden geladen …",
  "Загружаем операции…": "Vorgänge werden geladen …",
  "Загружаем пример…": "Beispiel wird geladen …",
  "Загружаем работы…": "Werke werden geladen …",
  "Загружаем фото…": "Fotos werden geladen …",
  "Загрузить аудиофайлы": "Audiodateien hochladen",
  "Загрузить выбранные фото": "Ausgewählte Fotos hochladen",
  "Загрузка ещё не подтверждена. Нажмите «Продолжить отправку»: сначала проверим прежнюю загрузку.": "Upload noch nicht bestätigt. Klicken Sie auf „Upload fortsetzen“: Zuerst prüfen wir den vorherigen Upload.",
  "Загрузка не подтверждена. Продолжение сначала проверит прежние загрузки.": "Upload nicht bestätigt. Beim Fortsetzen werden zunächst die vorherigen Uploads geprüft.",
  "Загрузка отклонена. Нажмите «Продолжить отправку», чтобы получить новую ссылку и загрузить образец.": "Upload abgelehnt. Klicken Sie auf „Upload fortsetzen“, um einen neuen Link zu erhalten und das Beispiel hochzuladen.",
  "Закрыть": "Schließen",
  "Закрыть мастер": "Assistenten schließen",
  "Заменить образцы": "Beispiele ersetzen",
  "Записать с микрофона": "Mit dem Mikrofon aufnehmen",
  "Запись": "Aufnahme",
  "Запись здесь недоступна. Откройте приложение по HTTPS или загрузите аудиофайл.": "Die Aufnahme ist hier nicht verfügbar. Öffne die App über HTTPS oder lade eine Audiodatei hoch.",
  "Запись прервалась. Попробуйте ещё раз или загрузите файл.": "Die Aufnahme wurde unterbrochen. Versuche es erneut oder lade eine Datei hoch.",
  "Запись-{0}.{1}": "Aufnahme-{0}.{1}",
  "Запишите образец, дождитесь обучения и озвучивайте текст своим голосом.": "Nehmen Sie ein Beispiel auf, warten Sie das Training ab und sprechen Sie Texte mit Ihrer eigenen Stimme ein.",
  "Запишите речь или загрузите аудиофайлы": "Sprechen aufnehmen oder Audiodateien hochladen",
  "Запишите свой голос один раз — используйте его в озвучке.": "Nehmen Sie Ihre Stimme einmal auf und verwenden Sie sie für die Sprachausgabe.",
  "Запрос сохранён. Продолжение проверит прежний запрос и не создаст второй голос.": "Anfrage gespeichert. Beim Fortsetzen wird die vorherige Anfrage geprüft, ohne eine zweite Stimme zu erstellen.",
  "Запустить обработку": "Verarbeitung starten",
  "Здесь появятся ваши работы": "Hier erscheinen Ihre Werke",
  "Из них": "Davon",
  "Из них {0} C можно вывести": "Davon können {0} C ausgezahlt werden",
  "Избранное": "Favoriten",
  "Избранные работы": "Favorisierte Werke",
  "Изменение не подтверждено. Проверьте актуальную карточку перед повтором.": "Änderung nicht bestätigt. Prüfen Sie vor einem erneuten Versuch die aktuelle Karte.",
  "Изменить": "Bearbeiten",
  "Изменить близкого": "Angehörige bearbeiten",
  "Изменить вариант": "Variante bearbeiten",
  "Изменить голос": "Stimme bearbeiten",
  "Изменить мои фото": "Meine Fotos bearbeiten",
  "Имя близкого": "Name der angehörigen Person",
  "Имя голоса": "Stimmenname",
  "Имя пользователя не задано": "Benutzername nicht festgelegt",
  "Использовать как себя": "Als mich selbst verwenden",
  "Используем сохранённые образцы голоса «": "Gespeicherte Stimmbeispiele verwenden „",
  "Используйте свои фото и фото близких в инструментах студии.": "Verwenden Sie Ihre Fotos und die Fotos Ihrer Angehörigen in den Studio-Tools.",
  "История очищена: {0} работ, {1} заказов.": "Verlauf geleert: {0} Werke, {1} Aufträge.",
  "КЛОН ГОЛОСА": "STIMMKLON",
  "Каждый образец должен содержать хотя бы одну секунду речи.": "Jedes Beispiel muss mindestens eine Sekunde Sprache enthalten.",
  "Как в системе": "Wie im System",
  "Как пользоваться": "So funktioniert’s",
  "Как снимать": "Aufnahmetipps",
  "Каталог голосов": "Stimmenkatalog",
  "Квадрат": "Quadratisch",
  "Кем приходится": "Verwandtschaft",
  "Ко входу": "Zur Anmeldung",
  "Количество вариантов пока недоступно": "Anzahl der Varianten derzeit nicht verfügbar",
  "Конфиденциальность": "Datenschutz",
  "Копирование недоступно. ID показан в карточке аккаунта.": "Kopieren nicht verfügbar. Die ID wird in der Kontokarte angezeigt.",
  "Кружок с героем": "Videonachricht mit Figur",
  "Лимит {0} голосов выбран": "Limit von {0} Stimmen ausgewählt",
  "Лимит голосов выбран. Удалите ненужный голос, чтобы добавить новый.": "Stimmenlimit erreicht. Löschen Sie eine nicht benötigte Stimme, um eine neue hinzuzufügen.",
  "Лимит:": "Limit:",
  "Мама": "Mama",
  "Можно добавить до {0} образцов.": "Sie können bis zu {0} Beispiele hinzufügen.",
  "Можно закрыть приложение. Статус обновится после обработки.": "Sie können die App schließen. Der Status wird nach der Verarbeitung aktualisiert.",
  "Мои варианты": "Meine Varianten",
  "Мои голоса": "Meine Stimmen",
  "Мои данные": "Meine Daten",
  "Мои фото": "Meine Fotos",
  "Моё": "Mein Profil",
  "Моё фото": "Mein Foto",
  "Муж": "Ehemann",
  "НОВЫЙ ГОЛОС": "NEUE STIMME",
  "Награды": "Prämien",
  "Награды и задания": "Belohnungen und Aufgaben",
  "Назад": "Zurück",
  "Название варианта": "Variantenname",
  "Назначить голос": "Stimme zuweisen",
  "Настройки": "Einstellungen",
  "Настройки уже изменились. Показана актуальная версия.": "Die Einstellungen wurden bereits geändert. Die aktuelle Version wird angezeigt.",
  "Начните с 2 секунд речи в тихом месте.": "Beginnen Sie mit 2 Sekunden Sprache an einem ruhigen Ort.",
  "Не больше 5 фото JPEG или PNG, до 10 МБ каждое.": "Maximal 5 JPEG- oder PNG-Fotos mit jeweils bis zu 10 MB.",
  "Не задано": "Nicht festgelegt",
  "Не короче 8 знаков": "Mindestens 8 Zeichen",
  "Не удалось включить микрофон. Разрешите доступ или загрузите файл.": "Das Mikrofon konnte nicht aktiviert werden. Erlaube den Zugriff oder lade eine Datei hoch.",
  "Не удалось войти. Откройте приложение из Telegram заново.": "Anmeldung fehlgeschlagen. Öffnen Sie die App erneut über Telegram.",
  "Не удалось воспроизвести пример. Откройте карточку заново и попробуйте ещё раз.": "Beispiel konnte nicht abgespielt werden. Öffnen Sie die Karte erneut und versuchen Sie es noch einmal.",
  "Не удалось загрузить варианты.": "Varianten konnten nicht geladen werden.",
  "Не удалось загрузить голоса. Измените поиск или вкладку, чтобы повторить.": "Stimmen konnten nicht geladen werden. Ändern Sie die Suche oder den Tab, um es erneut zu versuchen.",
  "Не удалось загрузить настройки. Попробуйте обновить.": "Einstellungen konnten nicht geladen werden. Versuchen Sie, die Seite zu aktualisieren.",
  "Не удалось загрузить работы.": "Werke konnten nicht geladen werden.",
  "Не удалось загрузить следующую страницу.": "Nächste Seite konnte nicht geladen werden.",
  "Не удалось загрузить следующую страницу. Попробуйте ещё раз.": "Nächste Seite konnte nicht geladen werden. Versuchen Sie es erneut.",
  "Не удалось обновить данные из Telegram. Попробуйте позже.": "Telegram-Daten konnten nicht aktualisiert werden. Versuchen Sie es später erneut.",
  "Не удалось подтвердить изменение избранного. Обновите профиль.": "Änderung der Favoriten konnte nicht bestätigt werden. Aktualisieren Sie Ihr Profil.",
  "Не удалось подтвердить операцию. Проверьте состояние аккаунта перед повтором.": "Vorgang konnte nicht bestätigt werden. Prüfen Sie vor einem erneuten Versuch den Kontostatus.",
  "Не удалось подтвердить сохранение. Обновите настройки перед повтором.": "Speichern konnte nicht bestätigt werden. Aktualisieren Sie vor einem erneuten Versuch die Einstellungen.",
  "Не удалось подтвердить удаление близкого. Обновите профиль.": "Löschen der angehörigen Person konnte nicht bestätigt werden. Aktualisieren Sie Ihr Profil.",
  "Не удалось получить ответ. Попробуйте ещё раз — запрос продолжится с прежним ключом.": "Keine Antwort erhalten. Versuchen Sie es erneut – die Anfrage wird mit demselben Schlüssel fortgesetzt.",
  "Не удалось проверить выгрузку. Обновите страницу: продолжим прежнюю операцию.": "Export konnte nicht überprüft werden. Aktualisieren Sie die Seite: Wir setzen den vorherigen Vorgang fort.",
  "Не удалось прочитать запись.": "Die Aufnahme konnte nicht gelesen werden.",
  "Не удалось создать голос. Откройте карточку, чтобы проверить статус или повторить обработку.": "Stimme konnte nicht erstellt werden. Öffnen Sie die Karte, um den Status zu prüfen oder die Verarbeitung erneut zu starten.",
  "Не удалось создать голос. Проверьте данные и образцы.": "Stimme konnte nicht erstellt werden. Prüfen Sie die Daten und Beispiele.",
  "Не удалось сохранить просмотр. Можно закрыть и вернуться позже.": "Ansicht konnte nicht gespeichert werden. Sie können die Seite schließen und später zurückkehren.",
  "Неверная почта или пароль": "Ungültige E-Mail-Adresse oder ungültiges Passwort",
  "Нет работ": "Keine Werke",
  "Новая выгрузка": "Neuer Export",
  "Новости": "Neuigkeiten",
  "Новый вариант": "Neue Variante",
  "Новый голос": "Neue Stimme",
  "Новых публикаций пока нет.": "Noch keine Beiträge veröffentlicht.",
  "Нужно от 2 секунд до 1,5 минуты речи в сумме.": "Sie benötigen insgesamt 2 Sekunden bis 1,5 Minuten Sprache.",
  "О приложении": "Über die App",
  "Обновить": "Aktualisieren",
  "Обновить варианты": "Varianten aktualisieren",
  "Обновить из Telegram": "Aus Telegram aktualisieren",
  "Обновить настройки": "Einstellungen aktualisieren",
  "Обновить профиль": "Profil aktualisieren",
  "Обновить работы": "Werke aktualisieren",
  "Обновления": "Aktualisierungen",
  "Обновляем вход…": "Anmeldung wird aktualisiert …",
  "Обрабатывается": "In Bearbeitung",
  "Образ готов": "Erscheinungsbild fertig",
  "Образ ещё не собран": "Erscheinungsbild noch nicht erstellt",
  "Образец {0}": "Beispiel {0}",
  "Образец голоса": "Stimmbeispiel",
  "Образец ещё не проверен. Подождите и продолжите отправку.": "Beispiel noch nicht geprüft. Warten Sie und setzen Sie den Upload fort.",
  "Образец не прошёл проверку. Выберите другую запись.": "Beispiel hat die Prüfung nicht bestanden. Wählen Sie eine andere Aufnahme.",
  "Образцы готовы к повторной обработке.": "Beispiele bereit für erneute Verarbeitung.",
  "Образцы для «": "Beispiele für „",
  "Образцы обновлены. Нажмите «Повторить обработку», чтобы обучить голос заново.": "Beispiele aktualisiert. Klicken Sie auf „Erneut verarbeiten“, um die Stimme neu zu trainieren.",
  "Обучаем голос": "Stimme wird trainiert",
  "Общая длительность образцов не должна превышать 1,5 минуты.": "Die Gesamtdauer der Beispiele darf 1,5 Minuten nicht überschreiten.",
  "Объединение STEOS ID": "STEOS-IDs zusammenführen",
  "Объединяем аккаунты": "Konten werden zusammengeführt",
  "Объём образцов": "Umfang der Beispiele",
  "Один аккаунт для бота и сайта STEOS": "Ein Konto für den STEOS-Bot und die STEOS-Website",
  "Озвучить текст голосом «": "Text mit der Stimme „ vorlesen",
  "Операции": "Vorgänge",
  "Операции в токенах STEOS ID": "Vorgänge in STEOS-ID-Token",
  "Операции временно недоступны.": "Vorgänge vorübergehend nicht verfügbar.",
  "Операций пока нет.": "Noch keine Vorgänge vorhanden.",
  "Операция не подтверждена. Повтор использует прежний ключ.": "Vorgang nicht bestätigt. Beim erneuten Versuch wird derselbe Schlüssel verwendet.",
  "Описание": "Beschreibung",
  "Описание и согласие": "Beschreibung und Zustimmung",
  "Остановить запись ·": "Aufnahme stoppen ·",
  "Остаток Circle недоступен": "Circle-Restguthaben nicht verfügbar",
  "Отклик": "Haptisches Feedback",
  "Откройте ссылку из письма и задайте новый пароль на id.steos.io. Потом войдите здесь.": "Öffnen Sie den Link aus der E-Mail und legen Sie unter id.steos.io ein neues Passwort fest. Melden Sie sich anschließend hier an.",
  "Откройте ссылку подтверждения для": "Öffnen Sie den Bestätigungslink für",
  "Открыть id.steos.io": "id.steos.io öffnen",
  "Открыть историю": "Verlauf öffnen",
  "Отмена": "Abbrechen",
  "Отметьте согласие с условиями": "Stimmen Sie den Bedingungen zu",
  "Отправить ссылку": "Link senden",
  "Отправляем…": "Wird gesendet …",
  "Оформить подписку": "Abo abschließen",
  "Оформление": "Darstellung",
  "Очистить историю": "Verlauf löschen",
  "Очистить историю?": "Verlauf löschen?",
  "Очистка не подтверждена. Повтор проверит прежнюю операцию.": "Löschen nicht bestätigt. Beim erneuten Versuch wird der vorherige Vorgang geprüft.",
  "Очищаем…": "Wird geleert …",
  "Ошибка": "Fehler",
  "Папа": "Papa",
  "Пароль": "Passwort",
  "Переименовать вариант": "Variante umbenennen",
  "Перенос ещё не подтверждён. Квитанция сохранена; проверка продолжится.": "Übertragung noch nicht bestätigt. Der Beleg wurde gespeichert; die Prüfung wird fortgesetzt.",
  "Перенос завершён, обновляем вход…": "Übertragung abgeschlossen, Anmeldung wird aktualisiert …",
  "Переносим данные в существующий STEOS ID. После переноса приложение обновит сессию. Не запускайте повторное объединение.": "Daten werden in eine bestehende STEOS ID übertragen. Nach der Übertragung aktualisiert die App die Sitzung. Starten Sie die Zusammenführung nicht erneut.",
  "Письмо отправлено": "E-Mail gesendet",
  "Питомец": "Haustier",
  "Повторить загрузку": "Erneut laden",
  "Повторить обработку": "Erneut verarbeiten",
  "Подготовить ZIP для скачивания": "ZIP zum Herunterladen vorbereiten",
  "Поддержка": "Support",
  "Подключение STEOS ID сейчас недоступно. Попробуйте позже или откройте сайт STEOS ID.": "Verbindung mit STEOS ID derzeit nicht verfügbar. Versuchen Sie es später erneut oder öffnen Sie die STEOS-ID-Website.",
  "Подключён": "Verbunden",
  "Подключён:": "Verbunden:",
  "Подруга": "Freundin",
  "Подтвердите почту": "E-Mail-Adresse bestätigen",
  "Подтвердите согласие перед отправкой образцов.": "Bestätigen Sie Ihre Zustimmung, bevor Sie Beispiele senden.",
  "Подтвердить очистку истории": "Verlauf löschen bestätigen",
  "Подтвердить удаление": "Löschen bestätigen",
  "Подтвердить удаление аккаунта": "Löschung des Kontos bestätigen",
  "Подтвердить удаление близкого": "Löschen der angehörigen Person bestätigen",
  "Подтвердить удаление варианта": "Löschen der Variante bestätigen",
  "Поиск голоса": "Stimme suchen",
  "Поиск по имени": "Nach Namen suchen",
  "Пока нет своих голосов": "Noch keine eigenen Stimmen",
  "Показать ещё": "Mehr anzeigen",
  "Показать ещё голоса": "Weitere Stimmen anzeigen",
  "Показать пароль": "Passwort anzeigen",
  "Пополнить": "Guthaben aufladen",
  "Попробовать": "Ausprobieren",
  "Портрет": "Porträt",
  "Пост": "Beitrag",
  "Потрачено Circle:": "Ausgegebenes Circle-Guthaben:",
  "Почта": "E-Mail-Adresse",
  "Почта уже занята": "E-Mail-Adresse bereits vergeben",
  "Почта уже занята, войдите с ней": "E-Mail-Adresse bereits vergeben. Melden Sie sich damit an.",
  "Привет! Это запись для моего голоса. Я говорю спокойно и в обычном темпе, как в разговоре с другом. Расскажу, как прошёл мой день, что меня порадовало и какие планы у меня на завтра. Продолжайте говорить своими словами не меньше тридцати секунд.": "Hallo! Dies ist eine Aufnahme für meine Stimme. Ich spreche ruhig und in normalem Tempo, wie bei einem Gespräch mit einem Freund. Ich erzähle, wie mein Tag verlaufen ist, worüber ich mich gefreut habe und welche Pläne ich für morgen habe. Sprechen Sie mindestens dreißig Sekunden lang mit Ihren eigenen Worten weiter.",
  "Приглашайте друзей": "Freunde einladen",
  "Пример голоса {0}": "Stimmbeispiel {0}",
  "Принимаю": "Ich stimme zu",
  "Присылать готовые работы в чат": "Fertige Werke im Chat erhalten",
  "Проверен": "Geprüft",
  "Проверить выгрузку": "Export überprüfen",
  "Проверить подтверждение": "Bestätigung überprüfen",
  "Проверка голоса не пройдена. Запишите образец без музыки и других людей.": "Stimmenprüfung fehlgeschlagen. Nehmen Sie das Beispiel ohne Musik und andere Personen auf.",
  "Проверка образцов не пройдена. Попробуйте чистую запись одного голоса.": "Beispielprüfung fehlgeschlagen. Versuchen Sie eine saubere Aufnahme mit nur einer Stimme.",
  "Проверьте адрес": "Adresse überprüfen",
  "Проверяем запись": "Aufnahme wird geprüft",
  "Проверяем образец {0} из {1}…": "Beispiel {0} von {1} wird geprüft …",
  "Проверяем состояние переноса…": "Übertragungsstatus wird geprüft …",
  "Проверяем…": "Wird geprüft …",
  "Проверяйте остаток в профиле и получайте доступные награды.": "Prüfen Sie Ihr Restguthaben im Profil und erhalten Sie verfügbare Prämien.",
  "Продолжим проверку прежнего запроса, без повторного запуска.": "Wir setzen die Prüfung der vorherigen Anfrage fort, ohne sie erneut zu starten.",
  "Продолжим сохранённый запрос с теми же данными.": "Wir setzen die gespeicherte Anfrage mit denselben Daten fort.",
  "Продолжить отправку": "Upload fortsetzen",
  "Продолжить проверку": "Prüfung fortsetzen",
  "Продолжить создание голоса": "Stimmerstellung fortsetzen",
  "Продолжить сохранение": "Speichern fortsetzen",
  "Прослушать {0}": "{0} anhören",
  "Профиль": "Profil",
  "Профиль «Вы» пока недоступен.": "Das Profil „Sie“ ist derzeit nicht verfügbar.",
  "Профиль уже изменился. Закройте форму и откройте актуальную версию.": "Das Profil wurde bereits geändert. Schließen Sie das Formular und öffnen Sie die aktuelle Version.",
  "Работ в этом списке пока нет.": "Noch keine Werke in dieser Liste.",
  "Работа №": "Werk Nr.",
  "Работы и параметры заказов исчезнут из истории. Голоса, варианты «Вы» и близкие останутся. Финансовые квитанции сохраняются. Вернуть историю нельзя.": "Werke und Auftragsdetails werden aus dem Verlauf entfernt. Stimmen, Varianten von „Sie“ und Angehörige bleiben erhalten. Finanzbelege bleiben gespeichert. Der Verlauf kann nicht wiederhergestellt werden.",
  "Работы по неделям": "Werke nach Wochen",
  "Раздел профиля": "Profilbereich",
  "Разделы профиля": "Profilbereiche",
  "Размер каждого образца должен быть от 1 байта до 20 МБ.": "Jedes Beispiel muss zwischen 1 Byte und 20 MB groß sein.",
  "Ребёнок": "Kind",
  "Результат обработки уточняется. Повторный запуск пока недоступен.": "Das Verarbeitungsergebnis wird noch ermittelt. Ein erneuter Start ist derzeit nicht verfügbar.",
  "Русский": "Русский",
  "С": "Ab",
  "Сбросить голос по умолчанию": "Standardstimme zurücksetzen",
  "Светлая": "Hell",
  "Свой аватар": "Eigenes Avatarbild",
  "Сгорят {0}, если не потратить": "Verfallen am {0}, wenn nicht ausgegeben",
  "Сделать кружок": "Videonachricht erstellen",
  "Серия:": "Serie:",
  "Сестра": "Schwester",
  "Скачать ZIP": "ZIP herunterladen",
  "Скопировать Telegram ID": "Telegram-ID kopieren",
  "Скорость речи": "Sprechgeschwindigkeit",
  "Скрыть пароль": "Passwort verbergen",
  "Слишком много запросов. Подождите немного и попробуйте ещё раз.": "Zu viele Anfragen. Warten Sie kurz und versuchen Sie es erneut.",
  "Слишком много попыток. Попробуйте позже.": "Zu viele Versuche. Versuchen Sie es später erneut.",
  "Снимайте лицо без фильтров и тёмных очков, при ровном освещении. Добавьте разные ракурсы. В кадре должен быть один человек.": "Nehmen Sie Ihr Gesicht ohne Filter oder dunkle Brille bei gleichmäßiger Beleuchtung auf. Fügen Sie verschiedene Blickwinkel hinzu. Im Bild darf nur eine Person zu sehen sein.",
  "Снять голос": "Stimme aufnehmen",
  "Снять фото": "Foto aufnehmen",
  "Согласие изменилось до начала обучения. Обновите страницу и подтвердите актуальную версию перед повторной обработкой.": "Die Zustimmung hat sich vor Trainingsbeginn geändert. Aktualisieren Sie die Seite und bestätigen Sie vor der erneuten Verarbeitung die aktuelle Version.",
  "Создавайте говорящие кружки с выбранным персонажем или своим образом.": "Erstellen Sie sprechende Rundvideos mit einer ausgewählten Figur oder Ihrem eigenen Erscheinungsbild.",
  "Создание": "Erstellung",
  "Создание голосов временно недоступно. Образцы сохранены в этом окне.": "Die Stimmerstellung ist vorübergehend nicht verfügbar. Die Beispiele wurden in diesem Fenster gespeichert.",
  "Создание новых голосов пока недоступно. Уже созданные голоса доступны ниже.": "Das Erstellen neuer Stimmen ist derzeit nicht verfügbar. Bereits erstellte Stimmen sind unten verfügbar.",
  "Создано:": "Erstellt:",
  "Создан {0}": "Erstellt am {0}",
  "Создать аккаунт": "Konto erstellen",
  "Создать голос": "Stimme erstellen",
  "Создаём голос…": "Stimme wird erstellt …",
  "Сохранение настроек создания сейчас выключено.": "Speichern der Erstellungseinstellungen ist derzeit deaktiviert.",
  "Сохранение не подтверждено. Закройте форму и проверьте актуальный профиль.": "Speichern nicht bestätigt. Schließen Sie das Formular und prüfen Sie das aktuelle Profil.",
  "Сохранение не подтверждено. Повтор создания использует прежний запрос.": "Speichern nicht bestätigt. Bei einem erneuten Erstellungsversuch wird dieselbe Anfrage verwendet.",
  "Сохранение недоступно.": "Speichern nicht verfügbar.",
  "Сохранено": "Gespeichert",
  "Сохранить": "Speichern",
  "Сохранить близкого": "Angehörige Person speichern",
  "Сохранить вариант": "Variante speichern",
  "Сохранить голос по умолчанию": "Standardstimme speichern",
  "Сохранить мои фото": "Meine Fotos speichern",
  "Сохранить образцы": "Beispiele speichern",
  "Сохраняем образцы…": "Beispiele werden gespeichert …",
  "Сохраняем…": "Wird gespeichert …",
  "Сохранённые варианты себя доступны в профиле и инструментах создания.": "Gespeicherte Varianten von Ihnen sind im Profil und in den Erstellungstools verfügbar.",
  "Сохранённых вариантов пока нет.": "Noch keine Varianten gespeichert.",
  "Сроки партий Circle временно недоступны": "Ablaufzeiten der Circle-Pakete vorübergehend nicht verfügbar",
  "Старший": "Älter",
  "Статистика": "Statistik",
  "Статистика по неделям временно недоступна.": "Wöchentliche Statistik vorübergehend nicht verfügbar.",
  "Статус удаления временно недоступен. Квитанция сохранена в этой вкладке.": "Löschstatus vorübergehend nicht verfügbar. Der Beleg wurde in diesem Tab gespeichert.",
  "Сторис": "Storys",
  "Сын": "Sohn",
  "Тариф": "Tarif",
  "Текст для чтения": "Vorlesetext",
  "Тема": "Design",
  "Тема сохраняется на этом устройстве.": "Das Design wird auf diesem Gerät gespeichert.",
  "Тёмная": "Dunkel",
  "У меня есть право использовать эти фотографии и согласие изображённых людей.": "Ich bin berechtigt, diese Fotos zu verwenden, und habe die Zustimmung der abgebildeten Personen.",
  "УДАЛИТЬ": "УДАЛИТЬ",
  "Убираем шум": "Rauschen wird entfernt",
  "Убрать": "Entfernen",
  "Убрать {0}": "{0} entfernen",
  "Убрать из избранного": "Aus Favoriten entfernen",
  "Убрать фоновый шум": "Hintergrundgeräusche entfernen",
  "Убрать фото": "Foto entfernen",
  "Уведомления": "Benachrichtigungen",
  "Уведомления недоступны.": "Benachrichtigungen nicht verfügbar.",
  "Уведомления пока недоступны.": "Benachrichtigungen derzeit nicht verfügbar.",
  "Удаление аккаунта Mini App": "Mini-App-Konto löschen",
  "Удаление:": "Löschen:",
  "Удалить": "Löschen",
  "Удалить «": "„ entfernen",
  "Удалить «{0}»?": "„{0}“ löschen?",
  "Удалить аккаунт Mini App": "Mini-App-Konto löschen",
  "Удалить близкого": "Angehörige Person löschen",
  "Удалить вариант": "Variante löschen",
  "Удалить голос": "Stimme löschen",
  "Удаляем…": "Wird gelöscht …",
  "Удаляется": "Wird gelöscht",
  "Українська": "Українська",
  "Условия использования": "Nutzungsbedingungen",
  "Файл": "Datei",
  "Формат": "Format",
  "Фото Telegram": "Telegram-Foto",
  "Фото {0}": "Foto {0}",
  "Фото и имя берутся из вашего профиля в Telegram. Если вы их сменили, обновите данные здесь.": "Foto und Name stammen aus Ihrem Telegram-Profil. Wenn Sie sie geändert haben, aktualisieren Sie die Daten hier.",
  "Фото и фотосессия": "Foto und Fotoshooting",
  "Фото перед загрузкой": "Foto vor dem Hochladen",
  "Фото профиля": "Profilfoto",
  "Фото профиля Telegram": "Telegram-Profilfoto",
  "Фото, голоса, близкие и данные Mini App будут удалены во всех сервисах. STEOS ID и финансовые квитанции останутся. Отменить удаление нельзя.": "Fotos, Stimmen, Angehörige und Mini-App-Daten werden in allen Diensten gelöscht. STEOS ID und Finanzbelege bleiben erhalten. Das Löschen kann nicht rückgängig gemacht werden.",
  "Фото:": "Foto:",
  "Часть профиля временно недоступна. Попробуйте обновить.": "Ein Teil des Profils ist vorübergehend nicht verfügbar. Versuchen Sie, es zu aktualisieren.",
  "Читаем аудиофайлы…": "Audiodateien werden gelesen …",
  "Что нового": "Was ist neu?",
  "Что нового пока не опубликовано или временно недоступно.": "Es wurden noch keine Neuigkeiten veröffentlicht oder sie sind vorübergehend nicht verfügbar.",
  "Что нового пока не опубликовано.": "Es wurden noch keine Neuigkeiten veröffentlicht.",
  "Шаблоны": "Vorlagen",
  "Шаблоны и рилс": "Vorlagen und Reels",
  "Эта неделя": "Diese Woche",
  "Этот голос используется:": "Diese Stimme wird verwendet:",
  "Этот запуск пока нельзя повторить. Обновите статус голоса.": "Dieser Vorgang kann derzeit nicht wiederholt werden. Aktualisieren Sie den Stimmenstatus.",
  "Этот формат не поддерживается. Выберите MP3, WAV, M4A, OGG или WebM.": "Dieses Format wird nicht unterstützt. Wählen Sie MP3, WAV, M4A, OGG oder WebM.",
  "Язык аккаунта": "Kontosprache",
  "готова": "fertig",
  "готова частично": "teilweise fertig",
  "дата недоступна": "Datum nicht verfügbar",
  "для переозвучки": "zur erneuten Vertonung",
  "до {0}, потом {1}": "bis {0}, danach {1}",
  "другой тариф": "anderer Tarif",
  "закончится {0}": "endet am {0}",
  "и": "und",
  "из": "von",
  "из 1:30 · минимум 0:02": "von 1:30 · mindestens 0:02",
  "лимит уточняется": "Limit wird noch ermittelt",
  "не задан": "nicht festgelegt",
  "не назначен": "nicht zugewiesen",
  "новых": "neue",
  "образец": "Beispiel",
  "образца": "Beispiels",
  "образцов": "Beispiele",
  "оплачено до {0}": "bezahlt bis {0}",
  "подарок до {0}": "Geschenk bis {0}",
  "пока недоступно": "derzeit nicht verfügbar",
  "политику конфиденциальности STEOS": "STEOS-Datenschutzerklärung",
  "продлится {0}": "verlängert sich am {0}",
  "речи.": "Sprache.",
  "токенов": "Token",
  "условия": "Bedingungen",
  "уточняется": "wird noch ermittelt",
  "Қазақша": "Қазақша",
  "← Профиль": "← Profil",
  "▶ Прослушать": "▶ Anhören",
  "Озвучка": "Voiceover",
  "Клон": "Klon",
  "Студия": "Studio",
  "Баланс": "Guthaben",
  "История": "Verlauf",
  "Ещё": "Mehr",
  "Клонирование голоса": "Stimme klonen",
  "Партнёрство": "Partnerschaft",
  "Добавить в чат": "Zum Chat hinzufügen",
  "Разделы": "Bereiche",
  "Главное меню": "Hauptmenü",
  "Выберите": "Auswählen",
  "После объединения сохранены все фото. Оставьте до пяти, чтобы изменить образ.": "Nach der Zusammenführung wurden alle Fotos behalten. Behalte bis zu fünf, um dein Erscheinungsbild zu ändern.",
  "Абзацы": "Absätze",
  "Альбом": "Album",
  "Аудио": "Audio",
  "Без изменения": "Keine Änderung",
  "Бесплатно по текущему тестовому dev-тарифу.": "Kostenlos gemäß dem aktuellen Dev-Testtarif.",
  "Бесплатно по тестовому dev-тарифу": "Kostenlos gemäß dem Dev-Testtarif",
  "В избранном пока пусто": "Noch nichts in den Favoriten",
  "В очереди": "In der Warteschlange",
  "Вариант {0}": "Variante {0}",
  "Введите текст до 1000 символов": "Text mit bis zu 1000 Zeichen eingeben",
  "Вернули": "Erstattet",
  "Вернуть запись в историю не получится. Файл в чате останется.": "Der Eintrag kann nicht wieder in den Verlauf aufgenommen werden. Die Datei bleibt im Chat erhalten.",
  "Видео": "Video",
  "Виды работ": "Arbeitsarten",
  "Все": "Alle",
  "Вчера": "Gestern",
  "Выбранный вариант": "Ausgewählte Variante",
  "Выбранный вариант недоступен. Вернитесь в профиль и обновите список.": "Die ausgewählte Variante ist nicht verfügbar. Kehren Sie zum Profil zurück und aktualisieren Sie die Liste.",
  "Выполняется": "Wird ausgeführt",
  "Высота голоса": "Stimmhöhe",
  "Говорящее видео": "Sprechendes Video",
  "Голоса": "Stimmen",
  "Дата неизвестна": "Datum unbekannt",
  "Длительность": "Dauer",
  "Для этого действия пока нет доступного опубликованного инструмента.": "Für diese Aktion ist derzeit kein veröffentlichtes Tool verfügbar.",
  "Дополнительное поле": "Zusätzliches Feld",
  "Заголовок": "Überschrift",
  "Загружаем историю…": "Verlauf wird geladen…",
  "Загружаем работу…": "Arbeit wird geladen…",
  "Загружаем результат…": "Ergebnis wird geladen…",
  "Загружаем…": "Wird geladen…",
  "Загружено": "Hochgeladen",
  "Загрузка не подтверждена. Продолжите проверку этого файла.": "Der Upload wurde nicht bestätigt. Fahre mit der Überprüfung dieser Datei fort.",
  "Заказ": "Auftrag",
  "Заказ не подтверждён. Продолжение проверит прежний запрос с тем же ключом.": "Der Auftrag wurde nicht bestätigt. Beim Fortfahren wird die vorherige Anfrage mit demselben Schlüssel überprüft.",
  "Заменить файл": "Datei ersetzen",
  "Избранное: {0}": "Favoriten: {0}",
  "Инструмент обновляется. Обновите форму позже.": "Das Tool wird aktualisiert. Aktualisiere das Formular später.",
  "Искать в {0} работах": "In {0} Arbeiten suchen",
  "Искать в истории": "Im Verlauf suchen",
  "Использовать фото выбранного варианта": "Foto der ausgewählten Variante verwenden",
  "Используется выбранный голос.": "Die ausgewählte Stimme wird verwendet.",
  "Исход генерации уточняется. Новая работа автоматически не запускается.": "Der Ausgang der Generierung wird noch geklärt. Es wird nicht automatisch eine neue Arbeit gestartet.",
  "К инструментам": "Zu den Tools",
  "Кавер": "Coverversion",
  "Карусель": "Karussell",
  "Ключевые слова": "Schlüsselwörter",
  "Коллаж": "Collage",
  "Кратко": "Kurz",
  "Кружки": "Videonachrichten",
  "Кружок": "Videonachricht",
  "Кто в кадре": "Wer ist im Bild",
  "Название": "Name",
  "Не получилось": "Fehlgeschlagen",
  "Не удалось выполнить": "Aktion fehlgeschlagen",
  "Не удалось выполнить действие с этой работой. Обновите её и попробуйте снова.": "Die Aktion für diese Arbeit konnte nicht ausgeführt werden. Aktualisiere sie und versuche es erneut.",
  "Не удалось завершить создание. Попробуйте изменить настройки.": "Die Erstellung konnte nicht abgeschlossen werden. Ändere die Einstellungen und versuche es erneut.",
  "Не удалось загрузить историю. Попробуйте ещё раз.": "Der Verlauf konnte nicht geladen werden. Versuche es erneut.",
  "Не удалось загрузить студию.": "Das Studio konnte nicht geladen werden.",
  "Не удалось загрузить фото варианта. Обновите профиль.": "Das Foto der Variante konnte nicht geladen werden. Aktualisiere das Profil.",
  "Не удалось обработать запись": "Aufnahme konnte nicht verarbeitet werden",
  "Не удалось озвучить текст": "Text konnte nicht vertont werden",
  "Не удалось открыть инструмент. Попробуйте обновить.": "Das Tool konnte nicht geöffnet werden. Versuche, es zu aktualisieren.",
  "Не удалось открыть результат. Попробуйте снова.": "Das Ergebnis konnte nicht geöffnet werden. Versuche es erneut.",
  "Не удалось отправить результат. Повторите отправку.": "Das Ergebnis konnte nicht gesendet werden. Sende es erneut.",
  "Не удалось связаться с сервисом. Попробуйте ещё раз.": "Verbindung zum Dienst fehlgeschlagen. Versuche es erneut.",
  "Не удалось скопировать. Выделите текст вручную.": "Kopieren fehlgeschlagen. Markiere den Text manuell.",
  "Не удалось сохранить отправку. Разрешите хранилище вкладки и попробуйте ещё раз.": "Senden konnte nicht gespeichert werden. Erlaube den Speicherzugriff für den Tab und versuche es erneut.",
  "Некоторые файлы повтора больше недоступны. Загрузите их заново.": "Einige Dateien der Wiederholung sind nicht mehr verfügbar. Lade sie erneut hoch.",
  "Ничего не нашли": "Keine Ergebnisse gefunden",
  "Нужно разных фото": "Es werden unterschiedliche Fotos benötigt",
  "Обрабатываем запись": "Aufnahme wird verarbeitet",
  "Озвучиваем текст": "Text wird vertont",
  "Озвучить": "Vertonen",
  "Озвучка готова": "Vertonung fertig",
  "Озвучка проекта": "Projektvertonung",
  "Оплата": "Zahlung",
  "Оплачено донатом": "Mit einer Spende bezahlt",
  "Определить автоматически": "Automatisch erkennen",
  "Основа": "Basis",
  "Открыть результат": "Ergebnis öffnen",
  "Отменено": "Storniert",
  "Отправить в чат": "An Chat senden",
  "Отправка не принята. Проверьте сообщение об ошибке.": "Die Sendung wurde nicht angenommen. Prüfe die Fehlermeldung.",
  "Отправка принята. Бот доставит результат в чат.": "Die Sendung wurde angenommen. Der Bot liefert das Ergebnis im Chat aus.",
  "Отправлено": "Gesendet",
  "Переозвучить запись": "Aufnahme neu vertonen",
  "Переозвучка": "Neuvertonung",
  "Персонаж": "Figur",
  "Площадка": "Plattform",
  "Повтори движения": "Bewegungen nachahmen",
  "Повторить": "Wiederholen",
  "Подпись": "Beschriftung",
  "Подтверждаю право использовать загружаемые материалы": "Ich bestätige, dass ich die Rechte zur Nutzung der hochgeladenen Materialien habe",
  "Подтверждаю право использовать эти фото и согласие изображённых людей на создание варианта": "Ich bestätige, dass ich die Rechte zur Nutzung dieser Fotos habe und die abgebildeten Personen der Erstellung einer Variante zugestimmt haben",
  "Поиск в истории": "Im Verlauf suchen",
  "Показатели истории": "Verlaufsstatistiken",
  "Показатели истории временно недоступны": "Verlaufsstatistiken vorübergehend nicht verfügbar",
  "Показать все работы": "Alle Arbeiten anzeigen",
  "Показать текст": "Text anzeigen",
  "Порядок": "Reihenfolge",
  "Почистить запись": "Aufnahme bereinigen",
  "Прежний голос недоступен. Выберите другой голос.": "Die vorherige Stimme ist nicht verfügbar. Wähle eine andere Stimme.",
  "Преимущества": "Vorteile",
  "Проверьте заполненные поля. Заказ не создан.": "Überprüfe die ausgefüllten Felder. Der Auftrag wurde nicht erstellt.",
  "Проверяем итог операции": "Ergebnis des Vorgangs wird überprüft",
  "Проверяем отправку…": "Sendung wird überprüft…",
  "Проверяем результат": "Ergebnis wird überprüft",
  "Проверяем списание токенов": "Token-Abbuchung wird überprüft",
  "Продолжить проверку озвучки": "Überprüfung der Vertonung fortsetzen",
  "Работ пока нет": "Noch keine Arbeiten",
  "Работ: {0}": "Arbeiten: {0}",
  "Работа": "Arbeit",
  "Работа больше не найдена. Обновите историю.": "Arbeit nicht mehr gefunden. Aktualisiere den Verlauf.",
  "Работа из истории": "Arbeit aus dem Verlauf",
  "Работа не прошла проверку.": "Die Arbeit hat die Prüfung nicht bestanden.",
  "Работа обновилась. Загрузите её ещё раз.": "Die Arbeit wurde aktualisiert. Lade sie erneut.",
  "Распознавание": "Erkennung",
  "Распознанный текст": "Erkannter Text",
  "Распознать речь": "Sprache erkennen",
  "Расшифровка": "Transkription",
  "Режим озвучки": "Vertonungsmodus",
  "Результат": "Ergebnis",
  "Результат больше недоступен": "Ergebnis nicht mehr verfügbar",
  "Результат операции уточняется. Повторный запуск отключён.": "Der Ausgang des Vorgangs wird noch geklärt. Ein erneuter Start ist deaktiviert.",
  "Результат отправки пока неизвестен. Повторите проверку.": "Der Sendestatus ist noch unbekannt. Überprüfe ihn erneut.",
  "Результат отправки пока неизвестен. Повторите с тем же ключом.": "Der Sendestatus ist noch unbekannt. Überprüfe ihn erneut mit demselben Schlüssel.",
  "Результат переозвучки": "Ergebnis der Neuvertonung",
  "Результат работы": "Arbeitsergebnis",
  "Реплики": "Sprechbeiträge",
  "Речевая запись": "Sprachaufnahme",
  "Рилс": "Reel",
  "Сегодня": "Heute",
  "Сейчас создаётся": "Wird gerade erstellt",
  "Сервис сейчас недоступен.": "Der Dienst ist derzeit nicht verfügbar.",
  "Сессия истекла. Откройте приложение заново.": "Sitzung abgelaufen. Öffne die App erneut.",
  "Синтез": "Synthese",
  "Скачать": "Herunterladen",
  "Скачать все файлы": "Alle Dateien herunterladen",
  "Скачать набор": "Paket herunterladen",
  "Скопировано": "Kopiert",
  "Скопировать": "Kopieren",
  "Слайды": "Folien",
  "Слишком много запросов. Подождите немного.": "Zu viele Anfragen. Warte einen Moment.",
  "Слушать результат": "Ergebnis anhören",
  "Смена голоса": "Stimmenwechsel",
  "Сначала новые": "Neueste zuerst",
  "Сначала старые": "Älteste zuerst",
  "Создать": "Erstellen",
  "Создаётся": "Wird erstellt",
  "Списано": "Abgebucht",
  "Статус пока не подтверждён. Проверяем прежний заказ.": "Der Status ist noch nicht bestätigt. Der vorherige Auftrag wird überprüft.",
  "Статус текущих заказов временно недоступен": "Status der aktuellen Aufträge vorübergehend nicht verfügbar",
  "Стиль": "Stil",
  "Стоимость": "Kosten",
  "Сцена": "Szene",
  "Съёмка": "Fotoshooting",
  "Текст": "Text",
  "Текст для озвучки": "Text für die Vertonung",
  "Текст песни": "Songtext",
  "Текст поста": "Beitragstext",
  "Товар": "Produkt",
  "Удалить из истории": "Aus dem Verlauf löschen",
  "Удалить из истории?": "Aus dem Verlauf löschen?",
  "Уточняем результат": "Ergebnis wird geklärt",
  "Уточняем состояние сохранённого заказа…": "Status des gespeicherten Auftrags wird geklärt…",
  "Файл в чате останется": "Die Datei bleibt im Chat erhalten",
  "Файлов: {0}": "Dateien: {0}",
  "Форма недоступна.": "Formular nicht verfügbar.",
  "Формат отправки": "Sendeformat",
  "Фото": "Foto",
  "Фотосессии": "Fotoshootings",
  "Фотосессия": "Fotoshooting",
  "Фотосессия товара": "Produktfotoshooting",
  "Части": "Teile",
  "Шаблон": "Vorlage",
  "Эта работа недоступна вашему аккаунту.": "Diese Arbeit ist für dein Konto nicht verfügbar.",
  "Это вся история": "Das ist der gesamte Verlauf",
  "Этот инструмент сейчас недоступен. Попробуйте обновить форму.": "Dieses Tool ist derzeit nicht verfügbar. Versuche, das Formular zu aktualisieren.",
  "Язык записи": "Sprache der Aufnahme",
  "MP3 · пауза между репликами 0,6 с": "MP3 · Pause zwischen den Sprechbeiträgen 0,6 s",
  "{0} / 1 000 знаков": "{0} / 1.000 Zeichen",
  "{0} / 20 000 знаков · версия {1}": "{0} / 20.000 Zeichen · Version {1}",
  "{0} реплик": "{0} Sprechbeiträge",
  "{0} ролей · {1} новых реплик": "{0} Rollen · {1} neue Sprechbeiträge",
  "Аудио больше недоступно. Обновите статус проекта.": "Audio nicht mehr verfügbar. Aktualisieren Sie den Projektstatus.",
  "Буфер недоступен. Вставьте текст в поле вручную.": "Zwischenablage nicht verfügbar. Fügen Sie den Text manuell in das Feld ein.",
  "В проекте должно быть от 1 до 50 ролей.": "Das Projekt muss zwischen 1 und 50 Rollen enthalten.",
  "В проекте может быть не больше 500 реплик.": "Das Projekt darf höchstens 500 Sprechbeiträge enthalten.",
  "Вставить из буфера": "Aus Zwischenablage einfügen",
  "Вставить сценарий": "Skript einfügen",
  "Выберите голос для каждой непустой роли.": "Wählen Sie für jede nicht leere Rolle eine Stimme aus.",
  "Выше": "Nach oben",
  "Голос {0}": "Stimme {0}",
  "Голос роли": "Rollenstimme",
  "Готовим аудио…": "Audio wird vorbereitet…",
  "Добавить {0} реплик": "{0} Sprechbeiträge hinzufügen",
  "Добавьте реплику или вставьте сценарий.": "Fügen Sie einen Sprechbeitrag hinzu oder fügen Sie ein Skript ein.",
  "Дождитесь загрузки общего файла и попробуйте ещё раз.": "Warten Sie, bis die gemeinsame Datei geladen ist, und versuchen Sie es erneut.",
  "Дублировать": "Duplizieren",
  "Загружаем аудио…": "Audio wird geladen…",
  "Загружаем проекты…": "Projekte werden geladen…",
  "Загрузить версию сервера": "Serverversion laden",
  "Закрыть раздел без сохранения изменений?": "Abschnitt ohne Speichern der Änderungen schließen?",
  "Заменить текущие роли и реплики?": "Aktuelle Rollen und Sprechbeiträge ersetzen?",
  "Заменить текущий сценарий": "Aktuelles Skript ersetzen",
  "Изменить сценарий": "Skript bearbeiten",
  "Имя роли": "Rollenname",
  "Кто говорит": "Wer spricht",
  "Мои проекты": "Meine Projekte",
  "Нажмите воспроизведение в плеере, чтобы разрешить звук.": "Klicken Sie im Player auf Wiedergabe, um den Ton zu aktivieren.",
  "Название проекта": "Projektname",
  "Название слишком длинное.": "Der Name ist zu lang.",
  "Не удалось восстановить операции. Не запускайте озвучку повторно; проверьте историю.": "Vorgänge konnten nicht wiederhergestellt werden. Starten Sie die Sprachgenerierung nicht erneut; überprüfen Sie den Verlauf.",
  "Не удалось выполнить действие. Изменения остаются на экране.": "Aktion fehlgeschlagen. Die Änderungen bleiben auf dem Bildschirm erhalten.",
  "Не удалось загрузить аудио. Проверьте соединение и попробуйте ещё раз.": "Audio konnte nicht geladen werden. Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
  "Не удалось озвучить проект": "Projekt konnte nicht vertont werden",
  "Не удалось подготовить аудио. Проверьте реплику и выбранный голос.": "Audio konnte nicht vorbereitet werden. Überprüfen Sie den Sprechbeitrag und die ausgewählte Stimme.",
  "Не удалось проверить владельца проекта. Обновите страницу.": "Der Projekteigentümer konnte nicht überprüft werden. Aktualisieren Sie die Seite.",
  "Не удалось связаться с сервером. Проверьте соединение и повторите попытку.": "Verbindung zum Server fehlgeschlagen. Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
  "Не хватает Circle. Пополните баланс и повторите действие.": "Nicht genügend Circle. Laden Sie Ihr Guthaben auf und wiederholen Sie die Aktion.",
  "Ниже": "Nach unten",
  "Новый дубль реплики": "Neue Version des Sprechbeitrags",
  "Общий файл · MP3": "Gemeinsame Datei · MP3",
  "Один из голосов больше недоступен. Выберите другой голос.": "Eine der Stimmen ist nicht mehr verfügbar. Wählen Sie eine andere Stimme.",
  "Озвучено реплик: {0} из {1}": "Vertonte Sprechbeiträge: {0} von {1}",
  "Озвучиваем проект": "Projekt wird vertont",
  "Озвучить · {0} Circle": "Vertonen · {0} Circle",
  "Озвучить проект": "Projekt vertonen",
  "Озвучка проектов": "Skript-Vertonung",
  "Озвучка уже выполняется. Дождитесь результата.": "Die Vertonung läuft bereits. Warten Sie auf das Ergebnis.",
  "Операция уже принята или её исход неизвестен. Проверьте прежний запрос.": "Der Vorgang wurde bereits angenommen oder sein Status ist unbekannt. Überprüfen Sie die vorherige Anfrage.",
  "Отбросить локальные изменения и загрузить версию сервера?": "Lokale Änderungen verwerfen und die Serverversion laden?",
  "Открыть в истории": "Im Verlauf öffnen",
  "Отменить изменения": "Änderungen rückgängig machen",
  "Отменить несохранённые изменения?": "Nicht gespeicherte Änderungen verwerfen?",
  "Перед озвучкой дождитесь сохранения изменений.": "Warten Sie vor der Vertonung, bis die Änderungen gespeichert sind.",
  "Переозвучить": "Erneut vertonen",
  "Переозвучить реплику": "Sprechbeitrag erneut vertonen",
  "Повторить проверку": "Prüfung wiederholen",
  "Подтвердить и запустить": "Bestätigen und starten",
  "Подтверждение озвучки": "Vertonung bestätigen",
  "Проверить прежний запрос": "Vorherige Anfrage überprüfen",
  "Проверить статус": "Status überprüfen",
  "Проверьте роли, голоса и длину реплик.": "Überprüfen Sie Rollen, Stimmen und Länge der Sprechbeiträge.",
  "Проект больше недоступен.": "Projekt nicht mehr verfügbar.",
  "Проект длиннее 20 000 знаков.": "Das Projekt überschreitet 20.000 Zeichen.",
  "Проект изменился в другом окне. Сравните свою версию и загрузите свежую.": "Das Projekt wurde in einem anderen Fenster geändert. Vergleichen Sie Ihre Version und laden Sie die aktuelle Version.",
  "Проект изменился. Сохраните его и проверьте цену ещё раз.": "Das Projekt wurde geändert. Speichern Sie es und überprüfen Sie den Preis erneut.",
  "Проект или результат больше недоступен.": "Projekt oder Ergebnis nicht mehr verfügbar.",
  "Проект озвучен": "Projekt vertont",
  "Проекты {0}": "Projekte {0}",
  "Прослушать": "Anhören",
  "Прослушать реплику": "Sprechbeitrag anhören",
  "Прослушать текущую версию": "Aktuelle Version anhören",
  "Прослушивание в очереди": "Wiedergabe in der Warteschlange",
  "Прослушивание реплики": "Sprechbeitrag wird angehört",
  "Результат изменился. Загрузите его актуальную версию.": "Das Ergebnis wurde geändert. Laden Sie die aktuelle Version.",
  "Результат озвучки проекта": "Ergebnis der Projektvertonung",
  "Результат уточняется. Повторная генерация автоматически не запускается.": "Das Ergebnis wird noch ermittelt. Eine erneute Generierung wird nicht automatisch gestartet.",
  "Реплика {0}": "Sprechbeitrag {0}",
  "Реплика длиннее 1 000 знаков.": "Der Sprechbeitrag überschreitet 1.000 Zeichen.",
  "Реплики · {0}": "Sprechbeiträge · {0}",
  "Реплику {0} выше": "Sprechbeitrag {0} nach oben",
  "Реплику {0} ниже": "Sprechbeitrag {0} nach unten",
  "Роли и голоса": "Rollen und Stimmen",
  "Роль {0}": "Rolle {0}",
  "Роль реплики": "Rolle des Sprechbeitrags",
  "Скачать MP3": "MP3 herunterladen",
  "Слишком много запросов. Подождите и повторите проверку.": "Zu viele Anfragen. Warten Sie kurz und versuchen Sie die Überprüfung erneut.",
  "Создайте проект, затем вставьте сценарий или добавьте роли и реплики.": "Erstellen Sie ein Projekt und fügen Sie anschließend ein Skript ein oder fügen Sie Rollen und Sprechbeiträge hinzu.",
  "Стоимость подтверждена сервером. Повторная проверка этого же запроса не создаёт нового списания.": "Die Kosten wurden vom Server bestätigt. Eine erneute Prüfung derselben Anfrage führt nicht zu einer weiteren Abbuchung.",
  "Стоимость: {0} Circle": "Kosten: {0} Circle",
  "Строки «Имя: реплика» станут ролями и репликами. Таймкоды можно оставить.": "Zeilen im Format „Name: Sprechbeitrag“ werden zu Rollen und Sprechbeiträgen. Zeitstempel können beibehalten werden.",
  "Сценарий": "Skript",
  "Сценарий изменился. Эта дорожка относится к предыдущей версии проекта.": "Das Skript wurde geändert. Diese Tonspur gehört zu einer früheren Projektversion.",
  "Сценарий по ролям — каждая роль звучит своим голосом.": "Rollenskript — jede Rolle spricht mit ihrer eigenen Stimme.",
  "Текст или голос изменились. Для текущей версии нужно новое прослушивание.": "Text oder Stimme wurden geändert. Für die aktuelle Version ist eine neue Hörprobe erforderlich.",
  "Текст реплики": "Text des Sprechbeitrags",
  "Удалить проект": "Projekt löschen",
  "Удалить реплику {0}": "Sprechbeitrag {0} löschen",
  "Удалить реплику?": "Sprechbeitrag löschen?",
  "Удалить роль {0}": "Rolle {0} löschen",
  "Удалить роль «{0}» вместе с её репликами ({1})?": "Rolle „{0}“ einschließlich ihrer Sprechbeiträge ({1}) löschen?",
  "Удалить этот проект?": "Dieses Projekt löschen?",
  "Укажите имя каждой роли.": "Geben Sie für jede Rolle einen Namen an.",
  "Уточняем результат озвучки": "Ergebnis der Vertonung wird ermittelt",
  "Цена изменилась. Проверьте новую цену перед запуском.": "Der Preis hat sich geändert. Überprüfen Sie den neuen Preis vor dem Start.",
  "есть несохранённые изменения": "nicht gespeicherte Änderungen vorhanden",
  "сохранено": "gespeichert",
  "＋ Новый проект": "＋ Neues Projekt",
  "＋ Реплика": "＋ Sprechbeitrag",
  "＋ Роль": "＋ Rolle",
  "Circle из пакетов без срока действия.": "Circle aus Paketen ohne Ablaufdatum.",
  "Circle каждый месяц": "Circle jeden Monat",
  "Circle приходят каждые {0} дней, первая партия — сразу.": "Circle werden alle {0} Tage gutgeschrieben, die erste Charge sofort.",
  "Circle этой партии действуют до {0}": "Diese Circle-Charge ist gültig bis {0}",
  "{0} Circle каждый месяц": "{0} Circle jeden Monat",
  "{0} Circle каждый месяц · до {1} своих голосов": "{0} Circle jeden Monat · bis zu {1} eigene Stimmen",
  "{0} мес.": "{0} Mon.",
  "Баланс и профиль": "Guthaben und Profil",
  "В текущем месяце осталось {0} из {1} Circle": "Im aktuellen Monat sind noch {0} von {1} Circle übrig",
  "Ваш текущий тариф": "Ihr aktueller Tarif",
  "Включить тестовое продление": "Testverlängerung aktivieren",
  "Выбор тарифа": "Tarif auswählen",
  "Действует до {0}": "Gültig bis {0}",
  "Для этой подписки продление пока недоступно.": "Eine Verlängerung ist für dieses Abonnement derzeit nicht verfügbar.",
  "До {0} своих голосов": "Bis zu {0} eigene Stimmen",
  "До {0} сохраняется текущий тариф.": "Der aktuelle Tarif bleibt bis {0} bestehen.",
  "Докупить Circle": "Circle nachkaufen",
  "Доступные сроки": "Verfügbare Laufzeiten",
  "Загружаем подписку…": "Abonnement wird geladen…",
  "Запланировать переход": "Tarifwechsel planen",
  "Запрос не совпадает с сохранённой операцией. Не повторяйте покупку; обратитесь в поддержку.": "Die Anfrage stimmt nicht mit dem gespeicherten Vorgang überein. Wiederholen Sie den Kauf nicht und wenden Sie sich an den Support.",
  "Исход прежнего запроса нужно проверить. Новая покупка пока заблокирована.": "Der Status der vorherigen Anfrage muss überprüft werden. Ein neuer Kauf ist vorerst gesperrt.",
  "Начислить {0} тестовых Circle": "{0} Test-Circle gutschreiben",
  "Не удалось восстановить операцию. Проверьте подписку перед новой покупкой.": "Der Vorgang konnte nicht wiederhergestellt werden. Überprüfen Sie das Abonnement vor einem erneuten Kauf.",
  "Операция подтверждена. Обновите данные; повторять покупку не нужно.": "Vorgang bestätigt. Aktualisieren Sie die Daten; ein erneuter Kauf ist nicht erforderlich.",
  "Оставить текущий тариф": "Aktuellen Tarif beibehalten",
  "Отмена продления сохраняет тариф и лимиты до конца оплаченного срока.": "Durch die Kündigung der Verlängerung bleiben Tarif und Limits bis zum Ende des bezahlten Zeitraums erhalten.",
  "Отменить продление": "Verlängerung kündigen",
  "Оформить dev-подписку": "Dev-Abonnement abschließen",
  "Пакет Circle начислен.": "Circle-Paket gutgeschrieben.",
  "Пакеты Circle доступны с активной подпиской.": "Circle-Pakete sind mit einem aktiven Abonnement verfügbar.",
  "Перейти на выбранный тариф": "Zum ausgewählten Tarif wechseln",
  "Переход начнётся после окончания текущей подписки. Сейчас оплата не требуется.": "Der Wechsel beginnt nach Ablauf des aktuellen Abonnements. Jetzt ist keine Zahlung erforderlich.",
  "Подписка": "Abonnement",
  "Подписка временно недоступна. Попробуйте обновить данные.": "Abonnement vorübergehend nicht verfügbar. Versuchen Sie, die Daten zu aktualisieren.",
  "Подписка не продлится": "Das Abonnement wird nicht verlängert",
  "Подписка обновлена.": "Abonnement aktualisiert.",
  "Подписка уже активна. Обновите данные и выберите доступное действие.": "Das Abonnement ist bereits aktiv. Aktualisieren Sie die Daten und wählen Sie eine verfügbare Aktion.",
  "Подписка уже закончилась. Обновите данные.": "Das Abonnement ist bereits abgelaufen. Aktualisieren Sie die Daten.",
  "Подтвердить": "Bestätigen",
  "Подтверждение подписки": "Abonnement bestätigen",
  "Покупка сейчас недоступна. Реальные платежи не включены.": "Der Kauf ist derzeit nicht verfügbar. Echte Zahlungen sind nicht aktiviert.",
  "Получить dev-пакет бесплатно": "Kostenloses Dev-Paket erhalten",
  "Потом: {0}": "Danach: {0}",
  "Предыдущая подписка закончилась {0}": "Das vorherige Abonnement ist am {0} abgelaufen",
  "При продлении оплаченного срока новая партия придёт в следующем периоде.": "Bei Verlängerung des bezahlten Zeitraums wird die nächste Charge im folgenden Zeitraum gutgeschrieben.",
  "Проверка операции": "Vorgang überprüfen",
  "Продление включено": "Verlängerung aktiviert",
  "Продлить подписку": "Abonnement verlängern",
  "Свои голоса": "Eigene Stimmen",
  "Свои голоса: {0} из {1}": "Eigene Stimmen: {0} von {1}",
  "Сравнить тарифы": "Tarife vergleichen",
  "Срок": "Laufzeit",
  "Срок подписки": "Abonnementlaufzeit",
  "Срок: {0} мес.": "Laufzeit: {0} Mon.",
  "Тариф останется до конца срока. Следующего продления не будет.": "Der Tarif bleibt bis zum Ende der Laufzeit bestehen. Es erfolgt keine weitere Verlängerung.",
  "Тарифы пока недоступны. Попробуйте обновить данные позже.": "Tarife sind derzeit nicht verfügbar. Versuchen Sie später, die Daten zu aktualisieren.",
  "Текущий тариф": "Aktueller Tarif",
  "Тестовый dev-каталог. Реальных платежей нет; начисляются тестовые Circle.": "Test-Dev-Katalog. Keine echten Zahlungen; es werden Test-Circle gutgeschrieben.",
  "Управление подпиской": "Abonnement verwalten",
  "Условия тарифа изменились. Обновите данные перед подтверждением.": "Die Tarifbedingungen haben sich geändert. Aktualisieren Sie die Daten vor der Bestätigung.",
  "Что входит": "Leistungsumfang",
  "Это бесплатная dev-операция. Деньги и Telegram Stars не списываются.": "Dies ist ein kostenloser Dev-Vorgang. Es werden weder Geld noch Telegram Stars abgebucht.",
  "Этот переход между тарифами недоступен.": "Dieser Tarifwechsel ist nicht verfügbar.",
  "Этот тариф больше недоступен. Обновите список.": "Dieser Tarif ist nicht mehr verfügbar. Aktualisieren Sie die Liste.",
  "QR-код": "QR-Code",
  "QR-код приглашения": "QR-Code für Einladungen",
  "{0} из {1} · {2} Circle": "{0} von {1} · {2} Circle",
  "Виды заданий": "Aufgabentypen",
  "Выполнение этого задания пока недоступно.": "Diese Aufgabe ist derzeit nicht verfügbar.",
  "Готовим материал…": "Material wird vorbereitet…",
  "Действие подтверждено. Обновляем задания.": "Aktion bestätigt. Aufgaben werden aktualisiert.",
  "День {0}": "Tag {0}",
  "День {0} из {1}": "Tag {0} von {1}",
  "Дней подряд: {0}": "Aufeinanderfolgende Tage: {0}",
  "Друзья": "Freunde",
  "Ежедневная серия": "Tägliche Serie",
  "Ежедневные": "Tägliche Aufgaben",
  "Есть награды": "Belohnungen verfügbar",
  "Забрать {0} Circle": "{0} Circle abholen",
  "Загружаем награды…": "Belohnungen werden geladen…",
  "Задание ещё не выполнено. Обновите прогресс.": "Aufgabe noch nicht abgeschlossen. Aktualisiere den Fortschritt.",
  "Задание засчитывает открытие отправки сторис. Telegram не подтверждает публикацию.": "Die Aufgabe zählt das Öffnen der Story-Veröffentlichung. Telegram bestätigt nicht, dass die Story veröffentlicht wurde.",
  "Заданий в этой группе пока нет.": "In dieser Gruppe gibt es noch keine Aufgaben.",
  "Задания дня": "Aufgaben des Tages",
  "Заходите каждый день. Пропуск дня начинает серию заново.": "Komm jeden Tag vorbei. Wenn du einen Tag auslässt, beginnt die Serie von vorn.",
  "Исход прежнего запроса нужно проверить. Новые начисления пока заблокированы.": "Der Status der vorherigen Anfrage muss überprüft werden. Neue Gutschriften sind vorerst gesperrt.",
  "Копирование недоступно. Выделите текст вручную.": "Kopieren nicht verfügbar. Markiere den Text manuell.",
  "Материал для сторис": "Story-Material",
  "Награда подтверждена. Обновите данные; повторять начисление не нужно.": "Belohnung bestätigt. Aktualisiere die Daten; eine erneute Gutschrift ist nicht erforderlich.",
  "Награда получена": "Belohnung erhalten",
  "Награда получена. Завтра +{0} Circle": "Belohnung erhalten. Morgen +{0} Circle",
  "Награда уже получена. Обновите данные.": "Belohnung bereits erhalten. Aktualisiere die Daten.",
  "Награды временно недоступны. Попробуйте обновить данные.": "Belohnungen vorübergehend nicht verfügbar. Versuche, die Daten zu aktualisieren.",
  "Награды за друзей": "Belohnungen für Freunde",
  "Награды приходят в Circle: ими можно платить в STEOS, выводить нельзя.": "Belohnungen werden in Circle gutgeschrieben: Du kannst damit in STEOS bezahlen, aber sie nicht auszahlen lassen.",
  "Начисление не подтверждено. Проверьте прежний запрос; новая награда пока заблокирована.": "Gutschrift nicht bestätigt. Überprüfe die vorherige Anfrage; eine neue Belohnung ist vorerst gesperrt.",
  "Начисления приостановлены.": "Gutschriften pausiert.",
  "Начислено {0} Circle": "{0} Circle gutgeschrieben",
  "Начислено: {0} Circle": "Gutgeschrieben: {0} Circle",
  "Не удалось восстановить запрос награды. Проверьте баланс и обратитесь в поддержку.": "Die Belohnungsanfrage konnte nicht wiederhergestellt werden. Überprüfe dein Guthaben und wende dich an den Support.",
  "Не удалось загрузить QR-код.": "QR-Code konnte nicht geladen werden.",
  "Не удалось открыть отправку сторис. Награда не начислена.": "Story-Veröffentlichung konnte nicht geöffnet werden. Keine Belohnung gutgeschrieben.",
  "Не удалось подготовить сторис. Попробуйте ещё раз.": "Story konnte nicht vorbereitet werden. Versuche es erneut.",
  "Новый день: {0}": "Neuer Tag: {0}",
  "Обновить награды": "Belohnungen aktualisieren",
  "Обновятся: {0}": "Werden aktualisiert: {0}",
  "Откройте Mini App в Telegram с поддержкой сторис.": "Öffne die Mini App in Telegram mit Story-Unterstützung.",
  "Открыть STEOS ID в профиле": "STEOS ID im Profil öffnen",
  "Открыть сторис": "Story öffnen",
  "Отправить в сторис": "In der Story teilen",
  "Партнёрские данные временно недоступны.": "Partnerdaten vorübergehend nicht verfügbar.",
  "Партнёрство · Статистика, материалы и вывод": "Partnerschaft · Statistiken, Materialien und Auszahlung",
  "Первые шаги": "Erste Schritte",
  "Перейти к заданию": "Zur Aufgabe",
  "Получить ежедневную награду": "Tägliche Belohnung abholen",
  "Приглашено: {0} · Покупателей: {1}": "Eingeladen: {0} · Käufer: {1}",
  "Прогресс задания": "Aufgabenfortschritt",
  "Прогресс задания временно недоступен.": "Aufgabenfortschritt vorübergehend nicht verfügbar.",
  "Промокод": "Aktionscode",
  "Разовые": "Einmalige Aufgaben",
  "Скопировать приглашение": "Einladung kopieren",
  "Скопировать промокод": "Aktionscode kopieren",
  "Ссылка приглашения": "Einladungslink",
  "Сторис в Telegram": "Telegram-Stories",
  "Челленджи недели": "Wöchentliche Challenges",
  "Circle используются внутри STEOS": "Circle werden innerhalb von STEOS verwendet",
  "Telegram подтвердил отправку сообщения.": "Telegram hat den Versand der Nachricht bestätigt.",
  "Без покупок": "Keine Käufe",
  "В этом списке пока нет друзей.": "In dieser Liste gibt es noch keine Freunde.",
  "Возможен вывод по условиям программы": "Auszahlung gemäß den Programmbedingungen möglich",
  "Вопросы": "Fragen",
  "Всё время": "Gesamter Zeitraum",
  "Вы здесь": "Sie sind hier",
  "Выберите PDF, JPG или PNG.": "Wählen Sie PDF, JPG oder PNG aus.",
  "Выберите плательщика": "Zahlungspflichtigen auswählen",
  "Выбрать чат в Telegram": "Chat in Telegram auswählen",
  "Выбрать чат для отправки": "Chat für den Versand auswählen",
  "Вывод": "Auszahlung",
  "Вывод недоступен на текущем уровне.": "Auszahlung auf der aktuellen Stufe nicht verfügbar.",
  "Вывод сейчас недоступен.": "Auszahlung derzeit nicht verfügbar.",
  "Вывод средств": "Geld auszahlen",
  "Выплачен": "Ausgezahlt",
  "Выставьте счёт на": "Rechnung an",
  "Для вывода войдите в STEOS ID.": "Melden Sie sich für die Auszahlung bei STEOS ID an.",
  "Для расчёта нужны опубликованные уровни и тарифы.": "Für die Berechnung müssen Stufen und Tarife veröffentlicht sein.",
  "До уровня «{0}»: ещё {1} покупателей": "Bis zur Stufe „{0}“: noch {1} Käufer",
  "Доступно к выводу": "Auszahlbarer Betrag",
  "Доступных шаблонов пока нет.": "Noch keine Vorlagen verfügbar.",
  "Доход": "Einnahmen",
  "Если купят {0} друзей": "Wenn {0} Freunde kaufen",
  "Есть покупки": "Käufe vorhanden",
  "За этот период начислений пока нет.": "Für diesen Zeitraum wurden noch keine Beträge gutgeschrieben.",
  "Загружаем QR-код…": "QR-Code wird geladen…",
  "Загружаем друзей…": "Freunde werden geladen…",
  "Загружаем материалы…": "Materialien werden geladen…",
  "Загружаем партнёрские данные…": "Partnerdaten werden geladen…",
  "Загрузите проверенный счёт на оплату.": "Laden Sie eine geprüfte Rechnung hoch.",
  "Заказать материал в чат": "Material im Chat bestellen",
  "Запрос принят. Доставка в чат ещё не подтверждена.": "Anfrage angenommen. Die Zustellung im Chat wurde noch nicht bestätigt.",
  "Заявка принята. Статус выплаты появится в истории.": "Antrag angenommen. Der Auszahlungsstatus wird im Verlauf angezeigt.",
  "Заявок на вывод пока нет.": "Noch keine Auszahlungsanträge vorhanden.",
  "Изменение реквизитов заблокировано до получения результата этой заявки.": "Die Änderung der Zahlungsdaten ist bis zum Ergebnis dieses Antrags gesperrt.",
  "Имя получателя": "Name des Zahlungsempfängers",
  "История выводов": "Auszahlungsverlauf",
  "Исход запроса нужно проверить. Новый материал пока заблокирован.": "Das Ergebnis der Anfrage muss überprüft werden. Neues Material ist vorerst gesperrt.",
  "Как определяется уровень?": "Wie wird die Stufe bestimmt?",
  "Как это работает": "So funktioniert es",
  "Калькулятор станет доступен после публикации расчётной политики.": "Der Rechner wird verfügbar, sobald die Berechnungsrichtlinie veröffentlicht wurde.",
  "Количество друзей": "Anzahl der Freunde",
  "Материалы": "Materialien",
  "Материалы временно недоступны. Попробуйте обновить список.": "Materialien sind vorübergehend nicht verfügbar. Versuchen Sie, die Liste zu aktualisieren.",
  "Материалы пока недоступны.": "Materialien sind derzeit nicht verfügbar.",
  "Месяц": "Monat",
  "Минимальная сумма": "Mindestbetrag",
  "На рассмотрении": "In Prüfung",
  "Налоговый номер": "Steuernummer",
  "Начисления за период": "Gutschriften im Zeitraum",
  "Начислено Circle": "Circle gutgeschrieben",
  "Начислено за период: {0} Circle": "Im Zeitraum gutgeschrieben: {0} Circle",
  "Не удалось безопасно сохранить заявку или проверить владельца. Отправка не выполнена.": "Der Antrag konnte nicht sicher gespeichert oder der Inhaber nicht überprüft werden. Der Versand wurde nicht ausgeführt.",
  "Не удалось восстановить отправку. Обратитесь в поддержку перед новым запросом.": "Der Versand konnte nicht wiederhergestellt werden. Wenden Sie sich vor einer neuen Anfrage an den Support.",
  "Не удалось загрузить друзей.": "Freunde konnten nicht geladen werden.",
  "Не удалось загрузить историю выводов.": "Der Auszahlungsverlauf konnte nicht geladen werden.",
  "Не удалось загрузить тарифы.": "Die Tarife konnten nicht geladen werden.",
  "Не удалось открыть отправку в Telegram.": "Der Versand über Telegram konnte nicht geöffnet werden.",
  "Не удалось проверить владельца. Обновите страницу.": "Der Inhaber konnte nicht überprüft werden. Aktualisieren Sie die Seite.",
  "Не удалось прочитать сохранённую заявку. Новый вывод заблокирован.": "Der gespeicherte Antrag konnte nicht gelesen werden. Eine neue Auszahlung ist gesperrt.",
  "Не удалось сохранить состояние отправки.": "Der Versandstatus konnte nicht gespeichert werden.",
  "Неделя": "Woche",
  "Нет данных": "Keine Daten",
  "Новая заявка": "Neuer Antrag",
  "Новая заявка на вывод сейчас недоступна.": "Ein neuer Auszahlungsantrag ist derzeit nicht verfügbar.",
  "О программе": "Über das Programm",
  "Обзор": "Übersicht",
  "Обновите страницу или обратитесь в поддержку.": "Aktualisieren Sie die Seite oder wenden Sie sich an den Support.",
  "Обновить историю выводов": "Auszahlungsverlauf aktualisieren",
  "Обновить материалы": "Materialien aktualisieren",
  "От {0} покупателей": "Ab {0} Käufern",
  "Ответ не получен. Проверьте ту же заявку: её данные и ключ сохранены.": "Keine Antwort erhalten. Überprüfen Sie denselben Antrag: Seine Daten und sein Schlüssel sind gespeichert.",
  "Отклонён": "Abgelehnt",
  "Откройте Mini App в Telegram с поддержкой отправки материалов.": "Öffnen Sie die Mini App in Telegram mit Unterstützung für den Materialversand.",
  "Открыть сторис в Telegram": "Story in Telegram öffnen",
  "Отправка не подтверждена. Повтор проверит прежний запрос без новой отправки.": "Der Versand wurde nicht bestätigt. Beim erneuten Versuch wird die vorherige Anfrage überprüft, ohne etwas erneut zu senden.",
  "Отправка отменена. Можно открыть выбор чата ещё раз.": "Der Versand wurde abgebrochen. Sie können die Chat-Auswahl erneut öffnen.",
  "Оценка дохода": "Geschätzte Einnahmen",
  "Оценка за {0} месяцев: {1} Circle": "Schätzung für {0} Monate: {1} Circle",
  "Оценка за месяц: {0} Circle": "Monatliche Schätzung: {0} Circle",
  "Переходы": "Aufrufe",
  "Период обзора": "Übersichtszeitraum",
  "Плательщик": "Zahlungspflichtiger",
  "Подать заявку на вывод": "Auszahlungsantrag stellen",
  "Подготовить QR-код": "QR-Code erstellen",
  "Подготовить другой материал": "Anderes Material erstellen",
  "Подготовить материал": "Material erstellen",
  "Поделитесь своей ссылкой или промокодом.": "Teilen Sie Ihren Link oder Promocode.",
  "Поделиться": "Teilen",
  "Пока без покупок": "Noch keine Käufe",
  "Пока недоступно": "Derzeit nicht verfügbar",
  "Покупатели": "Käufer",
  "Покупки друзей учитывает сервер STEOS ID.": "Käufe von Freunden werden vom STEOS ID-Server erfasst.",
  "Полные условия программы": "Vollständige Programmbedingungen",
  "Пользователь": "Benutzer",
  "Попробуйте STEOS: {0}\nПромокод: {1}": "Probieren Sie STEOS aus: {0}\nPromocode: {1}",
  "Привязка до: {0}": "Verknüpfung bis: {0}",
  "Привязка приглашённого друга действует {0} месяцев.": "Die Verknüpfung eines eingeladenen Freundes bleibt {0} Monate lang bestehen.",
  "Приглашён: {0}": "Eingeladen: {0}",
  "Проверить загрузку счёта": "Rechnungs-Upload überprüfen",
  "Проверить ту же заявку": "Denselben Antrag überprüfen",
  "Проверьте налоговый номер получателя.": "Überprüfen Sie die Steuernummer des Zahlungsempfängers.",
  "Проверьте реквизиты и счёт.": "Überprüfen Sie die Zahlungsdaten und die Rechnung.",
  "Проверьте сумму вывода: целое число в доступном диапазоне.": "Überprüfen Sie den Auszahlungsbetrag: eine ganze Zahl innerhalb des verfügbaren Bereichs.",
  "Проверяем владельца…": "Inhaber wird überprüft…",
  "Проверяем заявку или счёт…": "Antrag oder Rechnung wird überprüft…",
  "Процент и доступность вывода определяет опубликованная программа.": "Der Prozentsatz und die Verfügbarkeit von Auszahlungen werden durch das veröffentlichte Programm bestimmt.",
  "Проценты, сроки и ограничения показаны по опубликованным данным сервера.": "Prozentsätze, Fristen und Einschränkungen basieren auf den veröffentlichten Serverdaten.",
  "Размер счёта должен быть от 1 байта до 10 МБ.": "Die Rechnungsdatei muss zwischen 1 Byte und 10 MB groß sein.",
  "Регистрации": "Registrierungen",
  "Результат загрузки счёта неизвестен. Проверьте загрузку без повторной отправки файла.": "Das Ergebnis des Rechnungs-Uploads ist unbekannt. Überprüfen Sie den Upload, ohne die Datei erneut zu senden.",
  "Скачать PNG": "PNG herunterladen",
  "Сколько действует привязка друга?": "Wie lange bleibt die Verknüpfung eines Freundes bestehen?",
  "Скопировать текст": "Text kopieren",
  "Сохранена неподтверждённая заявка": "Nicht bestätigter Antrag gespeichert",
  "Срок рассмотрения, дней": "Bearbeitungsdauer in Tagen",
  "Ссылка и промокод добавляются сервером. Выберите доступный материал.": "Link und Promocode werden vom Server hinzugefügt. Wählen Sie ein verfügbares Material aus.",
  "Ссылка на полный документ условий пока не опубликована.": "Der Link zum vollständigen Bedingungsdokument wurde noch nicht veröffentlicht.",
  "Сторис открыта в Telegram. Публикацию нужно подтвердить в редакторе.": "Die Story wurde in Telegram geöffnet. Die Veröffentlichung muss im Editor bestätigt werden.",
  "Сумма в Circle": "Betrag in Circle",
  "Сумма меньше минимальной суммы вывода.": "Der Betrag liegt unter dem Mindestauszahlungsbetrag.",
  "Сумма превышает доступный остаток.": "Der Betrag übersteigt das verfügbare Guthaben.",
  "Счёт на оплату · PDF, JPG или PNG, до 10 МБ": "Rechnung · PDF, JPG oder PNG, bis zu 10 MB",
  "Счёт не прошёл загрузку или проверку. Выберите PDF, JPG или PNG до 10 МБ.": "Die Rechnung konnte nicht hochgeladen oder überprüft werden. Wählen Sie eine PDF-, JPG- oder PNG-Datei mit maximal 10 MB aus.",
  "Счёт пока не подтверждён. Повторите проверку или выберите другой файл.": "Die Rechnung wurde noch nicht bestätigt. Wiederholen Sie die Überprüfung oder wählen Sie eine andere Datei aus.",
  "Счёт проверен": "Rechnung überprüft",
  "Текст приглашения": "Einladungstext",
  "Текст сообщения": "Nachrichtentext",
  "Тексты": "Texte",
  "Тестовая заявка": "Testantrag",
  "Тестовая программа dev. Реальные выплаты выключены.": "Testprogramm dev. Reale Auszahlungen sind deaktiviert.",
  "Тестовая программа: реальные выплаты отключены.": "Testprogramm: Reale Auszahlungen sind deaktiviert.",
  "Тестовый расчёт dev. Это оценка, начисление не выполняется.": "Testberechnung dev. Dies ist eine Schätzung; es erfolgt keine Gutschrift.",
  "Укажите имя получателя: до 200 символов.": "Geben Sie den Namen des Zahlungsempfängers ein: maximal 200 Zeichen.",
  "Уровень показывает сервер по учтённым покупателям. Смотрите вкладку «Уровни».": "Die Stufe wird vom Server anhand der erfassten Käufer angezeigt. Siehe die Registerkarte „Stufen“.",
  "Уровни": "Stufen",
  "Условия начислений пока не опубликованы.": "Die Bedingungen für Gutschriften wurden noch nicht veröffentlicht.",
  "Условия программы": "Programmbedingungen",
  "Учёт переходов по ссылке пока недоступен.": "Die Erfassung von Linkaufrufen ist derzeit nicht verfügbar.",
  "Фильтр друзей": "Freundefilter",
  "Что делать, если данные не обновились?": "Was tun, wenn die Daten nicht aktualisiert wurden?",
  "Шаги": "Schritte",
  "Баннер": "Banner",
  "QR-постер": "QR-Plakat",
  "{0} / 300 знаков": "{0} / 300 Zeichen",
  "· до 20 МБ": "· bis zu 20 MB",
  "Агент готовит ответ…": "Der Agent erstellt eine Antwort…",
  "Аудиозапись": "Audioaufnahme",
  "Бесплатно только в dev. До 30 секунд и 10 МБ. Текст можно исправить перед отправкой.": "Kostenlos nur in der Dev-Umgebung. Bis zu 30 Sekunden und 10 MB. Der Text kann vor dem Senden bearbeitet werden.",
  "Ваш вопрос": "Ihre Frage",
  "Вопрос или название инструмента": "Frage oder Name des Tools",
  "Вопросов: {0}": "Fragen: {0}",
  "Вопросы · {0}": "Fragen · {0}",
  "Восстанавливаем чат…": "Chat wird wiederhergestellt…",
  "Все сервисы работают": "Alle Dienste funktionieren",
  "Выберите MP3, WAV или M4A до 20 МБ.": "Wählen Sie eine MP3-, WAV- oder M4A-Datei mit bis zu 20 MB aus.",
  "Выберите инструкцию к нужному инструменту или странице.": "Wählen Sie die Anleitung für das gewünschte Tool oder die gewünschte Seite aus.",
  "Диктовать вопрос": "Frage diktieren",
  "Диктовка не подтверждена. Повторите проверку прежнего запроса или загрузки.": "Diktat nicht bestätigt. Überprüfen Sie die vorherige Anfrage oder den Upload erneut.",
  "До": "Bis",
  "Ещё спрашивают": "Andere fragen auch",
  "Загружаем справку…": "Hilfe wird geladen…",
  "Загружаем статус…": "Status wird geladen…",
  "Закрыть чат": "Chat schließen",
  "ИИ-агент поддержки": "KI-Support-Agent",
  "ИИ-агент сейчас недоступен.": "Der KI-Agent ist derzeit nicht verfügbar.",
  "Инструкции": "Anleitungen",
  "Инструкции · {0}": "Anleitungen · {0}",
  "Инструкции пока не опубликованы.": "Es wurden noch keine Anleitungen veröffentlicht.",
  "Исход запроса пока неизвестен. Новый вопрос не отправляется.": "Der Ausgang der Anfrage ist noch unbekannt. Es wird keine neue Frage gesendet.",
  "Как пользоваться STEOS": "So verwenden Sie STEOS",
  "Кружки и говорящие видео": "Videonachrichten und sprechende Videos",
  "Медленнее обычного": "Langsamer als gewöhnlich",
  "Написать агенту": "Dem Agenten schreiben",
  "Начать": "Starten",
  "Начать новую диктовку": "Neues Diktat starten",
  "Не помогло": "Nicht hilfreich",
  "Не удалось восстановить диктовку. Новый запрос заблокирован.": "Das Diktat konnte nicht wiederhergestellt werden. Eine neue Anfrage ist gesperrt.",
  "Не удалось восстановить чат. Обратитесь в поддержку.": "Der Chat konnte nicht wiederhergestellt werden. Wenden Sie sich an den Support.",
  "Не удалось загрузить поддержку. Попробуйте ещё раз.": "Der Support konnte nicht geladen werden. Versuchen Sie es erneut.",
  "Не удалось загрузить статус сервисов.": "Der Dienststatus konnte nicht geladen werden.",
  "Не удалось подтвердить ответ. Можно начать новый чат или написать в поддержку.": "Die Antwort konnte nicht bestätigt werden. Sie können einen neuen Chat starten oder den Support kontaktieren.",
  "Не удалось получить ответ. Повторите проверку без нового вопроса.": "Es konnte keine Antwort abgerufen werden. Überprüfen Sie die vorherige Anfrage erneut, ohne eine neue Frage zu stellen.",
  "Не удалось проверить владельца чата. Повторите открытие.": "Der Chat-Eigentümer konnte nicht überprüft werden. Öffnen Sie den Chat erneut.",
  "Не удалось сохранить новый чат.": "Der neue Chat konnte nicht gespeichert werden.",
  "Не удалось сохранить оценку. Попробуйте ещё раз.": "Die Bewertung konnte nicht gespeichert werden. Versuchen Sie es erneut.",
  "Недоступен": "Nicht verfügbar",
  "Некоторые сервисы работают медленнее обычного. Открыть статус": "Einige Dienste sind langsamer als gewöhnlich. Status anzeigen",
  "Нет подтверждённых данных": "Keine bestätigten Daten",
  "Ничего не нашли. Попробуйте другие слова или спросите ИИ-агента.": "Nichts gefunden. Versuchen Sie es mit anderen Begriffen oder fragen Sie den KI-Agenten.",
  "Новый чат": "Neuer Chat",
  "Обзор приложения": "App-Übersicht",
  "Обновить справку": "Hilfe aktualisieren",
  "Обновить статус": "Status aktualisieren",
  "Опубликованная проверка. Автоматический мониторинг не заявлен.": "Veröffentlichte Prüfung. Eine automatische Überwachung wird nicht zugesichert.",
  "Ответ не подтверждён. Проверьте прежний запрос или напишите в поддержку.": "Die Antwort wurde nicht bestätigt. Überprüfen Sie die vorherige Anfrage oder wenden Sie sich an den Support.",
  "Отвечает по опубликованной справке STEOS": "Antwortet anhand der veröffentlichten STEOS-Hilfe",
  "Открыть инструкции": "Anleitungen öffnen",
  "Открыть инструкцию": "Anleitung öffnen",
  "Открыть инструмент": "Tool öffnen",
  "Открыть ответ справки": "Hilfeantwort öffnen",
  "Открыть раздел": "Abschnitt öffnen",
  "Отправить вопрос": "Frage senden",
  "Оценка ответа": "Antwort bewerten",
  "Очистить поиск": "Suche löschen",
  "Поиск по справке": "Hilfe durchsuchen",
  "Полезно": "Hilfreich",
  "Помощь": "Hilfe",
  "Популярные вопросы": "Häufig gestellte Fragen",
  "Последняя проверка устарела. Текущее состояние неизвестно.": "Die letzte Überprüfung ist veraltet. Der aktuelle Status ist unbekannt.",
  "Посмотреть короткий обзор": "Kurzübersicht ansehen",
  "Предыдущая": "Vorherige",
  "Проверено: {0}": "Geprüft: {0}",
  "Проверить диктовку": "Diktat überprüfen",
  "Пропустить": "Überspringen",
  "Работает": "Funktioniert",
  "Распознать вопрос": "Frage erkennen",
  "Распознаём вопрос…": "Frage wird erkannt…",
  "Результаты поиска": "Suchergebnisse",
  "Следующая": "Nächste",
  "Советы": "Tipps",
  "Справка пока не опубликована.": "Es wurde noch keine Hilfe veröffentlicht.",
  "Спросите что угодно": "Fragen Sie einfach",
  "Спросить ИИ-агента": "KI-Agent fragen",
  "Спросить ИИ-агента поддержки": "KI-Support-Agent fragen",
  "Статус": "Status",
  "Статус сервисов": "Dienststatus",
  "Статус сервисов пока не публикуется.": "Der Dienststatus wird derzeit nicht veröffentlicht.",
  "Статья недоступна": "Artikel nicht verfügbar",
  "Темы": "Themen",
  "Темы пока не опубликованы.": "Es wurden noch keine Themen veröffentlicht.",
  "Точного ответа в справке нет.": "In der Hilfe gibt es keine genaue Antwort.",
  "Чат не отправляет сообщения человеку автоматически.": "Der Chat sendet nicht automatisch Nachrichten an eine Person.",
  "Читаем запись…": "Aufnahme wird gelesen…",
  "Эта статья больше не входит в опубликованную справку.": "Dieser Artikel gehört nicht mehr zur veröffentlichten Hilfe.",
  "Выберите MP3, WAV или M4A до {0} МБ.": "Wähle eine MP3-, WAV- oder M4A-Datei mit maximal {0} MB aus.",
  "До {0} · до {1} МБ": "Bis zu {0} · bis zu {1} MB",
  "Нужна запись от 1 секунды до {0}.": "Die Aufnahme muss zwischen 1 Sekunde und {0} dauern.",
  "Остановить запись · {0}": "Aufnahme stoppen · {0}",
  "{0} C/сек": "{0} °C/s",
  "Все инструменты": "Alle Tools",
  "Все шаблоны": "Alle Vorlagen",
  "Вся подборка": "Gesamte Sammlung",
  "Выбрать, кто играет": "Wer spielt auswählen",
  "Голос и музыка": "Stimme und Musik",
  "Двое": "Zwei",
  "Дети": "Kinder",
  "Дешевле": "Günstiger",
  "Для бизнеса": "Für Unternehmen",
  "Для этого действия доступно несколько шаблонов. Выберите подходящий в каталоге.": "Für diese Aktion sind mehrere Vorlagen verfügbar. Wählen Sie eine passende im Katalog aus.",
  "Загружаем шаблон…": "Vorlage wird geladen…",
  "Закрыть поиск": "Suche schließen",
  "Закрыть превью": "Vorschau schließen",
  "Инструменты": "Tools",
  "Искать во всех шаблонах": "Alle Vorlagen durchsuchen",
  "Короче": "Kürzer",
  "Кто играет": "Wer spielt",
  "Найти инструмент или шаблон": "Tool oder Vorlage suchen",
  "Не удалось загрузить выбранный вариант.": "Die ausgewählte Variante konnte nicht geladen werden.",
  "Не удалось загрузить шаблон. Обновите превью.": "Die Vorlage konnte nicht geladen werden. Aktualisieren Sie die Vorschau.",
  "Не удалось открыть инструмент.": "Das Tool konnte nicht geöffnet werden.",
  "Несколько": "Mehrere",
  "Новые": "Neu",
  "Один": "Eine Person",
  "от {0} C": "Ab {0} C",
  "от {0} C/сек": "Ab {0} °C/s",
  "От {0} Circle": "Ab {0} Circle",
  "От А до Я": "Von A bis Z",
  "Очистить": "Leeren",
  "Питомцы": "Haustiere",
  "По желанию": "Optional",
  "Подборка пока недоступна.": "Die Sammlung ist derzeit nicht verfügbar.",
  "Подборки": "Sammlungen",
  "Поиск": "Suche",
  "Пока нет доступных шаблонов": "Derzeit sind keine Vorlagen verfügbar",
  "Популярные": "Beliebt",
  "После": "Nachher",
  "Превью шаблона": "Vorlagenvorschau",
  "Пример результата пока не опубликован.": "Ein Ergebnisbeispiel wurde noch nicht veröffentlicht.",
  "Пример сейчас недоступен.": "Das Beispiel ist derzeit nicht verfügbar.",
  "Рекомендуем": "Empfohlen",
  "Смотреть все": "Alle ansehen",
  "Сначала": "Sortieren",
  "Сравнить до и после": "Vorher und nachher vergleichen",
  "Стилей: {0}. Выбор на следующем шаге.": "Stile: {0}. Die Auswahl erfolgt im nächsten Schritt.",
  "Удерживайте для просмотра": "Zum Anzeigen gedrückt halten",
  "Цена уточняется в форме создания.": "Der Preis wird im Erstellungsformular angezeigt.",
  "Частые вопросы": "Häufig gestellte Fragen",
  "Что нужно": "Was wird benötigt",
  "Что хотите сделать?": "Was möchten Sie tun?",
  "Шаблоны и подборки": "Vorlagen und Sammlungen",
  "Это действие пока недоступно.": "Diese Aktion ist derzeit nicht verfügbar.",
  "е": "e",
  "за секунду": "pro Sekunde",
  "ё": "ё",
  "{0} C в минуту": "{0} € pro Minute",
  "{0} C за 100 знаков": "{0} € pro 100 Zeichen",
  "Владелец сессии изменился. Вернитесь в студию после обновления страницы.": "Der Sitzungsinhaber hat sich geändert. Kehren Sie nach dem Aktualisieren der Seite zum Studio zurück.",
  "Не удалось восстановить сохранённую заявку. Новая генерация заблокирована.": "Der gespeicherte Antrag konnte nicht wiederhergestellt werden. Eine neue Generierung ist gesperrt.",
  "Не удалось обновить сохранённую заявку. Новая генерация заблокирована.": "Der gespeicherte Antrag konnte nicht aktualisiert werden. Eine neue Generierung ist gesperrt.",
  "Не удалось проверить владельца. Новая генерация заблокирована.": "Der Inhaber konnte nicht überprüft werden. Eine neue Generierung ist gesperrt.",
  "Не удалось сохранить заявку. Отправка не выполнена.": "Der Antrag konnte nicht gespeichert werden. Die Übermittlung ist fehlgeschlagen.",
  "от {0} C в минуту": "Ab {0} € pro Minute",
  "от {0} C за 100 знаков": "Ab {0} € pro 100 Zeichen",
  "Проверить статус заказа": "Bestellstatus prüfen",
  "Статус пока не подтверждён. Проверьте этот же заказ позже.": "Der Status wurde noch nicht bestätigt. Prüfen Sie dieselbe Bestellung später erneut.",
  "в минуту": "pro Minute",
  "за 100 знаков": "pro 100 Zeichen",
  "Анимация звука": "Soundanimation",
  "В видео останется исходная речь. Выберите фрагмент до одной минуты.": "Im Video bleibt die Originalsprache erhalten. Wähle einen Ausschnitt von bis zu einer Minute.",
  "В видео останутся исходные слова. Голос можно изменить. Выберите фрагмент до одной минуты.": "Im Video bleiben die Originalwörter erhalten. Die Stimme kann geändert werden. Wähle einen Ausschnitt von bis zu einer Minute.",
  "Вид персонажа": "Erscheinungsbild der Figur",
  "Видео готово": "Video fertig",
  "Видео не создано": "Video konnte nicht erstellt werden",
  "Волна": "Welle",
  "Выберите, кто говорит": "Wähle aus, wer spricht",
  "Выбранное фото": "Ausgewähltes Foto",
  "Движение": "Bewegung",
  "Добавьте видео": "Video hinzufügen",
  "Дополнительная настройка": "Zusätzliche Einstellungen",
  "Другой голос для записи": "Andere Stimme für die Aufnahme",
  "Ещё вариант": "Weitere Variante",
  "Ещё настройки": "Weitere Einstellungen",
  "Изменить данные": "Angaben ändern",
  "Источник": "Quelle",
  "Источник лица": "Gesichtsquelle",
  "Источник речи": "Sprachquelle",
  "Кадр по вертикали": "Hochformat",
  "Кадр по горизонтали": "Querformat",
  "Каких движений избегать": "Welche Bewegungen sollen vermieden werden?",
  "Конец фрагмента, секунды": "Ende des Ausschnitts, Sekunden",
  "Кружком": "Als Videonachricht",
  "Кружок готов": "Videonachricht fertig",
  "Кружок не создан": "Videonachricht konnte nicht erstellt werden",
  "Люди и персонажи": "Menschen und Figuren",
  "Напишите текст или добавьте запись": "Text eingeben oder Aufnahme hinzufügen",
  "Начало фрагмента, секунды": "Beginn des Ausschnitts, Sekunden",
  "Не удалось загрузить виды персонажа.": "Figurenansichten konnten nicht geladen werden.",
  "Не удалось загрузить людей и персонажей.": "Menschen und Figuren konnten nicht geladen werden.",
  "Не удалось подтвердить завершение заказа. Новая генерация не начата.": "Der Abschluss der Bestellung konnte nicht bestätigt werden. Eine neue Generierung wurde nicht gestartet.",
  "Не удалось проверить доставку. Откройте историю заказа.": "Die Zustellung konnte nicht überprüft werden. Öffne den Bestellverlauf.",
  "Оставить голос записи": "Originalstimme der Aufnahme beibehalten",
  "Открыть в чате": "Im Chat öffnen",
  "Отправлено в чат": "An den Chat gesendet",
  "По умолчанию": "Standard",
  "Подтвердите право использовать материалы": "Bestätige, dass du zur Nutzung der Materialien berechtigt bist",
  "Полосы": "Streifen",
  "Портретное": "Hochformat",
  "Прежний заказ ещё не завершён. Сначала проверьте его результат.": "Die vorherige Bestellung ist noch nicht abgeschlossen. Prüfe zuerst das Ergebnis.",
  "Приближение": "Annäherung",
  "Проверка отклонила материал. Измените исходные данные.": "Die Prüfung hat das Material abgelehnt. Ändere die Ausgangsdaten.",
  "Продолжить проверку отправки": "Versandprüfung fortsetzen",
  "Результат недоступен. Проверьте историю заказа.": "Ergebnis nicht verfügbar. Prüfe den Bestellverlauf.",
  "Результат отправки пока не подтверждён. Продолжите проверку с тем же ключом.": "Der Versand wurde noch nicht bestätigt. Setze die Prüfung mit demselben Schlüssel fort.",
  "Результат пока не подтверждён. Проверьте этот заказ, прежде чем создавать новый.": "Das Ergebnis wurde noch nicht bestätigt. Prüfe diese Bestellung, bevor du eine neue erstellst.",
  "Своё видео": "Eigenes Video",
  "Своё фото": "Eigenes Foto",
  "Создание сейчас недоступно": "Erstellung derzeit nicht verfügbar",
  "Создать кружок": "Videonachricht erstellen",
  "Создаём видео": "Video wird erstellt",
  "Списание возвращено": "Abbuchung erstattet",
  "Тестовый заказ без списания": "Testbestellung ohne Abbuchung",
  "Файлом": "Als Datei",
  "Фоновый звук": "Hintergrundton",
  "Фото с лицом": "Foto mit Gesicht",
  "Цена или версия инструмента изменилась. Обновите форму и проверьте стоимость.": "Der Preis oder die Tool-Version hat sich geändert. Aktualisiere das Formular und prüfe die Kosten.",
  "Человек или персонаж": "Mensch oder Figur",
  "Что скажет?": "Was soll die Person sagen?",
  "Напишите не меньше {0} знаков": "Geben Sie mindestens {0} Zeichen ein",
  "Текст отклонён проверкой. Измените текст.": "Der Text wurde bei der Prüfung abgelehnt. Ändern Sie den Text.",
  "В видео прозвучат новые слова.": "Im Video werden neue Wörter gesprochen.",
  "Если речь длиннее видео, ролик повторится.": "Wenn die Sprache länger als das Video ist, wird der Clip wiederholt.",
  "Исходная речь": "Originalsprache",
  "Новая запись": "Neue Aufnahme",
  "Новые слова текстом": "Neue Wörter als Text",
  "Речь в видео": "Sprache im Video",
  "Размер файла не должен превышать {0} МБ.": "Die Datei darf nicht größer als {0} MB sein.",
  "До {0} МБ": "Bis zu {0} MB",
  "Альбомное": "Querformat",
  "Альбомом": "Im Querformat",
  "Без стиля": "Ohne Stil",
  "В новом стиле": "In einem neuen Stil",
  "Вариант": "Variante",
  "Во весь экран": "Vollbild",
  "Восстановить фото": "Foto restaurieren",
  "Все стили": "Alle Stile",
  "Все темы": "Alle Themen",
  "Выберите инструмент в каталоге, затем подтвердите использование фото.": "Wählen Sie ein Werkzeug aus dem Katalog und bestätigen Sie anschließend die Verwendung des Fotos.",
  "Выберите подходящее фото до {0} МБ.": "Wählen Sie ein geeignetes Foto mit maximal {0} MB aus.",
  "Выберите стиль или свой референс": "Stil oder eigene Referenz auswählen",
  "Выбран свой референс": "Eigene Referenz ausgewählt",
  "Выбрать стиль": "Stil auswählen",
  "Двигайте картинку, чтобы выбрать кадр": "Verschieben Sie das Bild, um den Bildausschnitt auszuwählen",
  "Диафрагма": "Blende",
  "Добавить человека": "Person hinzufügen",
  "Добавьте описание, от 10 знаков": "Fügen Sie eine Beschreibung mit mindestens 10 Zeichen hinzu",
  "Загрузите фото": "Foto hochladen",
  "Заполните обязательные поля": "Füllen Sie die Pflichtfelder aus",
  "Изменить фото": "Foto ändern",
  "Использовать выбранное фото результата": "Ausgewähltes Ergebnisfoto verwenden",
  "Кадр": "Bild",
  "Кадрирование": "Zuschnitt",
  "Как у фото": "Wie auf dem Foto",
  "Камера": "Kamera",
  "Найти настройку съёмки": "Aufnahmeeinstellung finden",
  "Найти стиль": "Stil finden",
  "Настройки съёмки недоступны.": "Aufnahmeeinstellungen sind nicht verfügbar.",
  "Начать новое улучшение": "Neue Verbesserung starten",
  "Не выбран": "Nicht ausgewählt",
  "Не удалось восстановить улучшение. Новая отправка заблокирована.": "Die Verbesserung konnte nicht wiederhergestellt werden. Eine erneute Übermittlung ist gesperrt.",
  "Не удалось загрузить режимы фото.": "Fotomodi konnten nicht geladen werden.",
  "Не удалось загрузить фото.": "Foto konnte nicht geladen werden.",
  "Не удалось использовать фото результата. Откройте исходный заказ и попробуйте снова.": "Das Ergebnisfoto konnte nicht verwendet werden. Öffnen Sie den ursprünglichen Auftrag und versuchen Sie es erneut.",
  "Не удалось открыть режим. Попробуйте ещё раз.": "Modus konnte nicht geöffnet werden. Versuchen Sie es erneut.",
  "Не удалось передать выбранное фото. Попробуйте снова.": "Das ausgewählte Foto konnte nicht übermittelt werden. Versuchen Sie es erneut.",
  "Не удалось проверить владельца.": "Besitzverhältnisse konnten nicht überprüft werden.",
  "Не удалось прочитать фото.": "Foto konnte nicht gelesen werden.",
  "Не удалось улучшить текст. Исходный текст сохранён.": "Text konnte nicht verbessert werden. Der Originaltext wurde beibehalten.",
  "О стиле": "Über den Stil",
  "Объектив": "Objektiv",
  "Оживить фото": "Foto animieren",
  "Описание во весь экран": "Beschreibung im Vollbild",
  "Описание длиннее допустимого": "Beschreibung ist zu lang",
  "По вертикали": "Vertikal",
  "По горизонтали": "Horizontal",
  "По описанию": "Nach Beschreibung",
  "Повторить прежнее улучшение": "Vorherige Verbesserung wiederholen",
  "Подтвердите права на материалы": "Bestätigen Sie, dass Sie die Rechte an den Materialien besitzen",
  "Пример": "Beispiel",
  "Проверить улучшение": "Verbesserung überprüfen",
  "Проверяем фото…": "Foto wird überprüft…",
  "Ракурс": "Blickwinkel",
  "Раскрасить чёрно-белое": "Schwarz-Weiß-Foto kolorieren",
  "Режим фото": "Fotomodus",
  "Референс должен быть не меньше 256 × 256 пикселей.": "Die Referenz muss mindestens 256 × 256 Pixel groß sein.",
  "Свернуть": "Einklappen",
  "Свет": "Licht",
  "Свой референс": "Eigene Referenz",
  "Свой референс сейчас недоступен": "Eigene Referenz ist derzeit nicht verfügbar",
  "Сделать рилс": "Reel erstellen",
  "Сколько фото": "Anzahl der Fotos",
  "Создать фото": "Foto erstellen",
  "Создаём фото": "Foto wird erstellt",
  "Срок проверки улучшения истёк. Исходный текст сохранён.": "Die Frist für die Überprüfung der Verbesserung ist abgelaufen. Der Originaltext wurde beibehalten.",
  "Тема стиля": "Stilthema",
  "Убрать из кадра": "Aus dem Bild entfernen",
  "Улучшение пока не подтверждено. Исходный текст сохранён.": "Die Verbesserung wurde noch nicht bestätigt. Der Originaltext wurde beibehalten.",
  "Улучшить": "Verbessern",
  "Формат файла": "Dateiformat",
  "Фото готовы": "Fotos sind fertig",
  "Фото на аватарку": "Profilfoto",
  "Фото не создано": "Foto wurde nicht erstellt",
  "Цвет": "Farbe",
  "Что дальше": "Wie geht es weiter?",
  "Что делает в кадре": "Was im Bild getan wird",
  "Выберите разных людей в кадре": "Wähle unterschiedliche Personen für das Bild",
  "Измените описание и попробуйте улучшить его снова.": "Ändere die Beschreibung und versuche erneut, sie zu verbessern.",
  "Использовать референс": "Referenz verwenden",
  "Авто": "Auto",
  "Без движения": "Ohne Bewegung",
  "Видео должно длиться не меньше секунды": "Das Video muss mindestens eine Sekunde dauern",
  "Выберите главное фото": "Hauptfoto auswählen",
  "Выберите один исходный файл": "Eine Quelldatei auswählen",
  "Выберите файл подходящего формата и размера": "Datei mit unterstütztem Format und Größe auswählen",
  "Выберите фрагмент от 1 до 10 секунд": "Ausschnitt von 1 bis 10 Sekunden wählen",
  "Главное фото": "Hauptfoto",
  "Длительность исходника: {0} с": "Quelldauer: {0} s",
  "Добавить речь": "Sprache hinzufügen",
  "Загрузите видео": "Video hochladen",
  "Загрузите фото или видео": "Foto oder Video hochladen",
  "Загрузить": "Hochladen",
  "Загрузить видео": "Video hochladen",
  "Загрузить фото": "Foto hochladen",
  "Звук исходника не сохраняется: модель создаёт новый звук.": "Der Originalton bleibt nicht erhalten: das Modell erzeugt neuen Ton.",
  "Звук от модели": "Vom Modell erzeugter Ton",
  "Звук создаёт модель: фон, шумы и музыка. Речь можно добавить после создания.": "Das Modell erzeugt Hintergrundton, Geräusche und Musik. Sprache lässt sich danach hinzufügen.",
  "Использовать видео результата": "Ergebnisvideo verwenden",
  "Исходное видео": "Quellvideo",
  "Исходный файл": "Quelldatei",
  "Как двигаться": "Wie soll es sich bewegen",
  "Конец фрагмента, мс": "Ausschnittende, ms",
  "Конец, секунды": "Ende, Sekunden",
  "Люди в кадре недоступны для этого режима": "Personen im Bild sind in diesem Modus nicht verfügbar",
  "Начало фрагмента, мс": "Ausschnittbeginn, ms",
  "Начало, секунды": "Beginn, Sekunden",
  "Не удалось загрузить режимы видео.": "Videomodi konnten nicht geladen werden.",
  "Не удалось использовать видео результата. Откройте исходный заказ и попробуйте снова.": "Das Ergebnisvideo konnte nicht verwendet werden. Öffne den ursprünglichen Auftrag und versuche es erneut.",
  "Не удалось передать видео. Откройте исходный заказ и попробуйте снова.": "Video konnte nicht übertragen werden. Öffne den ursprünglichen Auftrag und versuche es erneut.",
  "Новое": "Neu",
  "Объёмное фото создаётся без звука": "Das Parallax-Video wird ohne Ton erstellt",
  "Первый кадр": "Erstes Bild",
  "Продолжить загрузку": "Upload fortsetzen",
  "Разрешение": "Auflösung",
  "Режим видео": "Videomodus",
  "Снимем из главного фото. Выберите главное фото для кадрирования.": "Wir verwenden das Hauptfoto. Wähle das Hauptfoto zum Zuschneiden aus.",
  "Снять": "Aufnehmen",
  "Снять видео": "Video aufnehmen",
  "Создать видео": "Video erstellen",
  "Темп": "Tempo",
  "Формат задаёт инструмент: портрет 3:4, ролик на 5 секунд": "Festes Format: Hochformat 3:4, 5 Sekunden Video",
  "Фото товара": "Produktfotos",
  "Фрагмент от 1 до 10 секунд": "Ausschnitt von 1 bis 10 Sekunden",
  "Хит": "Beliebt",
  "Что изменить": "Was soll geändert werden",
  "Этот режим видео пока недоступен": "Dieser Videomodus ist derzeit nicht verfügbar",
  "Как у исходника": "Wie die Quelle",
  "Со звуком": "Mit Ton",
  "Без звука": "Ohne Ton",
  "5 секунд": "5 Sekunden",
  "10 секунд": "10 Sekunden",
  "Не удалось прочитать файл.": "Die Datei konnte nicht gelesen werden.",
  "1. Видео с вами": "1. Video von dir",
  "1. Видео с движениями": "1. Bewegungsvideo",
  "2. Кем стать": "2. Wer möchtest du werden",
  "2. Кто повторит": "2. Wer wiederholt es",
  "Видео должно длиться не меньше {0} секунд": "Das Video muss mindestens {0} Sekunden dauern",
  "Водяной знак — недоступен": "Wasserzeichen – nicht verfügbar",
  "Вы, близкий или персонаж": "Du, eine nahestehende Person oder eine Figur",
  "Выберите допустимый фрагмент видео": "Wähle einen Ausschnitt mit zulässiger Dauer",
  "Выберите одного героя": "Wähle eine Figur",
  "Выберите фон": "Hintergrund auswählen",
  "Выберите, кто повторит движения": "Wähle, wer die Bewegungen wiederholt",
  "Голос героя — недоступен": "Figurenstimme – nicht verfügbar",
  "Другой голос — недоступен": "Andere Stimme – nicht verfügbar",
  "Загрузите видео с движениями": "Lade ein Bewegungsvideo hoch",
  "Из видео": "Aus dem Video",
  "Изменить людей и свои фото": "Personen und eigene Fotos verwalten",
  "Источник героя": "Quelle der Figur",
  "Исходный звук сохраняется, если он есть в ролике.": "Der Originalton bleibt erhalten, sofern das Video eine Tonspur hat.",
  "Кадр, ракурс и фон берутся с фото героя.": "Bildausschnitt, Perspektive und Hintergrund stammen vom Foto der Figur.",
  "Кто повторит движения": "Wer wiederholt die Bewegungen",
  "На фото должны быть видны голова, плечи и корпус.": "Auf dem Foto müssen Kopf, Schultern und Oberkörper sichtbar sein.",
  "Нужен один человек в кадре. На фото и видео должны быть видны голова, плечи и корпус.": "Im Bild muss eine Person sein. Foto und Video müssen Kopf, Schultern und Oberkörper zeigen.",
  "Подтвердите права и согласие человека": "Bestätige die Rechte und die Einwilligung der Person",
  "Подтверждаю права на материалы и согласие человека на использование его изображения": "Ich bestätige meine Rechte am Material und die Einwilligung der Person zur Nutzung ihres Bildes",
  "Преобразование в кружок недоступно: в результате нет подтверждённой звуковой дорожки.": "Die Umwandlung in ein rundes Video ist nicht verfügbar: Das Ergebnis hat keine bestätigte Tonspur.",
  "Режим движения": "Bewegungsmodus",
  "С героя": "Von der Figur",
  "Смена голоса пока недоступна": "Stimmenwechsel ist derzeit nicht verfügbar",
  "Снять выбор": "Auswahl aufheben",
  "Сохранение исходного звука не подтверждено.": "Die Beibehaltung des Originaltons ist nicht bestätigt.",
  "Стать персонажем": "Zur Figur werden",
  "Сцена и движения берутся из видео; внешность может отличаться.": "Szene und Bewegungen stammen aus dem Video; das Aussehen kann abweichen.",
  "Только свои фото или с согласием человека на фото": "Nur eigene Fotos oder mit Einwilligung der abgebildeten Person",
  "Фон": "Hintergrund",
  "Фото героя": "Foto der Figur",
  "Фрагмент от {0} до {1} секунд": "Ausschnitt von {0} bis {1} Sekunden",
  "{0} символов": "{0} Zeichen",
  "Авито": "Avito",
  "Английский": "Englisch",
  "Выберите аудио или видео": "Audio oder Video wählen",
  "Выбрать": "Auswählen",
  "Гарантия": "Garantie",
  "Да": "Ja",
  "Для чего нужен промпт": "Zweck des Prompts",
  "Для этого инструмента сократите текст до 500 символов.": "Kürze den Text für dieses Werkzeug auf 500 Zeichen.",
  "Добавьте текст": "Text hinzufügen",
  "Добавьте файл": "Datei hinzufügen",
  "Дополнительные варианты": "Weitere Varianten",
  "Дополнительные варианты пока не подтверждены.": "Weitere Varianten sind noch nicht bestätigt.",
  "Дружелюбный": "Freundlich",
  "Загрузите запись или запишите голос. Распознавание начнётся после подтверждения.": "Lade eine Aufnahme hoch oder nimm deine Stimme auf. Die Transkription beginnt nach der Bestätigung.",
  "Исходное фото": "Ausgangsfoto",
  "Как изменить текст": "Text anpassen",
  "Комплект": "Lieferumfang",
  "Короткий": "Kurz",
  "Материал": "Material",
  "Музыка": "Musik",
  "На весь экран": "Vollbild",
  "Не удалось открыть инструмент. Проверьте аккаунт и длину текста.": "Das Werkzeug konnte nicht geöffnet werden. Prüfe Konto und Textlänge.",
  "Не удалось подтвердить дополнительные варианты. Проверьте тот же запрос.": "Weitere Varianten konnten nicht bestätigt werden. Prüfe dieselbe Anfrage.",
  "Не удалось скачать текст.": "Der Text konnte nicht heruntergeladen werden.",
  "Не удалось скопировать текст.": "Der Text konnte nicht kopiert werden.",
  "Не удалось сохранить черновик. Создание заблокировано, чтобы не потерять данные.": "Der Entwurf konnte nicht gespeichert werden. Die Erstellung ist zum Schutz der Daten gesperrt.",
  "Нейтральный": "Neutral",
  "Нет": "Nein",
  "Объём описания": "Beschreibungslänge",
  "Описание товара": "Produktbeschreibung",
  "Повторить запрос с тем же ключом": "Mit demselben Schlüssel wiederholen",
  "Подарочный": "Geschenk",
  "Подробнее": "Ausführlicher",
  "Подробный": "Ausführlich",
  "Подтверждаю права на материалы": "Ich bestätige meine Rechte am Material",
  "Пожелания": "Wünsche",
  "Показать время": "Zeitangaben anzeigen",
  "Показать всё": "Alles anzeigen",
  "Премиальный": "Premium",
  "Проверить тот же запрос": "Dieselbe Anfrage prüfen",
  "Продающий": "Verkaufsorientiert",
  "Промпт из видео пока недоступен.": "Ein Prompt aus Video ist noch nicht verfügbar.",
  "Промпт из фото": "Prompt aus Foto",
  "Разделить по собеседникам": "Sprecher trennen",
  "Размеры": "Maße",
  "Распознавание по ссылке YouTube пока недоступно.": "Transkription über YouTube-Links ist noch nicht verfügbar.",
  "Распознать": "Transkribieren",
  "Редактировать текст": "Text bearbeiten",
  "Сайт": "Website",
  "Сбросить сохранённый черновик": "Gespeicherten Entwurf zurücksetzen",
  "Скачать TXT": "TXT herunterladen",
  "Скопировать весь текст": "Gesamten Text kopieren",
  "Собеседник {0}": "Sprecher {0}",
  "Создать промпт": "Prompt erstellen",
  "Создать сценарий": "Skript erstellen",
  "Создаём текст": "Text wird erstellt",
  "Сократите пожелания": "Kürze die Wünsche",
  "Сократите текст": "Text kürzen",
  "Список": "Liste",
  "Текст готов": "Text ist fertig",
  "Текст из аудио и видео": "Text aus Audio und Video",
  "Текст не создан": "Text wurde nicht erstellt",
  "Тестовый режим без списания": "Testmodus ohne Abbuchung",
  "Тон описания": "Ton der Beschreibung",
  "Улучшить промпт": "Prompt verbessern",
  "Уход": "Pflege",
  "Что добавить в описание": "Was zur Beschreibung hinzufügen",
  "Экспертный": "Fachlich",
  "Язык": "Sprache",
  "Яндекс Маркет": "Yandex Market",
  "Добавьте фото в открывшемся инструменте.": "Füge im geöffneten Werkzeug ein Foto hinzu.",
  "Не удалось открыть фото.": "Das Foto konnte nicht geöffnet werden.",
  "Текст для видео": "Text für das Video",
  "Цена этого выбора пока не подтверждена": "Der Preis für diese Auswahl ist noch nicht bestätigt",
  "C за фото": "C pro Foto",
  "C за секунду": "C pro Sekunde",
  "Обычный": "Standard",
  "Кто повторил": "Nachgeahmt von",
  "Человек с фото": "Person vom Foto",
  "Сменить фон": "Hintergrund ändern",
  "Убрать лишнее": "Störendes entfernen",
  "Добавить очки": "Brille hinzufügen",
  "Причёска": "Frisur",
  "Улыбка": "Lächeln",
  "Деловой образ": "Business-Look",
  "Летний фон": "Sommerhintergrund",
  "Машет рукой": "Winkt",
  "Ветер": "Wind",
  "Плавнее": "Flüssiger",
  "Ярче": "Heller",
  "День в ночь": "Tag zu Nacht",
  "Снег": "Schnee",
  "Очки": "Brille",
  "Что должно быть на фото? Например: девушка с зонтом на мокрой улице, вечер, огни витрин": "Was soll auf dem Foto sein? Zum Beispiel: ein Mädchen mit Regenschirm auf einer nassen Straße, Abend, Lichter der Schaufenster",
  "Что поменять на фото? Например: замени фон на ночной город, добавь очки": "Was soll auf dem Foto geändert werden? Zum Beispiel: Hintergrund durch eine nächtliche Stadt ersetzen, Brille hinzufügen",
  "Что добавить или поменять? Например: деловой костюм, лёгкая улыбка": "Was soll hinzugefügt oder geändert werden? Zum Beispiel: ein Business-Anzug, ein leichtes Lächeln",
  "Что происходит в ролике? Например: камера медленно летит над ночным городом, огни и мокрый асфальт": "Was passiert im Video? Zum Beispiel: Die Kamera fliegt langsam über eine nächtliche Stadt, Lichter und nasser Asphalt",
  "Как двигаться? Например: улыбается и машет рукой, ветер в волосах": "Wie soll es sich bewegen? Zum Beispiel: lächelt und winkt, Wind in den Haaren",
  "Что поменять в видео? Например: замени фон на ночной город, добавь снег": "Was soll im Video geändert werden? Zum Beispiel: Hintergrund durch eine nächtliche Stadt ersetzen, Schnee hinzufügen",
  "Что добавить? Например: движения плавнее, ярче": "Was soll hinzugefügt werden? Zum Beispiel: flüssigere Bewegungen, heller",
  "Сменить голос в записи": "Stimme in einer Aufnahme ändern",
  "Загрузите запись": "Laden Sie eine Aufnahme hoch",
  "Ваша речь зазвучит выбранным голосом": "Ihre Sprache klingt mit der gewählten Stimme",
  "Голосовое, интервью или заметку: уберём шум": "Sprachnachricht, Interview oder Notiz: Wir entfernen das Rauschen",
  "Библиотека и ваши клоны": "Bibliothek und Ihre Klone",
  "Без переозвучки, выберите другой": "Keine Stimmumwandlung, wählen Sie eine andere",
  "· Мой голос": "· Meine Stimme",
  "· ещё {0}+ голосов": "· {0}+ weitere Stimmen",
  "Убрать шум": "Rauschen entfernen",
  "Перед сменой голоса уберём фон и эхо": "Vor dem Stimmwechsel entfernen wir Hintergrund und Hall",
  "Оставим только голос, без фона и эха": "Wir behalten nur die Stimme, ohne Hintergrund und Hall",
  "Голосовым или файлом: выберете, когда запись будет готова": "Als Sprachnachricht oder Datei: Sie wählen, wenn die Aufnahme fertig ist",
  "Сменить голос": "Stimme ändern",
  "Сделать голосовым": "In Sprachnachricht umwandeln",
  "{0} · от {1} C": "{0} · ab {1} C",
  "Сначала остановите запись": "Beenden Sie zuerst die Aufnahme",
  "Загрузите или запишите аудио": "Laden Sie Audio hoch oder nehmen Sie es auf",
  "Читаем запись, секунду": "Aufnahme wird gelesen, einen Moment",
  "Запись длиннее {0}, загрузите короче": "Die Aufnahme ist länger als {0}, laden Sie eine kürzere hoch",
  "Выберите голос, которым зазвучит запись": "Wählen Sie die Stimme, mit der die Aufnahme klingen soll",
  "Этот голос не умеет переозвучку, выберите другой": "Diese Stimme unterstützt keine Stimmumwandlung, wählen Sie eine andere",
  "Пауза": "Pause",
  "Длиннее {0}": "Länger als {0}",
  "Звучит запись": "Aufnahme wird abgespielt",
  "Прослушать запись": "Aufnahme anhören",
  "Загрузите запись короче": "Laden Sie eine kürzere Aufnahme hoch",
  "Запись с микрофона": "Mikrofonaufnahme",
  "Без шума": "Ohne Rauschen",
  "Как в записи": "Wie in der Aufnahme",
  "Слушать": "Anhören",
  "Отправить голосовым": "Als Sprachnachricht senden",
  "Отправить файлом": "Als Datei senden",
  "Голосовое в чате": "Sprachnachricht im Chat",
  "Файл в чате": "Datei im Chat",
  "Голосовое в чате, в отдельной теме": "Sprachnachricht im Chat, in einem eigenen Thema",
  "Файл в чате, в отдельной теме": "Datei im Chat, in einem eigenen Thema",
  "Тут откроется тема чата, куда бот прислал голосовое": "Hier öffnet sich das Chat-Thema, in das der Bot die Sprachnachricht geschickt hat",
  "Тут откроется тема чата, куда бот прислал запись": "Hier öffnet sich das Chat-Thema, in das der Bot die Aufnahme geschickt hat",
  "Меняем голос": "Stimme wird geändert",
  "Собираем запись": "Aufnahme wird zusammengestellt",
  "Шум убран": "Rauschen entfernt",
  "Запись готова": "Die Aufnahme ist fertig",
  "Голос изменён": "Stimme geändert",
  "Можно уйти с экрана: бот напишет, когда запись будет готова.": "Sie können den Bildschirm verlassen: Der Bot schreibt Ihnen, wenn die Aufnahme fertig ist.",
  "Голос ваш, шума больше нет.": "Ihre Stimme, ohne Rauschen.",
  "Голос ваш, запись готова стать голосовым.": "Ihre Stimme – die Aufnahme ist bereit, zur Sprachnachricht zu werden.",
  "Слова и интонация ваши, голос новый.": "Ihre Worte und Ihre Betonung, eine neue Stimme.",
  "Пришлём в чат голосовым или файлом, как удобнее.": "Wir schicken es als Sprachnachricht oder Datei in den Chat, wie es Ihnen lieber ist.",
  "Запись ещё собирается": "Die Aufnahme wird noch zusammengestellt",
  "Заставить говорить": "Sprechen lassen",
  "Заменить запись": "Aufnahme ersetzen",
  "Загружаем запись": "Aufnahme wird hochgeladen",
  "Запись загружена": "Aufnahme hochgeladen",
  "Запись собрана": "Aufnahme zusammengestellt",
  "Запись не прошла проверку": "Die Aufnahme hat die Prüfung nicht bestanden",
  "запись не собрана": "die Aufnahme wurde nicht erstellt",
  "голос не изменён": "die Stimme wurde nicht geändert",
  "Не получилось убрать шум": "Das Rauschen konnte nicht entfernt werden",
  "Не получилось собрать запись": "Die Aufnahme konnte nicht erstellt werden",
  "Не получилось сменить голос": "Die Stimme konnte nicht geändert werden",
  "Обновить форму": "Formular aktualisieren",
  "Запись {0}": "Aufnahme {0}",
  "Проверяем доступность": "Verfügbarkeit wird geprüft",
  "Загрузите запись заново": "Laden Sie die Aufnahme erneut hoch",
  "Не удалось выбрать голос. Попробуйте ещё раз.": "Die Stimme konnte nicht ausgewählt werden. Versuchen Sie es erneut.",
  "Запись здесь недоступна, загрузите файл": "Aufnehmen ist hier nicht verfügbar, laden Sie eine Datei hoch",
  "Не удалось прочитать запись, попробуйте ещё раз": "Die Aufnahme konnte nicht gelesen werden, versuchen Sie es erneut",
  "Ваш голос": "Ihre Stimme",
  "в аудио": "im Audio",
  "со скидкой, {0} водяной знак": "mit Rabatt, Wasserzeichen {0}",
  "Запись ещё загружается": "Die Aufnahme wird noch geladen",
  "Проверяем отправку": "Versand wird geprüft",
  "Этот способ отправки сейчас недоступен": "Diese Versandart ist derzeit nicht verfügbar",
  "Отправка пока не подтверждена. Нажмите ещё раз — проверим тот же запрос.": "Der Versand ist noch nicht bestätigt. Tippen Sie erneut – wir prüfen dieselbe Anfrage.",
  "Не удалось передать запись. Откройте работу в «Истории» и попробуйте снова.": "Die Aufnahme konnte nicht übergeben werden. Öffnen Sie die Arbeit im „Verlauf“ und versuchen Sie es erneut.",
  "Попробовать ещё раз": "Erneut versuchen",
  "Проверить ещё раз": "Erneut prüfen",
  "К настройкам": "Zurück zu den Einstellungen",
  "Заказ не создан": "Bestellung nicht erstellt",
  "Заказ не подтверждён": "Bestellung nicht bestätigt",
  "остаток": "Restguthaben",
  "Права на материалы": "Rechte an den Materialien",
  "Только свои файлы или с согласия владельца": "Nur eigene Dateien oder mit Zustimmung des Inhabers",
  "Загружаем файл": "Datei wird hochgeladen",
  "Создаём": "Wird erstellt",
  "Файл больше {0} МБ, загрузите меньше": "Die Datei ist größer als {0} MB, laden Sie eine kleinere hoch",
  "Фото меньше {0} × {1} пикселей, загрузите крупнее": "Das Foto ist kleiner als {0} × {1} Pixel, laden Sie ein größeres hoch",
  "Видео длиннее {0}, загрузите короче": "Das Video ist länger als {0}, laden Sie ein kürzeres hoch",
  "Запись короче {0}, загрузите длиннее": "Die Aufnahme ist kürzer als {0}, laden Sie eine längere hoch",
  "Видео короче {0}, загрузите длиннее": "Das Video ist kürzer als {0}, laden Sie ein längeres hoch",
  "Не удалось открыть фото. Загрузите его заново.": "Das Foto konnte nicht geöffnet werden. Laden Sie es erneut hoch.",
  "Не удалось открыть видео. Загрузите его заново.": "Das Video konnte nicht geöffnet werden. Laden Sie es erneut hoch.",
  "Можно до {0} фото": "Bis zu {0} Fotos",
  "Этот человек не участвует": "Diese Person nimmt nicht teil",
  "Добавьте фото": "Fotos hinzufügen",
  "Файл не читается, загрузите другой": "Die Datei kann nicht gelesen werden, laden Sie eine andere hoch",
  "Запись слишком короткая": "Die Aufnahme ist zu kurz",
  "Не удалось открыть запись для прослушивания. Загрузите её заново.": "Die Aufnahme konnte nicht zum Anhören geöffnet werden. Laden Sie sie erneut hoch.",
  "Файл не прошёл проверку. Выберите другой файл.": "Die Datei hat die Prüfung nicht bestanden. Wählen Sie eine andere Datei.",
  "Слишком много загрузок подряд. Подождите минуту и выберите файл снова.": "Zu viele Uploads hintereinander. Warten Sie eine Minute und wählen Sie die Datei erneut.",
  "Файл не принят. Выберите его снова.": "Die Datei wurde nicht angenommen. Wählen Sie sie erneut.",
  "Выбранный персонаж, голос или шаблон стал недоступен. Выберите другой — заказ не создан.": "Die gewählte Figur, Stimme oder Vorlage ist nicht mehr verfügbar. Wählen Sie eine andere – die Bestellung wurde nicht erstellt.",
  "Создание сейчас недоступно. Заказ не создан, Circle не списаны.": "Das Erstellen ist derzeit nicht verfügbar. Die Bestellung wurde nicht erstellt, es wurden keine Circle abgebucht.",
  "Предыдущая работа ещё создаётся. Когда она будет готова, отправьте заказ снова.": "Die vorherige Arbeit wird noch erstellt. Wenn sie fertig ist, senden Sie die Bestellung erneut.",
  "Политику и запрещённые темы не пропускаем.": "Politik und verbotene Themen lassen wir nicht zu.",
  "{0} C списаны, {1}.": "{0} C wurden abgebucht, {1}.",
  "{0} C вернулись на баланс.": "{0} C wurden Ihrem Guthaben gutgeschrieben.",
  ", на шаге «{0}»": ", beim Schritt „{0}“",
  "Сбой на нашей стороне": "Fehler auf unserer Seite",
  "{0} или {1}": "{0} oder {1}",
  "до {0}": "bis {0}",
  "Записать": "Aufnehmen",
  "Заменить": "Ersetzen",
  "Нужна запись: MP3, WAV или M4A": "Benötigt wird eine Aufnahme: MP3, WAV oder M4A",
  "Нужно фото: JPG или PNG": "Benötigt wird ein Foto: JPG oder PNG",
  "Нужно видео: MP4 или MOV": "Benötigt wird ein Video: MP4 oder MOV",
  "Нужен файл PDF, DOCX или TXT": "Benötigt wird eine PDF-, DOCX- oder TXT-Datei",
  "Нужно фото или видео": "Benötigt wird ein Foto oder Video",
  "Файл больше {0} МБ": "Die Datei ist größer als {0} MB",
  "Остановить запись": "Aufnahme beenden",
  "Запрашиваем микрофон": "Mikrofon wird angefragt",
  "Отменить запись": "Aufnahme abbrechen",
  "{0} КБ": "{0} KB",
  "{0} МБ": "{0} MB",
  "Не хватает {0} C · Пополнить": "Es fehlen {0} C · Guthaben aufladen",
  "Не хватает Circle": "Nicht genügend Circle",
  "Не хватает {0} C": "Es fehlen {0} C",
  "На балансе {0} C, нужно {1} C": "Guthaben {0} C, benötigt {1} C",
  "Создать за {0} вместо {1} C": "Für {0} statt {1} C erstellen",
  "Создать за {0} C вместо {1} C": "Für {0} C statt {1} C erstellen",
  "Со скидкой всё равно не хватает {0}": "Auch mit Rabatt fehlen {0}",
  "Со скидкой всё равно не хватает {0} C": "Auch mit Rabatt fehlen {0} C",
  "Для этой работы скидки нет": "Für diese Arbeit gibt es keinen Rabatt",
  "Сделать дешевле на {0}%, с водяным знаком": "{0} % günstiger, mit Wasserzeichen",
  "Сделать дешевле на 10%, с водяным знаком": "10 % günstiger, mit Wasserzeichen",
  "Назад в студию": "Zurück zum Studio",
  "Работа ещё создаётся": "Die Arbeit wird noch erstellt",
  "Ваше фото": "Ihr Foto",
  "Ваши фото": "Ihre Fotos",
  "Ваш текст": "Ihr Text",
  "Ваша тема": "Ihr Thema",
  "Тема поста": "Thema des Beitrags",
  "Готовые кадры": "Fertige Aufnahmen",
  "Готовый кружок": "Fertiges Rundvideo",
  "Готовый ролик": "Fertiges Video",
  "Готовое фото": "Fertiges Foto",
  "Готовая аватарка": "Fertiger Avatar",
  "Готовые слайды": "Fertige Folien",
  "Готовый сюжет с вами: монтаж и музыка уже в шаблоне": "Eine fertige Story mit Ihnen: Schnitt und Musik sind schon in der Vorlage",
  "Пост в стиле шаблона, {0} на выбор": "Ein Beitrag im Stil der Vorlage, {0} zur Auswahl",
  "Аватарка для соцсетей и мессенджеров, {0} на выбор": "Ein Avatar für soziale Netzwerke und Messenger, {0} zur Auswahl",
  "Фотосессия из {0} кадра в стиле шаблона": "Ein Fotoshooting mit {0} Aufnahme im Stil der Vorlage",
  "Фотосессия из {0} кадров в стиле шаблона": "Ein Fotoshooting mit {0} Aufnahmen im Stil der Vorlage",
  "Ваш снимок оживёт в коротком ролике, {0} на выбор": "Ihr Foto erwacht in einem kurzen Video zum Leben, {0} zur Auswahl",
  "Персонаж скажет ваш текст в кружке Telegram, {0} на выбор": "Eine Figur spricht Ihren Text in einem Telegram-Rundvideo, {0} zur Auswahl",
  "Карусель слайдов для поста, {0} на выбор": "Ein Folienkarussell für den Beitrag, {0} zur Auswahl",
  "{0} стиль": "{0} Stil",
  "{0} стиля": "{0} Stile",
  "{0} стилей": "{0} Stile",
  "{0}, выберете на следующем шаге": "{0}, Auswahl im nächsten Schritt",
  "Что скажет герой, до 250 знаков": "Was die Figur sagt, bis zu 250 Zeichen",
  "1 фото": "1 Foto",
  "Любое, где хорошо видно лицо": "Jedes, auf dem das Gesicht gut zu sehen ist",
  "Лицо крупно и при хорошем свете": "Gesicht groß und bei gutem Licht",
  "Селфи, лицо крупно": "Ein Selfie, Gesicht groß",
  "Снимок оживёт в ролике": "Das Foto erwacht im Video zum Leben",
  "Или фото, из которых сделаем слайды": "Oder Fotos, aus denen wir Folien machen",
  "Стиль кружка": "Stil des Rundvideos",
  "1 человек": "1 Person",
  "Вы, близкие или персонаж": "Sie, Angehörige oder eine Figur",
  "Ваши дети, до {0}": "Ihre Kinder, bis zu {0}",
  "Ребёнок, одно фото": "Ein Kind, ein Foto",
  "Питомец, одно фото": "Ein Haustier, ein Foto",
  "Вы или близкие, одно фото": "Sie oder Angehörige, ein Foto",
  "По желанию: вы, близкие или персонаж": "Optional: Sie, Angehörige oder eine Figur",
  "По желанию: ваши дети, до {0}": "Optional: Ihre Kinder, bis zu {0}",
  "По желанию: ребёнок, одно фото": "Optional: ein Kind, ein Foto",
  "По желанию: питомец, одно фото": "Optional: ein Haustier, ein Foto",
  "По желанию: вы или близкие, одно фото": "Optional: Sie oder Angehörige, ein Foto",
  "Reels": "Reels",
  "Аватар": "Avatar",
  "{0} кадр": "{0} Aufnahme",
  "{0} кадра": "{0} Aufnahmen",
  "{0} кадров": "{0} Aufnahmen",
  "Выбрать, кто играет: {0}": "Wer spielt auswählen: {0}",
  "Сравнить: {0} и {1}": "Vergleichen: {0} und {1}",
  "Поровну": "Halb und halb",
  "Пример результата пока не опубликован": "Das Ergebnisbeispiel ist noch nicht veröffentlicht",
  "Результат сохранён в «Истории». В чат не отправляем — так выбрано в настройках.": "Das Ergebnis ist im „Verlauf“ gespeichert. Wir senden es nicht in den Chat – so ist es in den Einstellungen gewählt.",
  "Результат сохранён в «Истории».": "Das Ergebnis ist im „Verlauf“ gespeichert.",
  "Файл результата пока недоступен. Проверьте работу в «Истории».": "Die Ergebnisdatei ist noch nicht verfügbar. Prüfen Sie die Arbeit im „Verlauf“.",
  ", голос для: {0}": ", Stimme für: {0}",
  ", играет: {0}": ", spielt: {0}",
  ": добавьте свои фото": ": fügen Sie Ihre Fotos hinzu",
  ": добавьте фото": ": Fotos hinzufügen",
  "<b class=\"mono\">{0}</b> из <span class=\"mono\">{1}</span>": "<b class=\"mono\">{0}</b> von <span class=\"mono\">{1}</span>",
  "JPG или PNG, до 10 МБ": "JPG oder PNG, bis 10 MB",
  "JPG, PNG · до {0} снимков": "JPG, PNG · bis zu {0} Aufnahmen",
  "MP3, WAV или M4A, до 50 МБ": "MP3, WAV oder M4A, bis 50 MB",
  "MP4 или MOV, до 200 МБ": "MP4 oder MOV, bis 200 MB",
  "PDF, DOCX или TXT, до 20 МБ": "PDF, DOCX oder TXT, bis 20 MB",
  "{0} и {1}": "{0} und {1}",
  "{0} фото": "{0} Fotos",
  "{0} фото · как в жизни": "{0} Fotos · wie im echten Leben",
  "{0}, персонаж": "{0}, Figur",
  "Анфас, вполоборота, с улыбкой и без": "Frontal, im Halbprofil, mit und ohne Lächeln",
  "Без модели": "Ohne Model",
  "Без сильных теней и фильтров": "Ohne harte Schatten und Filter",
  "Было": "Vorher",
  "В близких": "Bei den Angehörigen",
  "В кадре {0}": "Im Bild: {0}",
  "В кадре уже {0} из {1}: снимите отметку с кого-нибудь": "Bereits {0} von {1} im Bild: Heben Sie eine Auswahl auf",
  "В кадре: {0}": "Im Bild: {0}",
  "В роли «{0}» не больше {1}": "In der Rolle „{0}“ höchstens {1}",
  "В роль «{0}» персонажи не входят": "Figuren passen nicht in die Rolle „{0}“",
  "В роль «{0}» подходят {1}": "Für die Rolle „{0}“ passen {1}",
  "Варианты делаются из ваших фото в разделе «Свой аватар». Выбранный встаёт в «Кто в кадре» на всех экранах.": "Varianten entstehen aus Ihren Fotos unter „Eigenes Avatarbild“. Die gewählte erscheint auf allen Seiten unter „Wer ist im Bild“.",
  "Ваш питомец из близких": "Ihr Haustier aus den Angehörigen",
  "Ваш ребёнок из близких": "Ihr Kind aus den Angehörigen",
  "Ваши фото: один раз для всех инструментов": "Ihre Fotos: einmal für alle Werkzeuge",
  "Вкл": "An",
  "Впишите имя": "Geben Sie einen Namen ein",
  "Все <span class=\"mono\">{0}</span>": "Alle <span class=\"mono\">{0}</span>",
  "Все варианты на виду": "Alle Optionen sind sichtbar",
  "Все персонажи": "Alle Figuren",
  "Вы и персонажи": "Sie und Figuren",
  "Вы или персонаж": "Sie oder eine Figur",
  "Вы, близкие и персонажи": "Sie, Angehörige und Figuren",
  "Вы, свои фото": "Sie, eigene Fotos",
  "Вы: добавьте свои фото": "Sie: Fügen Sie Ihre Fotos hinzu",
  "Выберите вариант": "Wählen Sie eine Variante",
  "Выберите вариант для поля «{0}»": "Wählen Sie eine Variante für das Feld „{0}“",
  "Выберите ниже": "Unten auswählen",
  "Выберите одного": "Wählen Sie eine Person",
  "Выберите, кто играет: {0}": "Wählen Sie, wer spielt: {0}",
  "Выберите, кто это для вас": "Wählen Sie, wer das für Sie ist",
  "Выбирать во всех инструментах без загрузки": "In allen Werkzeugen ohne erneutes Hochladen auswählen",
  "Выбор встанет во все инструменты": "Die Auswahl gilt für alle Werkzeuge",
  "Выбрать «{0}»": "„{0}“ auswählen",
  "Выбрать вариант": "Variante auswählen",
  "Выбрать: {0}": "Auswählen: {0}",
  "Выкл": "Aus",
  "Выключится, когда выберете вариант": "Schaltet sich aus, wenn Sie eine Option wählen",
  "Группы": "Gruppen",
  "Добавить": "Hinzufügen",
  "Добавить в кадр": "Ins Bild aufnehmen",
  "Добавьте свои фото": "Fügen Sie Ihre Fotos hinzu",
  "Добавьте свои фото или вариант": "Fügen Sie Ihre Fotos oder eine Variante hinzu",
  "Добавьте фото: {0}": "Fotos hinzufügen: {0}",
  "Другой голос": "Andere Stimme",
  "Ещё {0}: {1}": "{0} weitere: {1}",
  "Заготовки": "Vorlagen",
  "Загрузите файл": "Datei hochladen",
  "Загрузить ещё": "Weitere hochladen",
  "Закрыть камеру": "Kamera schließen",
  "Запись недоступна. Загрузите видео.": "Aufnahme nicht verfügbar. Laden Sie ein Video hoch.",
  "Здесь подходят {0}": "Hier passen {0}",
  "Здесь только персонажи своей подборки": "Hier nur Figuren aus der eigenen Sammlung",
  "Играет: {0}": "Spielt: {0}",
  "Из ваших фото": "Aus Ihren Fotos",
  "Из каталога": "Aus dem Katalog",
  "Изменить ваши фото": "Ihre Fotos bearbeiten",
  "Изменить свои фото": "Eigene Fotos bearbeiten",
  "Изменить: {0}": "Bearbeiten: {0}",
  "Иллюстрация": "Illustration",
  "Имя": "Name",
  "Имя и фото · роли выбираются в ряду": "Name und Fotos · Rollen werden in der Reihe gewählt",
  "Искать стиль": "Stil suchen",
  "Каким вы будете": "Wie Sie aussehen werden",
  "Камера · лицо в кадр": "Kamera · Gesicht ins Bild",
  "Камера · селфи в кадр": "Kamera · Selfie ins Bild",
  "Камера недоступна · имитация": "Kamera nicht verfügbar · Simulation",
  "Камера недоступна. Загрузите файл.": "Kamera nicht verfügbar. Laden Sie eine Datei hoch.",
  "Каталог 2 400+ голосов, подборки": "Katalog mit über 2.400 Stimmen, Sammlungen",
  "Ко всем стилям": "Zu allen Stilen",
  "Кто будет моделью на фото": "Wer ist das Model auf dem Foto",
  "Кто играет: <b>{0}</b>": "Wer spielt: <b>{0}</b>",
  "Кто играет: {0}": "Wer spielt: {0}",
  "Кто это для вас": "Wer ist das für Sie",
  "Лицо в круг, смотрите в камеру": "Gesicht in den Kreis, schauen Sie in die Kamera",
  "Люди": "Personen",
  "Можно близких или персонажа": "Angehörige oder eine Figur",
  "Можно ваших близких": "Ihre Angehörigen",
  "Можно до {0} видео": "Bis zu {0} Videos",
  "Можно до {0} записей": "Bis zu {0} Aufnahmen",
  "Можно до {0} записи": "Bis zu {0} Aufnahmen",
  "Можно до {0} запись": "Bis zu {0} Aufnahme",
  "Можно до {0} файл": "Bis zu {0} Datei",
  "Можно до {0} файла": "Bis zu {0} Dateien",
  "Можно до {0} файлов": "Bis zu {0} Dateien",
  "Можно и так, но 3 или больше снимков дадут сходство точнее": "Das geht, aber 3 oder mehr Aufnahmen treffen die Ähnlichkeit genauer",
  "Можно и так, но 3 или больше фото дадут сходство точнее": "Das geht, aber 3 oder mehr Fotos treffen die Ähnlichkeit genauer",
  "Можно себя или близких": "Sie selbst oder Angehörige",
  "Можно себя, близких или персонажа": "Sie selbst, Angehörige oder eine Figur",
  "На этом экране вы в кадре всегда": "Auf dieser Seite sind Sie immer im Bild",
  "Навсегда, вместе с фото": "Dauerhaft, zusammen mit den Fotos",
  "Нажмите, чтобы выбрать": "Tippen zum Auswählen",
  "Найти": "Suchen",
  "Напишите пару слов, и мы предложим варианты": "Schreiben Sie ein paar Worte, und wir schlagen Varianten vor",
  "Например: Барсик": "Zum Beispiel: Bello",
  "Например: Лёша": "Zum Beispiel: Alex",
  "Нашли": "Gefunden",
  "Не получилось подготовить файл": "Die Datei konnte nicht vorbereitet werden",
  "Не получилось улучшить. Попробуйте дописать пару слов": "Verbessern hat nicht geklappt. Ergänzen Sie ein paar Worte",
  "Не помещается<span class=\"nfx\">: до {0} знаков</span>": "Passt nicht<span class=\"nfx\">: bis zu {0} Zeichen</span>",
  "Необязательно: всё уже настроено": "Optional: Alles ist bereits eingestellt",
  "Ничего не нашлось": "Nichts gefunden",
  "Нужно выбрать": "Auswahl nötig",
  "Объём": "Tiefe",
  "Один раз для всех инструментов": "Einmal für alle Werkzeuge",
  "Отменить свой вариант": "Eigene Variante verwerfen",
  "Отметьте, кто будет в кадре · {0}": "Markieren Sie, wer im Bild sein wird · {0}",
  "Персонажи": "Figuren",
  "Подберём сами": "Wir wählen selbst",
  "Подбираем варианты": "Wir suchen Varianten",
  "Пожилой": "Senior",
  "Поиск стилей": "Stilsuche",
  "Пока нечего сохранять": "Noch nichts zu speichern",
  "Попробуйте другое слово": "Versuchen Sie ein anderes Wort",
  "Порядок здесь один": "Hier gibt es nur eine Reihenfolge",
  "Примеры": "Beispiele",
  "Пропадёт {0} вместе с фото. Вернуть не получится.": "Wird {0} zusammen mit den Fotos entfernt. Das lässt sich nicht rückgängig machen.",
  "Пропадёт из близких вместе с фото. Вернуть не получится.": "Wird zusammen mit den Fotos aus den Angehörigen entfernt. Das lässt sich nicht rückgängig machen.",
  "Пропадёт из близких и {0} вместе с фото. Вернуть не получится.": "Wird zusammen mit den Fotos aus den Angehörigen und {0} entfernt. Das lässt sich nicht rückgängig machen.",
  "Профиль близкого": "Profil der angehörigen Person",
  "Разные ракурсы и выражения": "Verschiedene Blickwinkel und Mimik",
  "Реалистичный": "Realistisch",
  "Реалистичный, иллюстрация или 3D": "Realistisch, Illustration oder 3D",
  "Роли": "Rollen",
  "Роль «{0}»": "Rolle „{0}“",
  "Роль «{0}» для женского персонажа": "Die Rolle „{0}“ ist für eine weibliche Figur",
  "Роль «{0}» для мужского персонажа": "Die Rolle „{0}“ ist für eine männliche Figur",
  "Роль «{0}» для персонажей своей подборки": "Die Rolle „{0}“ ist für Figuren aus ihrer Sammlung",
  "Свой вариант": "Eigene Variante",
  "Скачать здесь не получится": "Herunterladen ist hier nicht möglich",
  "Создайте новый вариант": "Erstellen Sie eine neue Variante",
  "Сортировка": "Sortieren",
  "Сохранится в близких": "Wird bei den Angehörigen gespeichert",
  "Сохранить в близких": "Bei den Angehörigen speichern",
  "Стало": "Nachher",
  "Только для этой фотосессии": "Nur für dieses Fotoshooting",
  "Удаление": "Löschen",
  "Удалить «{0}» {1}?": "„{0}“ {1} entfernen?",
  "Удалить «{0}» из близких?": "„{0}“ aus den Angehörigen entfernen?",
  "Удалить из близких": "Aus den Angehörigen entfernen",
  "Удалить из фотосессии": "Aus dem Fotoshooting entfernen",
  "Удерживайте, чтобы посмотреть примеры": "Gedrückt halten für Beispiele",
  "Управление": "Verwaltung",
  "Файл готов. Нажмите ещё раз": "Die Datei ist bereit. Tippen Sie noch einmal",
  "Фото до 10 МБ, видео до 200 МБ": "Fotos bis 10 MB, Videos bis 200 MB",
  "Фрагмент": "Ausschnitt",
  "Что делает? Например: поправляет шарф": "Was macht die Person? Zum Beispiel: richtet den Schal",
  "Что делают в кадре": "Was sie im Bild tun",
  "Эта настройка здесь закреплена": "Diese Einstellung ist hier festgelegt",
  "Этот голос не умеет переозвучку записи": "Diese Stimme kann keine Aufnahme neu vertonen",
  "вариант «{0}»": "Variante „{0}“",
  "взрослая": "erwachsen",
  "взрослый": "erwachsen",
  "всё видео умещается": "das ganze Video passt",
  "выберите": "auswählen",
  "до <span class=\"mono\">{0}</span>": "bis <span class=\"mono\">{0}</span>",
  "до {0} человек": "bis zu {0} Personen",
  "до {0} человека": "bis zu {0} Personen",
  "ещё {0} из {1}": "noch {0} von {1}",
  "женская роль": "weibliche Rolle",
  "из фотосессии": "aus dem Fotoshooting",
  "из этой фотосессии": "aus diesem Fotoshooting",
  "камера": "Kamera",
  "максимум {0} секунд": "maximal {0} Sekunden",
  "максимум {0} секунда": "maximal {0} Sekunde",
  "максимум {0} секунды": "maximal {0} Sekunden",
  "можно до <span class=\"mono\">{0}</span>": "bis zu <span class=\"mono\">{0}</span>",
  "мужская роль": "männliche Rolle",
  "не из подборки этой роли": "nicht aus der Sammlung dieser Rolle",
  "не подходит по возрасту": "passt vom Alter nicht",
  "не участвует в этой фотосессии": "ist nicht Teil dieses Fotoshootings",
  "необязательно": "optional",
  "нет фото": "keine Fotos",
  "нужно выбрать": "Auswahl nötig",
  "нужно: Вы": "nötig: Sie",
  "персонажи в эту роль не входят": "Figuren passen nicht in diese Rolle",
  "питомец": "Haustier",
  "по желанию": "nach Wunsch",
  "пожилая": "älter",
  "пожилой": "älter",
  "ребёнок": "Kind",
  "роль для взрослого": "Rolle für eine erwachsene Person",
  "роль для женщины": "Rolle für eine Frau",
  "роль для мужчины": "Rolle für einen Mann",
  "роль для питомца": "Rolle für ein Haustier",
  "роль для ребёнка": "Rolle für ein Kind",
  "роль для человека": "Rolle für einen Menschen",
  "Попробуйте другое слово или сбросьте тему": "Versuchen Sie ein anderes Wort oder setzen Sie das Thema zurück",
  "Искать среди {n}+ голосов": "{n}+ Stimmen durchsuchen",
  "Голосов: {n}": "Stimmen: {n}",
  "Персонажей: {n}": "Figuren: {n}",
  "Голосов: {0}": "Stimmen: {0}",
  "Прослушать {n}": "{n} anhören",
  "Загружаем ещё {n}": "{n} weitere werden geladen",
  "{a} из {b}": "{a} von {b}",
  "Подборка": "Sammlung",
  "Закрыть подборку": "Sammlung schließen",
  "По имени": "Nach Name",
  "Загружаем подборки…": "Sammlungen werden geladen …",
  "Не удалось загрузить голоса": "Stimmen konnten nicht geladen werden",
  "Не удалось воспроизвести пример. Попробуйте ещё раз.": "Hörprobe konnte nicht abgespielt werden. Versuche es noch einmal.",
  "Мой голос": "Meine",
  "Мои": "Meine",
  "Своих голосов пока нет": "Noch keine eigenen Stimmen",
  "Клонируйте свой голос, и он появится на этой вкладке.": "Klone deine Stimme, dann erscheint sie hier.",
  "Клонировать голос": "Stimme klonen",
  "Открыть персонажа {0}": "{0} öffnen",
  "От": "Ab",
  "Тренды недели": "Trends der Woche",
  "Голоса, которые быстрее всего набирают заказы": "Stimmen mit den am schnellsten wachsenden Aufträgen",
  "Мужские": "Männlich",
  "Все мужские голоса библиотеки": "Alle männlichen Stimmen der Bibliothek",
  "Женские": "Weiblich",
  "Все женские голоса библиотеки": "Alle weiblichen Stimmen der Bibliothek",
  "Детские": "Kinder",
  "Детские и мультяшные голоса": "Kinder- und Zeichentrickstimmen",
  "меню: Озвучка": "Stimmen",
  "Системная": "System",
  "Для аватарки и ленты": "Für Avatar und Feed",
  "Как снимок с телефона": "Wie ein Handyfoto",
  "Для ленты": "Für den Feed",
  "На весь экран телефона": "Ganzer Handybildschirm",
  "Для обложки и экрана": "Für Cover und Bildschirm",
  "Станет голосом по умолчанию для озвучки.": "Wird zur Standardstimme für Vertonungen.",
  "Когда генерация закончится": "Wenn die Generierung fertig ist",
  "Награды и серия": "Belohnungen und Serie",
  "Напомним о награде за день": "Erinnerung an die Tagesbelohnung",
  "Новые шаблоны и стили": "Neue Vorlagen und Stile",
  "Не чаще раза в неделю": "Höchstens einmal pro Woche",
  "Новости STEOS": "STEOS-News",
  "Только крупные обновления": "Nur große Updates",
  "Тут откроется документ в браузере": "Das Dokument öffnet sich im Browser",
  "Язык и валюта": "Sprache & Währung",
  "Интерфейс и цены картой": "Oberfläche und Kartenpreise",
  "новое|новых|новых": "neu|neu",
  "работа|работы|работ": "Werk|Werke",
  "заказ|заказа|заказов": "Auftrag|Aufträge",
  "Счётчики недоступны": "Zähler nicht verfügbar",
  "История пуста": "Verlauf ist leer",
  "Не задан": "Nicht festgelegt",
  "Недоступны": "Nicht verfügbar",
  "Срок истёк": "Abgelaufen",
  "Не удалась": "Fehlgeschlagen",
  "Готовится": "Wird vorbereitet",
  "Запрошено": "Angefordert",
  "Запрошено {0}": "Angefordert {0}",
  "Недоступно": "Nicht verfügbar",
  "Пусто": "Leer",
  "Данные Mini App удалены": "Mini-App-Daten gelöscht",
  "Удаление данных не удалось": "Löschen der Daten fehlgeschlagen",
  "Данные удалены частично": "Daten teilweise gelöscht",
  "Удаление требует проверки": "Löschung muss geprüft werden",
  "Запрос удаления принят": "Löschanfrage erhalten",
  "Удаляем данные Mini App": "Mini-App-Daten werden gelöscht",
  "Удаление данных в очереди": "Löschung in der Warteschlange",
  "STEOS ID сохранён": "STEOS ID bleibt erhalten",
  "Финансовые квитанции сохранены": "Zahlungsbelege bleiben erhalten",
  "Статус удаления не подтверждён": "Löschstatus nicht bestätigt",
  "Удаление аккаунта": "Konto löschen",
  "Удалить данные Mini App?": "Mini-App-Daten löschen?",
  "Удалить аккаунт?": "Konto löschen?",
  "Работы, голоса и варианты «Вы» в Mini App удалятся. STEOS ID и финансовые квитанции сохранятся.": "Werke, Stimmen und deine Looks in der Mini App werden gelöscht. STEOS ID und Zahlungsbelege bleiben erhalten.",
  "Работы, голоса, варианты «Вы» и Circle удалятся. Вернуть их не получится.": "Werke, Stimmen, deine Looks und Circle werden gelöscht. Das lässt sich nicht rückgängig machen.",
  "Удалить данные Mini App": "Mini-App-Daten löschen",
  "Удалить аккаунт": "Konto löschen",
  "Данные Mini App. STEOS ID сохранится": "Nur Mini-App-Daten. STEOS ID bleibt",
  "Все данные удалятся навсегда": "Alle Daten werden endgültig gelöscht",
  "В прототипе аккаунт не удаляется": "Im Prototyp wird das Konto nicht gelöscht",
  "Автовоспроизведение": "Autoplay",
  "Пример при выборе голоса": "Hörprobe bei der Stimmauswahl",
  "Присылать в чат": "In den Chat senden",
  "Готовые работы от бота": "Fertige Werke vom Bot",
  "Уведомления и отклик": "Mitteilungen & Haptik",
  "Данные": "Daten",
  "Выгрузить данные": "Daten exportieren",
  "Настройки создания сейчас только для чтения": "Erstellungseinstellungen sind gerade schreibgeschützt",
  "Формат по умолчанию": "Standardformat",
  "Для новых фото и видео": "Für neue Fotos und Videos",
  "На экране создания их можно поменять для одной работы.": "Auf dem Erstellungsbildschirm lässt es sich für ein Werk ändern.",
  "Сообщения приходят в чат с ботом": "Nachrichten kommen im Chat mit dem Bot an",
  "Бот напишет только в ответ на действия": "Der Bot schreibt nur als Antwort auf Aktionen",
  "Уведомления пока недоступны": "Mitteilungen sind noch nicht verfügbar",
  "Вибрация": "Vibration",
  "Лёгкий отклик на нажатия": "Leichtes Feedback beim Tippen",
  "Выгрузка данных": "Datenexport",
  "Выгрузка запрошена": "Export angefordert",
  "Пришлём архив в чат в течение суток": "Wir senden das Archiv innerhalb von 24 Stunden in den Chat",
  "Настройки и доступные текстовые данные аккаунта": "Einstellungen und verfügbare Textdaten des Kontos",
  "Ссылка на архив придёт в чат с ботом": "Der Archivlink kommt im Chat mit dem Bot",
  "Готовые работы и заказы": "Fertige Werke und Aufträge",
  "Клоны и записи образцов": "Klone und Hörproben-Aufnahmen",
  "Ваши фото и варианты себя": "Deine Fotos und Looks",
  "Люди и питомцы из фотосессий": "Menschen und Haustiere aus Fotoshootings",
  "Запросить выгрузку": "Export anfordern",
  "Готовим архив": "Archiv wird erstellt",
  "Это займёт несколько минут. Лист можно закрыть, выгрузка продолжится": "Das dauert ein paar Minuten. Du kannst das schließen, der Export läuft weiter",
  "Срок хранения архива истёк": "Das Archiv ist abgelaufen",
  "Запросите новую выгрузку данных": "Fordere einen neuen Datenexport an",
  "Архив не собрался": "Das Archiv konnte nicht erstellt werden",
  "Запросите выгрузку ещё раз": "Fordere den Export erneut an",
  "Не вошли: {0}": "Nicht enthalten: {0}",
  "Вошли частично: {0}": "Teilweise enthalten: {0}",
  "Не входят в выгрузку: {0}": "Nicht Teil des Exports: {0}",
  "Часть данных недоступна. Точный состав указан в manifest.json внутри архива": "Einige Daten fehlen. Den genauen Inhalt findest du in manifest.json im Archiv",
  "Архив готов, но не полностью": "Archiv fertig, aber unvollständig",
  "Архив готов": "Archiv fertig",
  "Скачать можно до {0}": "Herunterladen bis {0}",
  "Архив в формате ZIP": "ZIP-Archiv",
  "Скачать архив": "Archiv herunterladen",
  "Счётчики истории не загрузились": "Verlaufszähler nicht geladen",
  "Загружаем историю": "Verlauf wird geladen",
  "Проверьте связь и повторите загрузку": "Prüfe die Verbindung und versuche es erneut",
  "История очищена": "Verlauf gelöscht",
  "Голоса, варианты «Вы», близкие и Circle на месте": "Stimmen, Looks, Liebste und Circle bleiben",
  "Здесь появятся работы, когда вы что-то создадите": "Hier erscheinen deine Werke, sobald du etwas erstellst",
  "Раздел «История»": "Bereich „Verlauf“",
  "Работы": "Werke",
  "Фото, видео, кружки и озвучки": "Fotos, Videos, Kreise und Vertonungen",
  "Заказы": "Aufträge",
  "Параметры и статусы генераций": "Parameter und Status der Generierungen",
  "Голоса, варианты «Вы», близкие и Circle останутся.": "Stimmen, Looks, Liebste und Circle bleiben erhalten.",
  "Удалить работы и заказы": "Werke und Aufträge löschen",
  "Без возможности восстановления": "Kann nicht rückgängig gemacht werden",
  "Подтверждение удаления": "Löschen bestätigen",
  "Попробовать: {0}": "Ausprobieren: {0}",
  "Обновление": "Update",
  "Загружаем «Что нового»": "„Neuigkeiten“ werden geladen",
  "Новых обновлений пока нет": "Noch keine neuen Updates",
  "Уведомления сейчас не сохранить": "Mitteilungen lassen sich gerade nicht speichern",
  "Настройки сейчас только для чтения": "Einstellungen sind gerade schreibgeschützt",
  "Выгрузка не запросилась. Попробуйте ещё раз": "Export konnte nicht angefordert werden. Versuche es erneut",
  "Удалить всю историю?": "Gesamten Verlauf löschen?",
  "{0}. Вернуть не получится.": "{0}. Das lässt sich nicht rückgängig machen.",
  "История не очистилась. Попробуйте ещё раз": "Verlauf wurde nicht gelöscht. Versuche es erneut",
  "Удаление не началось. Попробуйте ещё раз": "Löschen hat nicht begonnen. Versuche es erneut",
  "Не удалось загрузить настройки": "Einstellungen konnten nicht geladen werden",
  "«Что нового» не загрузилось": "„Neuigkeiten“ wurden nicht geladen",
  "Сохранение настроек сейчас недоступно": "Speichern ist gerade nicht möglich",
  "Настройки уже изменились, показываем актуальные": "Einstellungen haben sich geändert, aktuelle werden angezeigt",
  "Не удалось сохранить. Попробуйте ещё раз": "Speichern fehlgeschlagen. Versuche es erneut",
  "Настройки, ресурсы и история": "Einstellungen, Ressourcen und Verlauf",
  "Данные Mini App": "Mini-App-Daten",
  "Учётная запись и финансовые данные STEOS ID": "STEOS-ID-Konto und Finanzdaten",
  "Переписка с ботом": "Chat mit dem Bot",
  "Фото, аудио, видео и модели": "Fotos, Audio, Videos und Modelle",
  "Данные других продуктов STEOS": "Daten anderer STEOS-Produkte",
  "Рубли": "Rubel",
  "Драмы": "Dram",
  "Евро": "Euro",
  "Доллары": "Dollar",
  "Другие языки": "Weitere Sprachen",
  "Интерфейс и сообщения бота": "Oberfläche und Bot-Nachrichten",
  "Цены картой покажем в этой валюте. Звёзды Telegram везде одинаковые.": "Kartenpreise werden in dieser Währung angezeigt. Telegram Stars sind überall gleich.",
  "сегодня, {0}": "heute, {0}",
  "вчера, {0}": "gestern, {0}",
  "Старт": "Start",
  "Плюс": "Plus",
  "Про": "Pro",
  "Картой или СБП": "Karte oder SBP",
  "СБП только для РФ": "SBP nur in Russland",
  "1 месяц": "1 Monat",
  "3 месяца": "3 Monate",
  "6 месяцев": "6 Monate",
  "Год": "Jahr",
  "год": "1 Jahr",
  "С днём рождения": "Alles Gute zum Geburtstag",
  "С днём рождения. Пусть всё задуманное получается с первого раза": "Alles Gute zum Geburtstag. Möge alles auf Anhieb gelingen",
  "Просто так": "Einfach so",
  "Просто так. Пусть у тебя будет больше кружков и смешных голосов": "Einfach so. Auf mehr Kreise und lustige Stimmen",
  "Спасибо": "Danke",
  "Спасибо, что ты рядом. Это маленький подарок от меня": "Danke, dass du da bist. Ein kleines Geschenk von mir",
  "С праздником": "Frohes Fest",
  "С праздником. Твори, снимай и удивляй": "Frohes Fest. Erschaffe, filme und begeistere",
  "Для блога": "Für deinen Blog",
  "Для твоего блога: пусть ролики выходят чаще и легче": "Für deinen Blog: mehr Videos, weniger Aufwand",
  "Удачи": "Viel Glück",
  "Удачи в новом проекте. Пусть голос и картинка будут такими, как задумано": "Viel Glück mit dem neuen Projekt. Mögen Stimme und Bild genau so werden wie geplant",
  "картой": "per Karte",
  "оплата картой каждый месяц": "monatlich per Karte",
  "оплата картой за {0}": "per Karte für {0}",
  "{0} в месяц": "{0} pro Monat",
  "{0} за {1}": "{0} für {1}",
  "кружок|кружка|кружков": "Videonachricht|Videonachrichten",
  "рилс|рилса|рилсов": "Reel|Reels",
  "свой голос|своих голоса|своих голосов": "eigene Stimme|eigene Stimmen",
  "своего голоса|своих голосов|своих голосов": "eigene Stimme|eigene Stimmen",
  "день|дня|дней": "Tag|Tage",
  "звезда|звезды|звёзд": "Stern|Sterne",
  "Подписаться на {0}": "Für {0} abonnieren",
  "Продлевается каждый месяц, отмена в любой момент": "Verlängert sich monatlich, jederzeit kündbar",
  "Без автопродления, Circle приходят каждый месяц": "Ohne automatische Verlängerung, Circle kommen monatlich",
  "Перейти на {0}": "Zu {0} wechseln",
  "Сразу придут {0} C, а {1} больше не продлится": "{0} C kommen sofort, {1} verlängert sich nicht mehr",
  "Сразу придут {0} C": "{0} C kommen sofort",
  "Перейти на {0} с {1}": "Ab {1} zu {0} wechseln",
  "До {0} остаётся {1}, потом {2}": "Bis {0} bleibt {1}, danach {2}",
  "Продлить на {0}": "Um {0} verlängern",
  "Ещё {0} после {1}, без автопродления": "Noch {0} nach dem {1}, ohne Verlängerung",
  "Следующее списание {0}, {1}": "Nächste Abbuchung {0}, {1}",
  "Способ оплаты": "Zahlungsart",
  "Звёздами": "Mit Sternen",
  "Тестовая оплата": "Testzahlung",
  "Звёзды и деньги не списываются": "Keine Sterne oder Geld werden abgebucht",
  "Оплата картой скоро": "Kartenzahlung kommt bald",
  "Ваш тариф": "Dein Tarif",
  "выгоднее на {0}%": "{0} % günstiger",
  "{0} C в месяц": "{0} C pro Monat",
  "или": "oder",
  "Что сотворим в этом месяце?": "Was erschaffst du diesen Monat?",
  "Готовы творить без пауз?": "Bereit, ohne Pause zu erschaffen?",
  "Ваш тариф {0}": "Dein Tarif: {0}",
  "{0} C каждый месяц": "{0} C jeden Monat",
  "До {0} {1}": "Bis zu {0} {1}",
  "Пакеты Circle, если не хватит": "Circle-Pakete, falls es nicht reicht",
  "{0} включает": "{0} enthält",
  "Сравнить": "Vergleichen",
  "Помесячно": "Monatlich",
  "Выгода {0}": "Spare {0}",
  "Одним платежом": "Einmalzahlung",
  "{0} с {1}": "{0} ab {1}",
  "Оставить {0}": "{0} behalten",
  "Продлить {0}": "{0} verlängern",
  "Продлить": "Verlängern",
  "Включить продление": "Verlängerung einschalten",
  "Возобновить {0}": "{0} fortsetzen",
  "Возобновить": "Fortsetzen",
  "Оплата пока не подключена": "Zahlung ist noch nicht verbunden",
  "Сейчас недоступно": "Gerade nicht verfügbar",
  "Переход на {0} на {1}": "Wechsel zu {0} für {1}",
  "Переход на {0}": "Wechsel zu {0}",
  "Продление {0} на {1}": "{0} um {1} verlängern",
  "Подписка {0} на {1}": "{0} für {1}",
  "Как удобнее оплатить": "Wie möchtest du zahlen?",
  "Подарок друга": "Geschenk vom Freund",
  "{0} на первый пакет {1} после подписки": "{0} auf dein erstes Paket, {1} nach dem Abo",
  "Не загрузилось": "Nicht geladen",
  "Прошлую операцию не проверить": "Letzter Vorgang lässt sich nicht prüfen",
  "разрешите хранение данных и откройте раздел снова": "erlaube die Datenspeicherung und öffne den Bereich erneut",
  "Оплата требует проверки": "Zahlung muss geprüft werden",
  "Исход подтверждения оплаты ещё неизвестен": "Ergebnis der Zahlungsbestätigung noch unbekannt",
  "Исход отмены счёта неизвестен": "Ergebnis der Rechnungsstornierung unbekannt",
  "Ждём подтверждения оплаты": "Warten auf Zahlungsbestätigung",
  "Исход прошлой операции неизвестен": "Ergebnis des letzten Vorgangs unbekannt",
  "проверьте его перед новой покупкой": "prüfe es vor einem neuen Kauf",
  "Проверить": "Prüfen",
  "Открыть оплату": "Zahlung öffnen",
  "Отменить счёт": "Rechnung stornieren",
  "Продление отменено": "Verlängerung storniert",
  "Сообщение со старым счётом может прийти. Оно не подтверждает новую подписку": "Eine Nachricht mit der alten Rechnung kann noch kommen. Sie bestätigt kein neues Abo",
  "Продление требует проверки": "Verlängerung muss geprüft werden",
  "Счёт не подтверждён. Обновите данные или обратитесь в поддержку": "Rechnung nicht bestätigt. Aktualisiere oder kontaktiere den Support",
  "Не удалось подготовить счёт": "Rechnung konnte nicht erstellt werden",
  "Сервер повторит проверку. Текущие права не меняются": "Der Server prüft erneut. Deine aktuellen Rechte bleiben",
  "Счёт отправлен": "Rechnung gesendet",
  "Бот прислал счёт. Подписка начнётся после подтверждённой оплаты": "Der Bot hat eine Rechnung gesendet. Das Abo startet nach bestätigter Zahlung",
  "Счёт подготовлен": "Rechnung erstellt",
  "Передан боту. Доставка и оплата ещё не подтверждены": "An den Bot übergeben. Zustellung und Zahlung noch nicht bestätigt",
  "Срок счёта истёк": "Rechnung abgelaufen",
  "Продление не оплачено. Выберите тариф ещё раз": "Verlängerung nicht bezahlt. Wähle den Tarif erneut",
  "Запланированное продление отменено": "Geplante Verlängerung storniert",
  "Текущий тариф не меняется. Для новой подписки потребуется отдельная оплата": "Dein Tarif bleibt. Für ein neues Abo ist eine separate Zahlung nötig",
  "Продление запланировано": "Verlängerung geplant",
  "Счёт на свою подписку придёт в конце подарочного месяца": "Die Rechnung für dein eigenes Abo kommt am Ende des Geschenkmonats",
  "Подарок ещё действует": "Geschenk ist noch aktiv",
  "Месячная подписка будет доступна после его окончания. Сейчас можно продлить на 3 или 12 месяцев": "Das Monatsabo ist danach verfügbar. Jetzt kannst du um 3 oder 12 Monate verlängern",
  "выберите другой тариф или срок": "wähle einen anderen Tarif oder Zeitraum",
  "−{0}% на первый пакет · ещё {1}": "−{0} % aufs erste Paket · noch {1}",
  "Circle из пакетов не сгорают": "Circle aus Paketen verfallen nicht",
  "Подарить другу": "Verschenken",
  "С открыткой, без продления": "Mit Karte, ohne Verlängerung",
  "Промокод {0}": "Promocode {0}",
  "{0} C, сгорят {1}": "{0} C, verfallen am {1}",
  "Промокод применён": "Promocode eingelöst",
  "{0} C и {1} на первый пакет": "{0} C und {1} aufs erste Paket",
  "после подписки": "nach dem Abo",
  "Вы пришли по ссылке партнёра": "Du kamst über einen Partnerlink",
  "привязка уже действует": "die Verknüpfung ist schon aktiv",
  "Есть промокод?": "Hast du einen Promocode?",
  "Загружаем тарифы": "Tarife werden geladen",
  "Счёт придёт {0}": "Die Rechnung kommt am {0}",
  "Счёт придёт в конце текущего срока": "Die Rechnung kommt am Ende des Zeitraums",
  "Новый тариф начнётся после оплаты. Сейчас ничего не списывается.": "Der neue Tarif startet nach der Zahlung. Jetzt wird nichts abgebucht.",
  "Оплата подтверждена": "Zahlung bestätigt",
  "Оплаченный период уже закончился. Circle за прошедший период не начисляются.": "Der bezahlte Zeitraum ist schon vorbei. Für vergangene Zeiträume gibt es keine Circle.",
  "Баланс пополнен": "Guthaben aufgeladen",
  "Теперь на балансе {0} C. Circle из пакетов не сгорают": "Dein Guthaben: {0} C. Circle aus Paketen verfallen nicht",
  "следующие {0} C придут {1}": "die nächsten {0} C kommen am {1}",
  "До этой даты действует {0}": "{0} gilt bis dahin",
  "{0} продлён до {1}": "{0} verlängert bis {1}",
  "Circle приходят каждый месяц, {0}": "Circle kommen monatlich, {0}",
  "Тариф {0} подключён": "Tarif {0} aktiviert",
  "Подписка {0} оформлена": "{0}-Abo abgeschlossen",
  "Оплачено до {0}. Circle приходят каждый месяц, {1}": "Bezahlt bis {0}. Circle kommen monatlich, {1}",
  "Тестовая подписка действует до {0}. Звёзды и деньги не списываются": "Testabo gültig bis {0}. Keine Sterne oder Geld werden abgebucht",
  "Circle действуют до {0}, тогда же следующее списание {1}": "Circle gültig bis {0}, dann nächste Abbuchung: {1}",
  "Circle действуют до {0}, продление выключено": "Circle gültig bis {0}, Verlängerung aus",
  "В месяц": "Pro Monat",
  "Кружки или фото": "Kreise oder Fotos",
  "Видео говорит": "Video spricht",
  "Рилсы": "Reels",
  "Сравнение тарифов": "Tarifvergleich",
  "В любом тарифе {0} {1} вместо {2}, все инструменты студии и пакеты Circle": "Jeder Tarif: {0} {1} statt {2}, alle Studio-Tools und Circle-Pakete",
  "Следующее списание": "Nächste Abbuchung",
  "Сумма": "Betrag",
  "Тестовая, без списаний": "Test, keine Abbuchung",
  "Картой": "Per Karte",
  "Оплачено до": "Bezahlt bis",
  "Действует до": "Gültig bis",
  "Потом": "Danach",
  "Продление": "Verlängerung",
  "Счёт на {0} запланирован": "Rechnung für {0} geplant",
  "подписку": "Abo",
  "Придёт {0}. Новый тариф начнётся после оплаты": "Kommt am {0}. Der neue Tarif startet nach der Zahlung",
  "Отменить": "Kündigen",
  "Отменить подписку": "Abo kündigen",
  "Тариф останется до {0}": "Der Tarif bleibt bis {0}",
  "Потом тариф {0}": "Danach {0}",
  "Подарок на месяц": "Geschenk für einen Monat",
  "Оплачено вперёд": "Im Voraus bezahlt",
  "Подписка {0}": "{0}-Abo",
  "Условия тарифа уточняются": "Tarifdetails werden geklärt",
  "Сменить тариф": "Tarif wechseln",
  "Отмена подписки": "Abo kündigen",
  "Этот переход сейчас недоступен": "Dieser Wechsel ist gerade nicht möglich",
  "Переход уже назначен": "Wechsel ist schon geplant",
  "Выберите другой тариф": "Wähle einen anderen Tarif",
  "С {0} начнётся этот тариф": "Dieser Tarif startet am {0}",
  "Это ваш тариф": "Das ist dein Tarif",
  "К подписке": "Zurück zum Abo",
  "Сейчас {0}, {1}": "Aktuell {0}, {1}",
  "Латиница, цифры и «_»": "Lateinische Buchstaben, Ziffern und _",
  "Ник начинается с буквы": "Muss mit einem Buchstaben beginnen",
  "Не короче 5 знаков": "Mindestens 5 Zeichen",
  "Не длиннее 32 знаков": "Höchstens 32 Zeichen",
  "Ник не кончается на _": "Darf nicht auf _ enden",
  "Это ваш ник": "Das ist dein Nutzername",
  "Сначала проверьте прежнюю операцию": "Prüfe zuerst den vorherigen Vorgang",
  "Подарок сейчас недоступен": "Verschenken ist gerade nicht möglich",
  "Укажите ник друга в Telegram": "Gib den Telegram-Nutzernamen ein",
  "Проверьте ник": "Prüfe den Nutzernamen",
  "Друг увидит: {0}": "Dein Freund sieht: {0}",
  "Подарок придёт без имени": "Das Geschenk kommt ohne Namen",
  "{0} дарит вам": "{0} schenkt dir",
  "вам подарили": "du hast bekommen",
  "Вам подарили": "Du hast bekommen",
  "{0} подписку STEOS {1} на месяц.": "{0} ein STEOS-{1}-Abo für einen Monat.",
  "Забрать подарок": "Geschenk abholen",
  "От друга": "Von einem Freund",
  "{0} C и {1} {2}": "{0} C und {1} {2}",
  "Подарить {0}": "{0} verschenken",
  "Тестовый подарок: звёзды и деньги не списываются": "Testgeschenk: keine Sterne oder Geld werden abgebucht",
  "На месяц, без продления": "Für einen Monat, ohne Verlängerung",
  "Тариф подарка": "Geschenktarif",
  "Кому": "An",
  "ник друга в Telegram": "Telegram-Name",
  "Ник друга в Telegram": "Telegram-Name des Freundes",
  "Пожелание": "Wunsch",
  "Пара тёплых слов, по желанию": "Ein paar nette Worte, optional",
  "Подписать от меня": "In meinem Namen",
  "Так увидит друг": "So sieht es dein Freund",
  "Подарок оформлен для {0}": "Geschenk für {0} erstellt",
  "Подарок отправлен {0}": "Geschenk an {0} gesendet",
  "Бот прислал открытку со ссылкой «Забрать подарок» в подписи.": "Der Bot hat eine Karte mit dem Link „Geschenk abholen“ gesendet.",
  "Месяц {0} начнётся, когда друг заберёт подарок": "Der {0}-Monat beginnt, wenn dein Freund es abholt",
  "Друг ещё не запускал STEOS? Перешлите открытку сами": "Dein Freund hat STEOS noch nicht geöffnet? Leite die Karte selbst weiter",
  "Переслать": "Weiterleiten",
  "Загружаем подарок": "Geschenk wird geladen",
  "Вам подарок": "Ein Geschenk für dich",
  "Подписка STEOS на месяц": "STEOS-Abo für einen Monat",
  "Этот подарок предназначен {0}. Перешлите получателю открытку со ссылкой.": "Dieses Geschenk ist für {0}. Leite die Karte mit dem Link weiter.",
  "Подарок уже получен": "Geschenk bereits abgeholt",
  "Подарок добавлен": "Geschenk hinzugefügt",
  "Подписка {0} подключена": "{0}-Abo aktiviert",
  "Circle подарка сгорят {0}": "Geschenk-Circle verfallen am {0}",
  "Месяц без продления, Circle действуют до {0}": "Ein Monat ohne Verlängerung, Circle gültig bis {0}",
  "У вас уже есть {0}: подарок добавит {1} C, они сгорят через месяц": "Du hast schon {0}: Das Geschenk bringt {1} C, die nach einem Monat verfallen",
  "Придут {0} C и {1} {2}. Подписка не продлится сама": "Du bekommst {0} C und {1} {2}. Es verlängert sich nicht automatisch",
  "За последние 7 дней": "Letzte 7 Tage",
  "Потрачено": "Ausgegeben",
  "Начислено": "Gutgeschrieben",
  "Пакеты пока недоступны": "Pakete sind noch nicht verfügbar",
  "Пакет": "Paket",
  "Оплата пакетов пока не подключена": "Paketzahlung ist noch nicht verbunden",
  "Введите промокод": "Promocode eingeben",
  "Применить": "Einlösen",
  "Промокод партнёра работает до первой покупки, промокод STEOS можно применить один раз": "Partnercodes gelten bis zum ersten Kauf, ein STEOS-Code einmal",
  "От партнёра или от STEOS": "Von einem Partner oder von STEOS",
  "Например, ANNA24": "Zum Beispiel ANNA24",
  "Не удалось загрузить операции": "Vorgänge konnten nicht geladen werden",
  "Начисление": "Gutschrift",
  "Списание": "Abbuchung",
  "Загружаем операции": "Vorgänge werden geladen",
  "Журнал STEOS ID": "STEOS-ID-Protokoll",
  "Операций пока нет": "Noch keine Vorgänge",
  "Применение не подтверждено. Проверьте прежний запрос": "Noch nicht bestätigt. Prüfe die vorherige Anfrage",
  "Отменить подписку?": "Abo kündigen?",
  "Тариф {0} останется до {1}, потом не продлится.": "{0} bleibt bis {1} und verlängert sich danach nicht.",
  "Оставить": "Behalten",
  "Не удалось подготовить открытку": "Karte konnte nicht vorbereitet werden",
  "Откройте Mini App в Telegram, чтобы переслать открытку": "Öffne die Mini App in Telegram, um die Karte weiterzuleiten",
  "Отправка отменена": "Senden abgebrochen",
  "Ссылка на подарок скопирована": "Geschenklink kopiert",
  "Не получилось. Попробуйте ещё раз": "Hat nicht geklappt. Versuche es erneut",
  "Счёт отменён": "Rechnung storniert",
  "Оплата не завершена": "Zahlung nicht abgeschlossen",
  "Подтверждение оплаты": "Zahlungsbestätigung",
  "Проверяем подтверждение оплаты": "Zahlungsbestätigung wird geprüft",
  "Проверяем отмену счёта": "Stornierung wird geprüft",
  "Telegram начал подтверждение счёта. Его исход ещё неизвестен. Не оплачивайте повторно: проверяйте этот счёт или обратитесь в поддержку.": "Telegram bestätigt die Rechnung gerade. Das Ergebnis ist noch offen. Nicht erneut zahlen: prüfe diese Rechnung oder kontaktiere den Support.",
  "Подарок будет оформлен после подтверждения сервера. Месяц подписки начнётся, когда друг заберёт подарок. Возврат из окна оплаты ещё не означает, что платёж завершён.": "Das Geschenk wird nach Serverbestätigung erstellt. Der Monat beginnt, wenn dein Freund es abholt. Die Rückkehr aus dem Zahlungsfenster heißt noch nicht, dass bezahlt ist.",
  "Circle поступят на баланс после подтверждения сервера. Возврат из окна оплаты ещё не означает, что платёж завершён.": "Circle kommen nach Serverbestätigung. Die Rückkehr aus dem Zahlungsfenster heißt noch nicht, dass bezahlt ist.",
  "Circle и подписка появятся после подтверждения сервера. Возврат из окна оплаты ещё не означает, что платёж завершён.": "Circle und Abo erscheinen nach Serverbestätigung. Die Rückkehr aus dem Zahlungsfenster heißt noch nicht, dass bezahlt ist.",
  "Не удалось открыть оплату. Проверьте прежний запрос": "Zahlung konnte nicht geöffnet werden. Prüfe die vorherige Anfrage",
  "Откройте Mini App в Telegram, чтобы оплатить звёздами": "Öffne die Mini App in Telegram, um mit Sternen zu zahlen",
  "Оплата ещё не подтверждена сервером": "Der Server hat die Zahlung noch nicht bestätigt",
  "Открытка готова. Откройте Mini App в Telegram, чтобы переслать её": "Die Karte ist fertig. Öffne die Mini App in Telegram, um sie weiterzuleiten",
  "Отменить счёт?": "Rechnung stornieren?",
  "Отменится только этот неоплаченный счёт. Текущая подписка останется. Если оплата уже подтверждается, сервер не разрешит отмену.": "Nur diese unbezahlte Rechnung wird storniert. Dein Abo bleibt. Wird die Zahlung bereits bestätigt, ist keine Stornierung möglich.",
  "Вернуться к оплате": "Zurück zur Zahlung",
  "{0} на первый пакет после подписки": "{0} aufs erste Paket nach dem Abo",
  "{0} на первый пакет, ещё {1}": "{0} aufs erste Paket, noch {1}",
  "{0} на первый пакет": "{0} aufs erste Paket",
  "Промокод {0} применён": "Promocode {0} eingelöst",
  "Circle сгорят {0}": "Circle verfallen am {0}",
  "Circle начислены": "Circle gutgeschrieben",
  "Привязка к партнёру подтверждена": "Partnerverknüpfung bestätigt",
  "Скидка {0}. Бонусные Circle сгорят {1}": "Rabatt: {0}. Bonus-Circle verfallen am {1}",
  "Привязка к партнёру действует": "Partnerverknüpfung aktiv",
  "{0} C и {1}": "{0} C und {1}",
  "Открытка передана боту для доставки.": "Die Karte wurde dem Bot zur Zustellung übergeben.",
  "Бот готовит доставку открытки. Можно переслать её самостоятельно.": "Der Bot bereitet die Zustellung vor. Du kannst die Karte auch selbst weiterleiten.",
  "Доставка открытки не подтверждена. Можно переслать её самостоятельно.": "Zustellung nicht bestätigt. Du kannst die Karte selbst weiterleiten.",
  "Сначала тратятся Circle со сроком: бонусные и по подписке, потом все остальные, а те, что можно вывести, в последнюю очередь.": "Zuerst werden Circle mit Ablaufdatum ausgegeben (Bonus und Abo), dann die übrigen; auszahlbare zuletzt.",
  "Получатель не найден среди пользователей STEOS. Проверьте ник или попросите друга запустить бота.": "Empfänger nicht unter STEOS-Nutzern gefunden. Prüfe den Namen oder bitte deinen Freund, den Bot zu starten.",
  "Условия оплаты изменились. Обновите данные.": "Die Zahlungsbedingungen haben sich geändert. Bitte aktualisieren.",
  "Эту открытку может переслать только отправитель подарка.": "Nur der Absender kann diese Karte weiterleiten.",
  "Откройте чат с ботом и попробуйте ещё раз.": "Öffne den Chat mit dem Bot und versuche es erneut.",
  "Доставка получателю не подтверждена. Перешлите открытку самостоятельно.": "Zustellung an den Empfänger nicht bestätigt. Leite die Karte selbst weiter.",
  "Предложение не найдено. Обновите данные.": "Angebot nicht gefunden. Bitte aktualisieren.",
  "Такого промокода нет": "Diesen Promocode gibt es nicht",
  "Срок действия промокода закончился": "Dieser Promocode ist abgelaufen",
  "Этот промокод пока не действует": "Dieser Promocode gilt noch nicht",
  "Вы уже активировали этот промокод": "Du hast diesen Promocode schon eingelöst",
  "Промокод больше не действует": "Dieser Promocode gilt nicht mehr",
  "Это ваш промокод": "Das ist dein eigener Promocode",
  "Партнёрские промокоды работают только до первой покупки": "Partnercodes gelten nur vor dem ersten Kauf",
  "Промокод партнёра временно недоступен": "Dieser Partnercode ist vorübergehend nicht verfügbar",
  "Вы уже привязаны к партнёру": "Du bist schon mit einem Partner verknüpft",
  "Получатель изменился. Отмените прежний неоплаченный счёт и проверьте ник перед новой покупкой.": "Der Empfänger hat sich geändert. Storniere die alte unbezahlte Rechnung und prüfe den Namen vor dem neuen Kauf.",
  "Пожелание должно быть не длиннее 200 знаков, без управляющих символов.": "Der Wunsch darf höchstens 200 Zeichen ohne Steuerzeichen haben.",
  "Проверьте ник: получатель должен запускать STEOS, нельзя дарить себе": "Prüfe den Namen: Der Empfänger muss STEOS gestartet haben, dir selbst kannst du nichts schenken",
  "Получатель сейчас занят. Повторите позже": "Der Empfänger ist gerade beschäftigt. Versuche es später",
  "Подарок не найден": "Geschenk nicht gefunden",
  "Этот подарок предназначен другому пользователю": "Dieses Geschenk ist für jemand anderen",
  "Не удалось подтвердить условия продления. Обновите тарифы.": "Verlängerungsbedingungen konnten nicht bestätigt werden. Aktualisiere die Tarife.",
  "Подписка изменилась. Обновите данные перед новым продлением.": "Dein Abo hat sich geändert. Aktualisiere vor der nächsten Verlängerung.",
  "Продление уже запланировано. Его можно отменить в управлении подпиской.": "Verlängerung ist schon geplant. Du kannst sie in der Abo-Verwaltung stornieren.",
  "Запланированное продление отменено. Обновите данные.": "Geplante Verlängerung storniert. Bitte aktualisieren.",
  "Счёт будет доступен в конце текущего срока.": "Die Rechnung ist am Ende des Zeitraums verfügbar.",
  "Месячная подписка будет доступна после окончания подарка. Сейчас можно продлить на 3 или 12 месяцев.": "Das Monatsabo ist nach dem Geschenk verfügbar. Jetzt kannst du um 3 oder 12 Monate verlängern.",
  "Предыдущее изменение подписки ещё проверяется. Повторите его проверку.": "Die vorherige Abo-Änderung wird noch geprüft. Prüfe sie erneut.",
  "Изменение подписки ещё не подтверждено Telegram.": "Telegram hat die Abo-Änderung noch nicht bestätigt.",
  "Подписка изменилась. Обновите данные и повторите проверку.": "Dein Abo hat sich geändert. Aktualisiere und prüfe erneut.",
  "Скидка уже закреплена за предыдущим счётом. Проверьте его оплату.": "Der Rabatt gehört schon zur vorherigen Rechnung. Prüfe deren Zahlung.",
  "Счёт уже подтверждается или недоступен для отмены. Проверьте результат оплаты.": "Die Rechnung wird schon bestätigt oder kann nicht storniert werden. Prüfe das Zahlungsergebnis.",
  "Оплата требует проверки. Сервер сохранил платёж; права пока не подтверждены. Не оплачивайте повторно — проверьте результат позже или обратитесь в поддержку.": "Die Zahlung muss geprüft werden. Der Server hat sie gespeichert, Rechte sind noch nicht bestätigt. Nicht erneut zahlen – später prüfen oder Support kontaktieren.",
  "Счёт отменён. Подписка и Circle по нему не начислены. Можно выбрать новую оплату.": "Rechnung storniert. Weder Abo noch Circle wurden gutgeschrieben. Du kannst neu bezahlen.",
  "Оплата не завершена. Деньги и Circle не подтверждены; можно начать новую оплату.": "Zahlung nicht abgeschlossen. Geld und Circle sind nicht bestätigt; du kannst neu bezahlen.",
  "Открытка готовится. Нажмите «Проверить», чтобы получить результат прежнего запроса.": "Die Karte wird vorbereitet. Tippe auf „Prüfen“, um das Ergebnis zu sehen.",
  "Подарить подписку": "Abo verschenken",
  "Оплата подписки": "Abo-Zahlung",
  "Итог оплаты": "Zahlungsergebnis",
  "Подарок": "Geschenk",
  "Пакет Circle": "Circle-Paket",
  "лента: Хит": "Top",
  "настройки: Очистить историю": "Verlauf löschen",
  "Разделы, которых нет в меню": "Bereiche außerhalb des Menüs",
  "Базовый": "Basis",
  "Продвинутый": "Fortgeschritten",
  "Амбассадор": "Botschafter",
  "задание ждёт|задания ждут|заданий ждут": "Aufgabe wartet|Aufgaben warten",
  ", до +{0} C": ", bis zu +{0} C",
  "Серия {0}, задания на сегодня": "Serie: {0}, Aufgaben für heute",
  "Задания на каждый день": "Tägliche Aufgaben",
  "Всё созданное в одном месте": "Alles Erstellte an einem Ort",
  "Пока пусто: всё созданное будет здесь": "Noch leer: Hier erscheint alles Erstellte",
  "{0}, последняя {1}": "{0}, zuletzt {1}",
  "тариф {0}": "Tarif {0}",
  "без подписки": "ohne Abo",
  "{0}, {1}% с покупок": "{0}, {1} % der Käufe",
  "{0} уровень, {1}% с покупок": "Stufe {0}, {1} % der Käufe",
  "До {0}% с покупок друзей": "Bis zu {0} % der Käufe von Freunden",
  "ИИ-агент ответит сразу": "KI-Agent antwortet sofort",
  "Черновики ролей и реплик": "Entwürfe von Rollen und Zeilen",
  "Тема, язык и валюта": "Design, Sprache & Währung",
  "{0} ждут": "{0} warten",
  "Тут Telegram откроет выбор чата: бот добавится в группу и будет работать там": "Hier öffnet Telegram die Chat-Auswahl: Der Bot kommt in die Gruppe und arbeitet dort",
  "голос {0}": "Stimme {0}",
  "Искать в {0} {1}": "In {0} {1} suchen",
  "работе|работах|работах": "Werk|Werken",
  "Не прошло модерацию": "Moderation nicht bestanden",
  "Бесплатно": "Kostenlos",
  "Цена недоступна": "Preis nicht verfügbar",
  "Не удалось загрузить историю": "Verlauf konnte nicht geladen werden",
  "Проверьте написание или поищите по номеру заказа": "Prüfen Sie die Schreibweise oder suchen Sie nach der Bestellnummer",
  "Проверьте написание или поищите по названию, голосу или персонажу": "Prüfen Sie die Schreibweise oder suchen Sie nach Titel, Stimme oder Figur",
  "Сбросить поиск": "Suche zurücksetzen",
  "В этой вкладке пока пусто": "Hier ist noch nichts",
  "Отмечайте работы сердцем в карточке, чтобы быстро находить их здесь": "Markieren Sie Werke mit dem Herz, um sie hier schnell zu finden",
  "Новые работы этого вида появятся здесь сами": "Neue Werke dieser Art erscheinen hier automatisch",
  "Показать все": "Alle anzeigen",
  "Поиск по истории": "Verlauf durchsuchen",
  "Что показать": "Anzeigen",
  "Кружки, фото, видео, озвучки и тексты, которые вы создадите": "Rundvideos, Fotos, Videos, Vertonungen und Texte, die Sie erstellen",
  "Открыть студию": "Studio öffnen",
  "{0}: шаг {1} из {2}. Открыть": "{0}: Schritt {1} von {2}. Öffnen",
  "Шаг {0} из {1}": "Schritt {0} von {1}",
  "{0}: {1}. Открыть": "{0}: {1}. Öffnen",
  "Раскладка": "Layout",
  "Широкий": "Breit",
  "Инструмент": "Werkzeug",
  "голос|голоса|голосов": "Stimme|Stimmen",
  "Как в оригинале": "Wie im Original",
  "фото|фото|фото": "Foto|Fotos",
  "слайд|слайда|слайдов": "Folie|Folien",
  "снимок|снимка|снимков": "Foto|Fotos",
  "кадр|кадра|кадров": "Bild|Bilder",
  "Длительность записи": "Aufnahmedauer",
  "Цена": "Preis",
  "Списание не подтверждено": "Abbuchung nicht bestätigt",
  "Кадры": "Bilder",
  "знак|знака|знаков": "Zeichen|Zeichen",
  "пункт|пункта|пунктов": "Punkt|Punkte",
  "фраза|фразы|фраз": "Phrase|Phrasen",
  "человек|человека|человек": "Person|Personen",
  "Смотреть видео": "Video ansehen",
  "символ|символа|символов": "Zeichen|Zeichen",
  "Дорожка": "Spur",
  "фрагмент 1:00": "Ausschnitt 1:00",
  "вся песня": "ganzer Song",
  "образец|образца|образцов": "Probe|Proben",
  "Свой голос": "Eigene Stimme",
  "{0} C списаны": "{0} C abgebucht",
  "Работа ещё создаётся. Результат появится здесь и придёт в чат": "Wird noch erstellt. Das Ergebnis erscheint hier und im Chat",
  "Проверяем результат. Обычно это занимает пару минут": "Wir prüfen das Ergebnis. Das dauert meist ein paar Minuten",
  "Не прошло модерацию. Политику и запрещённые темы не пропускаем, {0}": "Moderation nicht bestanden. Politik und verbotene Themen lassen wir nicht zu. {0}",
  "Не прошло модерацию. {0}": "Moderation nicht bestanden. {0}",
  "Не получилось. {0}": "Das hat nicht geklappt. {0}",
  "Не получилось. {0} C вернулись на баланс": "Das hat nicht geklappt. {0} C wurden Ihrem Guthaben gutgeschrieben",
  "Удалится только запись о заказе": "Nur der Bestelleintrag wird gelöscht",
  "Удаление из истории": "Aus dem Verlauf löschen",
  "Смотреть: {0}": "Ansehen: {0}",
  "В этой работе нет файлов для просмотра": "Dieses Werk hat keine Dateien zum Ansehen",
  "Вернуть запись в историю не получится.": "Der Eintrag kann nicht wiederhergestellt werden.",
  "Файл в чате останется. Вернуть работу в историю не получится.": "Die Datei bleibt im Chat. Das Werk kann nicht wiederhergestellt werden.",
  "Отправка пока не подтвердилась. Нажмите ещё раз": "Senden noch nicht bestätigt. Tippen Sie erneut",
  "Принято": "Angenommen",
  "Бот пришлёт результат в чат": "Der Bot schickt das Ergebnis in den Chat",
  "Возврат обрабатывается": "Erstattung läuft",
  "Не списано": "Nicht abgebucht",
  "Circle не списаны": "Keine Circle abgebucht",
  "Circle вернулись на баланс": "Circle wurden Ihrem Guthaben gutgeschrieben",
  "Списание пока не подтверждено": "Abbuchung noch nicht bestätigt",
  "Возврат не подтверждён": "Erstattung nicht bestätigt",
  "Ожидаем подтверждения оплаты": "Zahlung ausstehend",
  "история: Повторить": "Wiederholen",
  "история: Кружки": "Videonachrichten",
  "Фотосессия из селфи": "Fotoshooting aus Selfie",
  "Рилс с вами": "Reels mit Ihnen",
  "Фото говорит": "Foto spricht",
  "Слайды с преимуществами": "Vorteilsfolien",
  "Карусель для поста": "Karussell für einen Post",
  "Коллаж из фото": "Fotocollage",
  "Карточка для маркетплейса": "Marktplatz-Karte",
  "шаг|шага|шагов": "Schritt|Schritte",
  "вопрос|вопроса|вопросов": "Frage|Fragen",
  "Открыть": "Öffnen",
  "Ответ на этот вопрос не подтвердился. Если он важен, напишите в поддержку: {0}.": "Die Antwort auf diese Frage wurde nicht bestätigt. Wenn sie wichtig ist, schreiben Sie dem Support: {0}.",
  "Ответ на этот вопрос не подтвердился. Если он важен, напишите в поддержку.": "Die Antwort auf diese Frage wurde nicht bestätigt. Wenn sie wichtig ist, schreiben Sie dem Support.",
  "Ответ ещё не пришёл. Проверим этот же вопрос, второй раз он не задастся.": "Noch keine Antwort. Wir prüfen dieselbe Frage – sie wird nicht doppelt gestellt.",
  "Открыть профиль": "Profil öffnen",
  "Войти через STEOS ID": "Mit STEOS ID anmelden",
  "Тут Telegram откроет выбор чата": "Hier öffnet Telegram die Chatauswahl",
  "Разделы поддержки": "Support-Bereiche",
  "Ответит сразу": "Antwortet sofort",
  "Отвечает сразу": "Antwortet sofort",
  "Поддержка в Telegram, {0}": "Support in Telegram, {0}",
  "Поддержка в Telegram": "Support in Telegram",
  "Видео медленнее обычного": "Video ist langsamer als gewöhnlich",
  "Видео работает медленнее обычного": "Video läuft langsamer als gewöhnlich",
  "Спросить ИИ‑агента поддержки": "KI‑Support‑Agent fragen",
  "Отвечает сразу и знает всё о STEOS": "Antwortet sofort und weiß alles über STEOS",
  "Поиск по вопросам и инструкциям": "Fragen und Anleitungen suchen",
  "Шесть коротких сторис о главном": "Sechs kurze Storys zum Wichtigsten",
  "Попробуйте другие слова или спросите ИИ-агента": "Versuchen Sie andere Wörter oder fragen Sie den KI-Agenten",
  "Проверено в {0}": "Geprüft um {0}",
  "Заказы не теряются: результат придёт в чат, а если что-то сорвётся, Circle вернутся на баланс.": "Aufträge gehen nicht verloren: Das Ergebnis kommt im Chat an, und wenn etwas schiefgeht, gehen die Circle zurück auf Ihr Guthaben.",
  "Сервисы": "Dienste",
  "Загружаем статус сервисов": "Dienststatus wird geladen",
  "Загружаем справку": "Hilfe wird geladen",
  "Статус не загрузился": "Status wurde nicht geladen",
  "Статус сервисов пока не отслеживается": "Der Dienststatus wird noch nicht erfasst",
  "Если что-то не работает, напишите в поддержку": "Wenn etwas nicht funktioniert, schreiben Sie dem Support",
  "Часть сервисов работает с перебоями": "Einige Dienste haben Störungen",
  "Статусы ваших работ и подтверждённые возвраты смотрите в «Истории».": "Den Status Ihrer Werke und bestätigte Rückerstattungen finden Sie im „Verlauf“.",
  "Справка не загрузилась": "Hilfe wurde nicht geladen",
  "Справка пока не опубликована": "Die Hilfe ist noch nicht veröffentlicht",
  "Вопрос можно задать поддержке в Telegram": "Sie können Ihre Frage dem Support in Telegram stellen",
  "Инструкции появятся после публикации справки": "Anleitungen erscheinen, sobald die Hilfe veröffentlicht ist",
  "Назад к ИИ-агенту": "Zurück zum KI-Agenten",
  "Инструкция · {0}": "Anleitung · {0}",
  "Вопрос · {0}": "Frage · {0}",
  "Справка": "Hilfe",
  "Вопрос из Справки": "Frage aus der Hilfe",
  "Подробнее из Справки": "Mehr in der Hilfe",
  "Назад по таблице": "Tabelle zurückblättern",
  "Вперёд по таблице": "Tabelle vorblättern",
  "Здравствуйте, {0}.": "Hallo, {0}.",
  "Здравствуйте.": "Hallo.",
  "Я ИИ-агент поддержки STEOS: подскажу про тарифы и Circle, инструменты и шаблоны, промокоды, STEOS ID и партнёрство. Спросите своими словами или выберите вопрос.": "Ich bin der KI-Support-Agent von STEOS: Ich helfe bei Tarifen und Circle, Tools und Vorlagen, Promocodes, STEOS ID und dem Partnerprogramm. Fragen Sie in eigenen Worten oder wählen Sie eine Frage.",
  "ИИ-агент печатает": "Der KI-Agent schreibt",
  "ИИ-агент ещё отвечает": "Der KI-Agent antwortet noch",
  "Напишите вопрос": "Schreiben Sie eine Frage",
  "Диалог с ИИ-агентом": "Dialog mit dem KI-Agenten",
  "Распознаём…": "Wird erkannt…",
  "Слушаю": "Ich höre zu",
  "Спросите о STEOS": "Fragen Sie zu STEOS",
  "Вопрос ИИ-агенту": "Frage an den KI-Agenten",
  "Остановить диктовку": "Diktat beenden",
  "Сказать голосом": "Spracheingabe",
  "Отправить": "Senden",
  "Не удалось начать новый чат": "Neuer Chat konnte nicht gestartet werden",
  "Спасибо, учтём": "Danke, wir berücksichtigen das",
  "Спасибо, передадим команде": "Danke, wir geben es an das Team weiter",
  "Оценка не сохранилась": "Bewertung wurde nicht gespeichert",
  "Чат ещё загружается": "Chat wird noch geladen",
  "В чате уже {0} вопросов. Начните новый": "Dieser Chat hat bereits {0} Fragen. Starten Sie einen neuen",
  "Вопрос не сохранился. Попробуйте ещё раз": "Die Frage wurde nicht gespeichert. Versuchen Sie es erneut",
  "Некоторые сервисы работают медленнее обычного": "Einige Dienste sind langsamer als gewöhnlich",
  "{0} не работают": "{0} funktionieren nicht",
  "{0} не работает": "{0} funktioniert nicht",
  "{0} медленнее обычного": "{0} langsamer als gewöhnlich",
  "{0} работают медленнее обычного": "{0} sind langsamer als gewöhnlich",
  "{0} работает медленнее обычного": "{0} ist langsamer als gewöhnlich",
  "Микрофон здесь недоступен": "Das Mikrofon ist hier nicht verfügbar",
  "Нет доступа к микрофону": "Kein Zugriff auf das Mikrofon",
  "Нужна запись от 1 до 30 секунд": "Die Aufnahme muss 1 bis 30 Sekunden lang sein",
  "Не удалось разобрать запись": "Die Aufnahme konnte nicht erkannt werden",
  "Диктовка не распозналась. Нажмите микрофон, чтобы проверить ещё раз": "Das Diktat wurde nicht erkannt. Tippen Sie auf das Mikrofon, um es erneut zu prüfen",
  "Вопрос не подошёл. Сформулируйте иначе": "Die Frage passt nicht. Formulieren Sie sie anders",
  "Ответ не подтвердился. Напишите в поддержку": "Die Antwort wurde nicht bestätigt. Schreiben Sie dem Support",
  "Ответ не пришёл. Проверьте ещё раз": "Keine Antwort erhalten. Prüfen Sie erneut",
  "Говорящий кружок, видео и фото говорят, повтори движения, свой аватар": "Sprechendes Rundvideo, Video spricht, Foto spricht, Bewegungen nachahmen, eigener Avatar",
  "Оживить фото, видео по описанию, рилсы и сцены": "Foto animieren, Video aus Beschreibung, Reels und Szenen",
  "Фото, фотосессии, товары, карусели": "Fotos, Fotoshootings, Produkte, Karussells",
  "Голоса, клон, озвучка проектов, кавер": "Stimmen, Klon, Skript-Vertonung, Coverversion",
  "Звёзды Telegram и карты": "Telegram Stars und Karten",
  "Не работает": "Gestört",
  "Как сделать по шагам": "Schritt für Schritt",
  "Полезный ответ": "Hilfreiche Antwort",
  "Ответ не помог": "Nicht hilfreich",
  "Проверьте связь и попробуйте ещё раз": "Prüfen Sie die Verbindung und versuchen Sie es erneut",
  "Не удалось проверить владельца чата": "Chat-Inhaber konnte nicht überprüft werden",
  "Не удалось восстановить чат. Начните новый": "Chat konnte nicht wiederhergestellt werden. Starten Sie einen neuen",
  "Клоны для озвучки": "Klone für Vertonungen",
  "Создайте первый голос": "Erstellen Sie Ihre erste Stimme",
  "Люди и питомцы для фото": "Menschen und Haustiere für Fotos",
  "Добавьте близких для фото": "Liebste für Fotos hinzufügen",
  "Сохранённые работы": "Gespeicherte Werke",
  "Отмечайте работы сердцем": "Werke mit einem Herz markieren",
  "Ежедневная серия и бонусы": "Tägliche Serie und Boni",
  "Частые вопросы и связь с нами": "FAQ und Kontakt",
  "Обучается": "Wird trainiert",
  "Аккаунт недоступен": "Konto nicht verfügbar",
  "Эта неделя · {0}": "Diese Woche · {0}",
  "Неделя с {0} · {1}": "Woche ab {0} · {1}",
  "ID скопирован": "ID kopiert",
  "Скопировать ID": "ID kopieren",
  "Баланс временно недоступен": "Guthaben vorübergehend nicht verfügbar",
  "Разбивка остатка временно недоступна": "Aufschlüsselung vorübergehend nicht verfügbar",
  "Из них {0} C сгорит {1}|Из них {0} C сгорят {1}|Из них {0} C сгорят {1}": "Davon verfällt {0} C am {1}|Davon verfallen {0} C am {1}",
  "Ближайшие {0} C сгорят {1}": "Die nächsten {0} C verfallen am {1}",
  "Circle каждый месяц от {0}": "Circle jeden Monat ab {0}",
  "Circle каждый месяц с подпиской": "Circle jeden Monat mit Abo",
  "Тариф временно недоступен": "Tarif vorübergehend nicht verfügbar",
  "Аккаунт, подписка и баланс": "Konto, Abo und Guthaben",
  "Статистика и моё": "Statistik und Mein Profil",
  "{0} к прошлой неделе": "{0} ggü. Vorwoche",
  "Работы по неделям: на этой неделе {0}": "Werke nach Wochen: diese Woche {0}",
  "Работы по неделям: на этой неделе {0}, на прошлой {1}": "Werke nach Wochen: diese Woche {0}, letzte Woche {1}",
  "Статистика пока недоступна": "Statistik noch nicht verfügbar",
  "Дата регистрации недоступна": "Registrierungsdatum nicht verfügbar",
  "С {0}": "Seit {0}",
  "Создано": "Erstellt",
  "Серия": "Serie",
  "день подряд|дня подряд|дней подряд": "Tag in Folge|Tage in Folge",
  "Общий аккаунт STEOS": "Gemeinsames STEOS-Konto",
  "Для вывода Circle": "Zum Auszahlen von Circle",
  "До {0}% с их покупок": "Bis zu {0}% ihrer Käufe",
  "Обновлено {0}": "Aktualisiert: {0}",
  "Действия": "Aktionen",
  "Сохранить имя": "Namen speichern",
  "Новое имя": "Neuer Name",
  "Больше голосов с подпиской": "Mehr Stimmen mit Abo",
  "Создание голосов пока недоступно": "Stimmen erstellen ist noch nicht möglich",
  "Свободных мест нет": "Keine freien Plätze",
  "с подпиской до {0}": "mit Abo bis zu {0}",
  "Пауза «{0}»": "„{0}“ pausieren",
  "Прослушать «{0}»": "„{0}“ anhören",
  "Переименовать": "Umbenennen",
  "Запишите от 2 секунд речи или загрузите файлы, и голос будет звучать как вы": "Nehmen Sie 2 Sekunden Sprache auf oder laden Sie Dateien hoch – dann klingt die Stimme wie Sie",
  "Свободных мест нет. Удалите голос, чтобы записать новый": "Keine freien Plätze. Löschen Sie eine Stimme, um eine neue aufzunehmen",
  "Выбрать за «Вы»": "Als „Sie“ verwenden",
  "голос по умолчанию": "Standardstimme",
  "Сделать кружок с вариантом «{0}»": "Rundvideo mit dem Look „{0}“ erstellen",
  "Выбраны": "Ausgewählt",
  "{0} фото|{0} фото|{0} фото": "{0} Foto|{0} Fotos",
  "{0} фото · для всех инструментов|{0} фото · для всех инструментов|{0} фото · для всех инструментов": "{0} Foto · für alle Werkzeuge|{0} Fotos · für alle Werkzeuge",
  "{0} вариант · кружки, фото и видео|{0} варианта · кружки, фото и видео|{0} вариантов · кружки, фото и видео": "{0} Look · Rundvideos, Fotos, Videos|{0} Looks · Rundvideos, Fotos, Videos",
  "{0} вариант|{0} варианта|{0} вариантов": "{0} Look|{0} Looks",
  "Голос {0} удалён, у варианта {1} теперь голос по умолчанию.": "Die Stimme {0} wurde gelöscht, der Look {1} nutzt jetzt die Standardstimme.",
  "Голоса удалены, у вариантов {0} теперь голос по умолчанию.": "Stimmen wurden gelöscht, die Looks {0} nutzen jetzt die Standardstimme.",
  "Другой голос можно выбрать у каждого кружка": "Eine andere Stimme lässt sich für jedes Rundvideo wählen",
  "Вариантов пока нет": "Noch keine Looks",
  "Загрузите свои фото, и вариант себя будет говорить вашим голосом в кружках, фото и видео": "Laden Sie Ihre Fotos hoch – Ihr Look spricht dann mit Ihrer Stimme in Rundvideos, Fotos und Videos",
  "Вы: свои фото и варианты": "Sie: Ihre Fotos und Looks",
  "добавьте фото": "Fotos hinzufügen",
  "Изменить «{0}»": "„{0}“ bearbeiten",
  "{0} близкий · для фото и видео|{0} близких · для фото и видео|{0} близких · для фото и видео": "{0} Liebste Person · für Fotos und Videos|{0} Liebste · für Fotos und Videos",
  "Люди и питомцы для фото и видео": "Menschen und Haustiere für Fotos und Videos",
  "Близких пока нет": "Noch keine Liebsten",
  "Добавьте людей и питомцев с фото, и они появятся в кадре рядом с вами": "Fügen Sie Menschen und Haustiere mit Fotos hinzu – dann erscheinen sie neben Ihnen im Bild",
  "Открыть в «Истории»": "Im Verlauf öffnen",
  "Вернуть в избранное": "Wieder zu Favoriten hinzufügen",
  "{0} работа с сердцем|{0} работы с сердцем|{0} работ с сердцем": "{0} Werk mit Herz|{0} Werke mit Herz",
  "Отмеченные сердцем работы": "Mit Herz markierte Werke",
  "Открыть «Историю»": "Verlauf öffnen",
  "Не удалось загрузить избранное": "Favoriten konnten nicht geladen werden",
  "Закройте лист и откройте его ещё раз": "Schließen Sie das Fenster und öffnen Sie es erneut",
  "Отмечайте работы сердцем в «Истории», и они соберутся здесь": "Markieren Sie Werke im Verlauf mit einem Herz – sie sammeln sich hier",
  "Не удалось обновить. Попробуйте позже": "Aktualisierung fehlgeschlagen. Versuchen Sie es später",
  "Удалить голос «{0}»?": "Stimme „{0}“ löschen?",
  "Голос пропадёт из списка. Вернуть его не получится.": "Die Stimme verschwindet aus der Liste. Wiederherstellen ist nicht möglich.",
  "Удалить вариант «{0}»?": "Look „{0}“ löschen?",
  "За «Вы» снова встанут ваши фото.": "Als „Sie“ werden wieder Ihre Fotos verwendet.",
  "Готовые кружки и фото с ним останутся в «Истории». Вернуть вариант не получится.": "Fertige Rundvideos und Fotos damit bleiben im Verlauf. Der Look lässt sich nicht wiederherstellen.",
  "Не удалось удалить голос": "Stimme konnte nicht gelöscht werden",
  "Не удалось удалить вариант. Попробуйте ещё раз": "Look konnte nicht gelöscht werden. Versuchen Sie es erneut",
  "«{0}»": "„{0}“",
  "подписка: до {0}": "bis {0}",
  "варианты «Вы»: Новый вариант": "Neuer Look",
  "в очереди": "in der Warteschlange",
  "идёт": "läuft",
  "завершено": "abgeschlossen",
  "не удалось": "fehlgeschlagen",
  "слово подтверждения: УДАЛИТЬ": "LÖSCHEN",
  "Выгрузка: {0}": "Export: {0}",
  "Удаление: {0}. STEOS ID и финансовые квитанции сохраняются.": "Löschung: {0}. STEOS ID und Zahlungsbelege bleiben erhalten.",
  "Введите {0}": "Geben Sie {0} ein",
  "Перенос ещё не подтверждён. Проверка продолжится, откройте лист позже": "Übertragung noch nicht bestätigt. Die Prüfung läuft weiter – öffnen Sie das Fenster später",
  "Этот STEOS ID уже связан с другим Telegram": "Diese STEOS ID ist bereits mit einem anderen Telegram-Konto verknüpft",
  "На обоих аккаунтах есть подписка. Для объединения напишите в поддержку": "Beide Konten haben ein Abo. Wenden Sie sich zum Zusammenführen an den Support",
  "Слишком много попыток. Попробуйте позже": "Zu viele Versuche. Versuchen Sie es später",
  "Подключение STEOS ID сейчас недоступно. Попробуйте позже": "STEOS ID kann gerade nicht verbunden werden. Versuchen Sie es später",
  "Не удалось создать аккаунт. Попробуйте позже": "Konto konnte nicht erstellt werden. Versuchen Sie es später",
  "Не удалось отправить письмо": "E-Mail konnte nicht gesendet werden",
  "Фото не подошло. Выберите другое": "Das Foto passt nicht. Wählen Sie ein anderes",
  "Загрузите фото заново": "Laden Sie das Foto erneut hoch",
  "Данные изменились. Откройте заново": "Die Daten haben sich geändert. Öffnen Sie es erneut",
  "подряд": "in Folge",
  "Начните {0}": "Starten Sie {0}",
  "серию": "eine Serie",
  "Завтра +{0} C": "Morgen +{0} C",
  "Заходите каждый день: награда растёт, на седьмой день {0} C. Пропуск дня начинает серию заново.": "Kommen Sie täglich vorbei: Die Prämie wächst, am siebten Tag {0} C. Ein verpasster Tag startet die Serie neu.",
  "Забрать {0} C": "{0} C abholen",
  "Прогресс": "Fortschritt",
  "Заданий здесь пока нет": "Hier gibt es noch keine Aufgaben",
  "Время обновления недоступно": "Aktualisierungszeit nicht verfügbar",
  "Новые через {0}": "Neue in {0}",
  "Выполнено {0} из {1}": "{0} von {1} erledigt",
  "друг|друга|друзей": "Freund|Freunde",
  "{0} с вами": "{0} dabei",
  "Прогресс друзей недоступен": "Fortschritt der Freunde nicht verfügbar",
  "Пригласить": "Einladen",
  "Засчитываются друзья, которые пришли по вашей ссылке или промокоду и создали первую работу": "Es zählen Freunde, die über Ihren Link oder Aktionscode kommen und ihr erstes Werk erstellen",
  "Ещё {0} {1} до награды {2}": "Noch {0} {1} bis {2}",
  "Все ступени пройдены": "Alle Stufen erreicht",
  "Получено {0} из {1}": "{0} von {1} erhalten",
  "Задания": "Aufgaben",
  "покупатель|покупателя|покупателей": "Käufer|Käufer",
  "Партнёрская программа": "Partnerprogramm",
  "Партнёрам": "Für Partner",
  "До {0}% {1}": "Bis zu {0}% {1}",
  "с покупок друзей": "von Käufen Ihrer Freunde",
  "Заработано {0} с покупок {1} {2}": "{0} verdient mit Käufen von {1} {2}",
  "друга|друзей|друзей": "Freund|Freunden",
  "Сами выбирайте: больше возможностей в STEOS или доход с рекомендаций.": "Sie entscheiden: mehr Möglichkeiten in STEOS oder Einnahmen aus Empfehlungen.",
  "Ещё {0} до уровня {1}": "Noch {0} bis {1}",
  "Максимальный уровень: вывод через STEOS ID": "Höchste Stufe: Auszahlung über STEOS ID",
  "Статистика, материалы и вывод": "Statistik, Material und Auszahlung",
  "Исход прежнего запроса награды нужно проверить. Новые начисления пока заблокированы": "Die vorige Prämienanfrage muss geprüft werden. Neue Gutschriften sind vorerst gesperrt",
  "Загружаем награды": "Prämien werden geladen",
  "Награды не загрузились": "Prämien wurden nicht geladen",
  "Создайте 3 работы": "3 Werke erstellen",
  "Сделайте кружок": "Rundvideo erstellen",
  "Персонаж или вы сами": "Eine Figur oder Sie selbst",
  "Озвучьте текст": "Text vertonen",
  "Голосом героя или клона": "Mit der Stimme einer Figur oder eines Klons",
  "Улучшите описание": "Beschreibung verbessern",
  "Бот допишет детали": "Der Bot ergänzt Details",
  "Отправьте работу": "Werk teilen",
  "Из «Истории» в любой чат": "Aus dem Verlauf in einen Chat",
  "Неделя кружков": "Rundvideo-Woche",
  "Создайте 10 кружков за неделю": "10 Rundvideos in einer Woche erstellen",
  "Исследователь": "Entdecker",
  "Попробуйте 5 разных инструментов студии": "5 verschiedene Studio-Tools testen",
  "Первый кружок": "Erstes Rundvideo",
  "Видеокружок для Telegram": "Rundvideo für Telegram",
  "Клон голоса": "Stimmklon",
  "Всего 2 секунды речи": "Nur 2 Sekunden Sprache",
  "Первое фото": "Erstes Foto",
  "Портрет в любом стиле": "Porträt in jedem Stil",
  "Первый рилс с вами": "Ihr erstes Reel",
  "Шаблон одной кнопкой": "Vorlage mit einem Tipp",
  "Первый кавер": "Erstes Cover",
  "Песня другим голосом": "Ein Song mit anderer Stimme",
  "Кружки и видео с вами": "Rundvideos und Videos mit Ihnen",
  "С вашей ссылкой": "Mit Ihrem Link",
  "Бот в чате": "Bot im Chat",
  "Добавьте бота в группу": "Bot zu einer Gruppe hinzufügen",
  "Вход в STEOS ID": "Mit STEOS ID anmelden",
  "Один аккаунт с сайтом": "Ein Konto mit der Website",
  "Первый друг": "Erster Freund",
  "3 друга": "3 Freunde",
  "10 друзей": "10 Freunde",
  "25 друзей": "25 Freunde",
  "Первый покупатель": "Erster Käufer",
  "Первая оплата друга": "Erste Zahlung eines Freundes",
  "{0} мин": "{0} Min.",
  "{0} ч": "{0} Std.",
  "Последний день": "Letzter Tag",
  "Ещё {0} {1}": "Noch {0} {1}",
  "Это задание выполняется вне мини-приложения": "Diese Aufgabe wird außerhalb der Mini App erledigt",
  "Задание пока недоступно": "Aufgabe noch nicht verfügbar",
  "Прогресс временно недоступен": "Fortschritt vorübergehend nicht verfügbar",
  "Не удалось восстановить прежний запрос награды. Проверьте баланс и напишите в поддержку": "Die vorige Prämienanfrage konnte nicht wiederhergestellt werden. Prüfen Sie Ihr Guthaben und wenden Sie sich an den Support",
  "Награды временно недоступны. Попробуйте обновить данные": "Prämien sind vorübergehend nicht verfügbar. Versuchen Sie, die Daten zu aktualisieren",
  "Награда подтверждена. Обновите данные: повторять начисление не нужно": "Prämie bestätigt. Aktualisieren Sie die Daten: Kein erneutes Abholen nötig",
  "Задание ещё не выполнено. Обновите прогресс": "Aufgabe noch nicht erledigt. Aktualisieren Sie den Fortschritt",
  "Награда уже получена. Обновите данные": "Prämie bereits erhalten. Aktualisieren Sie die Daten",
  "Начисление не подтверждено. Проверьте прежний запрос: новая награда пока заблокирована": "Gutschrift nicht bestätigt. Prüfen Sie die vorige Anfrage: Neue Prämien sind vorerst gesperrt",
  "Сначала обновите данные наград": "Aktualisieren Sie zuerst die Prämien",
  "Сначала проверьте прежний запрос награды": "Prüfen Sie zuerst die vorige Prämienanfrage",
  "Рассказчик": "Erzähler",
  "Встреча на тракте": "Begegnung auf der Straße",
  "Геральт": "Geralt",
  "Цири": "Ciri",
  "Дождь шёл третий день, и дорога к крепости почти исчезла под грязью.": "Es regnete schon den dritten Tag, und der Weg zur Festung war im Schlamm fast verschwunden.",
  "Ты опять ушла вперёд без меня. Я же просил ждать у моста.": "Du bist schon wieder ohne mich vorausgegangen. Ich hatte dich gebeten, an der Brücke zu warten.",
  "Я ждала. Целый час. Потом решила, что ты заблудился.": "Ich habe gewartet. Eine ganze Stunde. Dann dachte ich, du hättest dich verirrt.",
  "Ведьмаки не блуждают. Мы иногда выбираем длинную дорогу.": "Hexer verirren sich nicht. Manchmal nehmen wir nur den längeren Weg.",
  "Тогда в следующий раз выбирай её быстрее. Я замёрзла.": "Dann such ihn nächstes Mal schneller aus. Mir ist kalt.",
  "Он молча снял плащ и накинул ей на плечи. Впереди уже виднелись огни крепости.": "Wortlos nahm er seinen Umhang ab und legte ihn ihr um die Schultern. Vorne sah man schon die Lichter der Festung.",
  "Пойдём. Весемир наверняка уже поставил суп на огонь.": "Komm. Vesemir hat bestimmt schon die Suppe aufs Feuer gestellt.",
  "Опять ты?": "Du schon wieder?",
  "Мне нужна помощь": "Ich brauche Hilfe",
  "Вставьте сценарий или начните с нуля": "Skript einfügen oder neu beginnen",
  "Напишите хотя бы одну реплику": "Schreiben Sie mindestens einen Sprechbeitrag",
  "Сократите реплику: до {0} знаков": "Sprechbeitrag kürzen: bis {0} Zeichen",
  "Сократите проект: до {0} знаков": "Projekt kürzen: bis {0} Zeichen",
  "Озвучка проектов временно недоступна": "Skript-Vertonung ist vorübergehend nicht verfügbar",
  "Выберите голос для каждой роли": "Wählen Sie für jede Rolle eine Stimme",
  "Озвучить · {0} C": "Vertonen · {0} C",
  "Без названия": "Ohne Titel",
  "Роль": "Rolle",
  "вчера": "gestern",
  "Проекты": "Projekte",
  "роль|роли|ролей": "Rolle|Rollen",
  "реплика|реплики|реплик": "Sprechbeitrag|Sprechbeiträge",
  "Нет реплик": "Keine Sprechbeiträge",
  "{0} знаков": "{0} Zeichen",
  "Строки «Имя: реплика» сами станут ролями и голосами": "Zeilen wie „Name: Text“ werden zu Rollen und Stimmen",
  "Начать с нуля": "Neu beginnen",
  "Роли и реплики добавите сами": "Rollen und Sprechbeiträge selbst hinzufügen",
  "Открыть пример": "Beispiel öffnen",
  "Проекты сохраняются сами: вернуться к ним можно в любой момент": "Projekte werden automatisch gespeichert: Sie können jederzeit zurückkehren",
  "Роль с именем персонажа сама получит его голос: Геральт, Цири, Йеннифэр": "Eine Rolle mit dem Namen einer Figur erhält deren Stimme: Geralt, Ciri, Yennefer",
  "Переименовать проект": "Projekt umbenennen",
  "Загрузить свежую": "Neueste laden",
  "{0}: голос {1}. Сменить голос": "{0}: Stimme {1}. Stimme ändern",
  "Действия с ролью": "Rollenaktionen",
  "Озвучиваем": "Wird vertont",
  "Действия с репликой": "Aktionen für Sprechbeitrag",
  "Реплика: {0}": "Sprechbeitrag: {0}",
  "Реплик пока нет": "Noch keine Sprechbeiträge",
  "Нажмите «Реплика» внизу или вставьте готовый сценарий": "Tippen Sie unten auf „Sprechbeitrag“ oder fügen Sie ein fertiges Skript ein",
  "Реплика": "Sprechbeitrag",
  "за проект": "pro Projekt",
  "Цена — по числу знаков": "Preis nach Zeichenzahl",
  "Добавить реплику": "Sprechbeitrag hinzufügen",
  "проект|проекта|проектов": "Projekt|Projekte",
  "{0} {1} · сохраняются сами": "{0} {1} · automatisch gespeichert",
  "Пока ни одного": "Noch keine",
  "Новый проект": "Neues Projekt",
  "Вставить сценарий или начать с нуля": "Skript einfügen oder neu beginnen",
  "Удаление проекта": "Projekt löschen",
  "Новая роль": "Neue Rolle",
  "Это первая реплика": "Das ist der erste Sprechbeitrag",
  "Это последняя реплика": "Das ist der letzte Sprechbeitrag",
  "Удалить роль": "Rolle löschen",
  "Вместе с её репликами": "Samt ihren Sprechbeiträgen",
  "В проекте нужна хотя бы одна роль": "Ein Projekt braucht mindestens eine Rolle",
  "Удалить роль «{0}»?": "Rolle „{0}“ löschen?",
  "Вместе с ней уйдут {0} {1}.": "Damit wird auch gelöscht: {0} {1}.",
  "Удалить проект?": "Projekt löschen?",
  "{0}. Роли и реплики удалятся, вернуть проект не получится.": "{0}. Rollen und Sprechbeiträge werden gelöscht, das Projekt lässt sich nicht wiederherstellen.",
  "Выбор голоса откроется в приложении": "Die Stimmauswahl öffnet sich in der App",
  "Не удалось удалить проект: {0}": "Projekt konnte nicht gelöscht werden: {0}",
  "Не получилось открыть аудио": "Audio konnte nicht geöffnet werden",
  "Не получилось включить звук": "Ton konnte nicht abgespielt werden",
  "Сначала напишите текст реплики": "Schreiben Sie zuerst den Text",
  "Аудио реплики пока недоступно": "Audio des Sprechbeitrags noch nicht verfügbar",
  "Готовим роли": "Rollen werden vorbereitet",
  "Роли готовы": "Rollen bereit",
  "Озвучиваем реплики": "Sprechbeiträge werden vertont",
  "Реплики озвучены": "Sprechbeiträge vertont",
  "Собираем дорожку": "Tonspur wird erstellt",
  "Дорожка собрана": "Tonspur erstellt",
  "дубль {0}": "Take {0}",
  "Время реплики пока недоступно": "Zeit des Sprechbeitrags noch nicht verfügbar",
  "Общий файл · {0}": "Gesamtdatei · {0}",
  "Аудио пока недоступно": "Audio noch nicht verfügbar",
  "Слушать дорожку": "Tonspur anhören",
  "реплика {0} из {1}": "Sprechbeitrag {0} von {1}",
  "Проект не озвучен": "Projekt nicht vertont",
  "Можно уйти с экрана: озвучка продолжится, дорожка появится здесь и в «Истории».": "Sie können den Bildschirm verlassen: Die Vertonung läuft weiter, die Tonspur erscheint hier und im Verlauf.",
  "Можно уйти с экрана: бот напишет, когда дорожка будет готова.": "Sie können den Bildschirm verlassen: Der Bot meldet sich, wenn die Tonspur fertig ist.",
  "Отправьте общий файл в чат или скачайте его. Любую реплику можно переозвучить отдельно.": "Senden Sie die Gesamtdatei in den Chat oder laden Sie sie herunter. Jeder Sprechbeitrag lässt sich einzeln neu vertonen.",
  "Бот уже прислал общий файл в чат, в отдельную тему. Любую реплику можно переозвучить отдельно.": "Der Bot hat die Gesamtdatei bereits in ein eigenes Thema im Chat geschickt. Jeder Sprechbeitrag lässt sich einzeln neu vertonen.",
  "Сценарий не прошёл проверку": "Skript hat die Prüfung nicht bestanden",
  "проект не озвучен": "Projekt nicht vertont",
  "Не получилось собрать дорожку": "Tonspur konnte nicht erstellt werden",
  "К сценарию": "Zum Skript",
  "Звук дорожки не загрузился: скачайте файл": "Ton der Tonspur nicht geladen: Laden Sie die Datei herunter",
  "Каждая реплика с новой строки: имя, двоеточие, текст. Строка без имени достаётся предыдущей роли": "Jeder Sprechbeitrag in einer neuen Zeile: Name, Doppelpunkt, Text. Eine Zeile ohne Namen gehört zur vorherigen Rolle",
  "голос персонажа": "Stimme der Figur",
  "Заменить сценарий": "Skript ersetzen",
  "Сейчас {0} {1}, они уйдут": "Aktuell {0} {1}, sie werden entfernt",
  "реплику|реплики|реплик": "Sprechbeitrag|Sprechbeiträge",
  "Заменить на {0} {1}": "Durch {0} {1} ersetzen",
  "Добавить {0} {1}": "{0} {1} hinzufügen",
  "Заменить реплики": "Sprechbeiträge ersetzen",
  "Добавить реплики": "Sprechbeiträge hinzufügen",
  "Не нашли реплик: имя, двоеточие, текст": "Keine Sprechbeiträge gefunden: Name, Doppelpunkt, Text",
  "Вставьте сценарий в поле": "Fügen Sie das Skript in das Feld ein",
  "Роли и голоса появятся сами": "Rollen und Stimmen erscheinen automatisch",
  "Геральт: Опять ты. Что на этот раз? Цири: Мне нужна твоя помощь.": "Geralt: Du schon wieder. Was ist es diesmal?\nCiri: Ich brauche deine Hilfe.",
  "Сейчас нельзя": "Gerade nicht möglich",
  "Вставьте текст в поле": "Fügen Sie den Text in das Feld ein",
  "Загружаем проекты": "Projekte werden geladen",
  "Проекты не загрузились": "Projekte wurden nicht geladen",
  "Не хватает Circle: пополните баланс": "Nicht genügend Circle: Laden Sie Ihr Guthaben auf",
  "Цена: {0} C. Нажмите ещё раз, чтобы озвучить": "Preis: {0} C. Zum Vertonen erneut tippen",
  "Не удалось посчитать цену. Попробуйте ещё раз": "Preis konnte nicht berechnet werden. Versuchen Sie es erneut",
  "Сценарий не прошёл проверку. Измените текст и попробуйте ещё раз.": "Das Skript hat die Prüfung nicht bestanden. Ändern Sie den Text und versuchen Sie es erneut.",
  "Не получилось собрать дорожку. Если Circle списались, они вернутся на баланс.": "Tonspur konnte nicht erstellt werden. Abgebuchte Circle werden Ihrem Guthaben wieder gutgeschrieben.",
  "Запуск не подтверждён": "Start nicht bestätigt",
  "Не получилось собрать дорожку.": "Tonspur konnte nicht erstellt werden.",
  "Повторная проверка не спишет Circle дважды.": "Eine erneute Prüfung bucht Circle nicht doppelt ab.",
  "Отправили в чат": "An den Chat gesendet",
  "Отправка принята: бот пришлёт дорожку в чат": "Auftrag angenommen: Der Bot schickt die Tonspur in den Chat",
  "Прослушивание реплики пока недоступно": "Anhören des Sprechbeitrags noch nicht verfügbar",
  "Прослушать реплику: {0} C. Нажмите ещё раз": "Sprechbeitrag anhören: {0} C. Erneut tippen",
  "Переозвучка реплики пока недоступна": "Neuvertonung des Sprechbeitrags noch nicht verfügbar",
  "Переозвучить реплику: {0} C. Нажмите ещё раз": "Sprechbeitrag neu vertonen: {0} C. Erneut tippen",
  "Сохранение проектов сейчас недоступно. Обновите данные.": "Projekte können gerade nicht gespeichert werden. Aktualisieren Sie die Daten.",
  "Изменение проектов сейчас недоступно. Обновите данные.": "Projekte können gerade nicht bearbeitet werden. Aktualisieren Sie die Daten.",
  "Проект ещё сохраняется. Попробуйте через секунду.": "Das Projekt wird noch gespeichert. Versuchen Sie es gleich noch einmal.",
  "Результат больше недоступен.": "Das Ergebnis ist nicht mehr verfügbar.",
  "Не удалось проверить владельца проекта.": "Projektinhaber konnte nicht geprüft werden.",
  "Операция не найдена. Проверьте историю.": "Vorgang nicht gefunden. Prüfen Sie den Verlauf.",
  "Проект ещё не сохранён.": "Das Projekt ist noch nicht gespeichert.",
  "Озвучка проектов сейчас недоступна. Обновите данные.": "Skript-Vertonung ist gerade nicht verfügbar. Aktualisieren Sie die Daten.",
  "Прослушивание реплики сейчас недоступно. Обновите данные.": "Anhören des Sprechbeitrags ist gerade nicht verfügbar. Aktualisieren Sie die Daten.",
  "Переозвучка реплики сейчас недоступна. Обновите данные.": "Neuvertonung des Sprechbeitrags ist gerade nicht verfügbar. Aktualisieren Sie die Daten.",
  "Дорожка ещё не готова.": "Die Tonspur ist noch nicht fertig.",
  "Аккаунт сменился. Обновите страницу.": "Das Konto wurde gewechselt. Laden Sie die Seite neu.",
  "Отправка пока не подтверждена. Нажмите ещё раз, чтобы проверить прежний запрос.": "Senden noch nicht bestätigt. Tippen Sie erneut, um die vorige Anfrage zu prüfen.",
  "Результат проекта пока недоступен. Проверьте статус ещё раз.": "Das Projektergebnis ist noch nicht verfügbar. Prüfen Sie den Status erneut.",
  "Не удалось открыть аудио проекта.": "Projekt-Audio konnte nicht geöffnet werden.",
  "месяц|месяца|месяцев": "Monat|Monate",
  "покупателя|покупателей|покупателей": "Käufer|Käufern",
  "рабочий день|рабочих дня|рабочих дней": "Werktag|Werktagen",
  "друг купит|друга купят|друзей купят": "Freund|Freunden",
  "покупателем|покупателями|покупателями": "Käufer|Käufer",
  "Баннеры": "Banner",
  "Постер": "Poster",
  "Голос героя": "Stimme der Figur",
  "Персонаж говорит": "Figur spricht",
  "Было и стало": "Vorher und nachher",
  "Подарок другу": "Geschenk für Freunde",
  "Кружок, который говорит": "Ein Rundvideo, das spricht",
  "Персонаж читает ваш текст": "Eine Figur liest Ihren Text",
  "Рилс с вами одной кнопкой": "Ein Reel mit Ihnen per Tipp",
  "Сюжет, монтаж и музыка в шаблоне": "Story, Schnitt und Musik inklusive",
  "Герой говорит": "Held spricht",
  "Герой говорит вашим текстом": "Ein Held spricht Ihren Text",
  "Голос и губы в такт": "Stimme und Lippen synchron",
  "Старое фото как новое": "Alte Fotos wie neu",
  "Цвет и резкость за минуту": "Farbe und Schärfe in einer Minute",
  "Кавер любым голосом": "Cover mit jeder Stimme",
  "Рок, джаз или lo-fi": "Rock, Jazz oder Lo-Fi",
  "Фотосессия в любом образе": "Fotoshooting in jedem Look",
  "По паре своих фото": "Aus ein paar eigenen Fotos",
  "Друзьям": "Für Freunde",
  "Личное сообщение": "Direktnachricht",
  "Подписчикам": "Für Follower",
  "Пост в канал": "Kanalbeitrag",
  "Семье": "Für die Familie",
  "Сообщение родным": "Nachricht an die Familie",
  "Геймерам": "Für Gamer",
  "Чат по интересам": "Themenchat",
  "Для работы": "Für die Arbeit",
  "Коллегам и в рабочий чат": "Kollegen und Arbeitschat",
  "Авторам": "Für Creator",
  "Блогерам и создателям роликов": "Blogger und Videomacher",
  "Подарок по моему промокоду": "Ein Geschenk mit meinem Code",
  "Кружки, фото и голос с ИИ прямо в Telegram": "KI-Rundvideos, Fotos und Stimme direkt in Telegram",
  "Кружки с персонажами": "Rundvideos mit Figuren",
  "Пишете текст, персонаж его говорит": "Sie schreiben, die Figur spricht",
  "Озвучка любым голосом": "Vertonung mit jeder Stimme",
  "Из библиотеки или своим клоном": "Aus der Bibliothek oder mit eigenem Klon",
  "Фотосессия без студии": "Fotoshooting ohne Studio",
  "Пара своих фото, любой образ": "Ein paar Fotos, jeder Look",
  "{0} с регистрации по вашей ссылке или с первой покупки по промокоду. Всё это время процент идёт со всех оплат друга. Промокод работает только до первой покупки друга, а если друг пришёл по ссылке, промокод привязку уже не меняет.": "{0} ab der Registrierung über Ihren Link oder ab dem ersten Kauf mit Ihrem Code. In dieser Zeit erhalten Sie einen Anteil an allen Zahlungen des Freundes. Der Code gilt nur bis zum ersten Kauf; kam der Freund über Ihren Link, ändert der Code die Zuordnung nicht mehr.",
  "Что получает друг?": "Was bekommt der Freund?",
  "+{0} C сразу: они не выводятся и сгорают через {1}.": "+{0} C sofort: nicht auszahlbar, {1} lang gültig.",
  "Скидка {0}% на первый пакет Circle действует {1} после оформления подписки, потому что пакеты Circle продаются только с подпиской. Подарок один на аккаунт: по ссылке или по промокоду.": "{0} % Rabatt auf das erste Circle-Paket gelten {1} lang nach Abschluss des Abos, weil Circle-Pakete nur mit Abo verkauft werden. Ein Geschenk pro Konto: per Link oder Code.",
  "Что считается оплатой?": "Was zählt als Zahlung?",
  "Подписка и пакеты Circle, оплаченные звёздами или картой. Процент считается от суммы, которую друг заплатил, со скидкой. Бонусные монеты, награды за задания и возвраты не учитываются.": "Abos und Circle-Pakete, bezahlt mit Stars oder Karte. Der Anteil richtet sich nach dem tatsächlich gezahlten Betrag inklusive Rabatt. Bonusmünzen, Aufgabenbelohnungen und Erstattungen zählen nicht.",
  "Какие бывают промокоды?": "Welche Codes gibt es?",
  "Ваш промокод партнёра даёт другу подарок и привязывает его к вам, работает только до его первой покупки. Промокоды STEOS публикует команда в канале и сообществе STEOS: они дают Circle со своим сроком и работают у всех, один раз на аккаунт.": "Ihr Partnercode schenkt dem Freund etwas und ordnet ihn Ihnen zu; er gilt nur bis zum ersten Kauf. STEOS-Codes veröffentlicht das Team im STEOS-Kanal und in der Community: Sie geben Circle mit eigener Laufzeit und gelten für alle, einmal pro Konto.",
  "Когда приходят Circle?": "Wann kommen die Circle?",
  "Сразу после оплаты друга, прямо на баланс. На уровне {0} их можно вывести.": "Direkt nach der Zahlung des Freundes aufs Guthaben. Auf der Stufe {0} können Sie sie auszahlen.",
  "Сразу после оплаты друга, прямо на баланс. На уровнях {0} они работают внутри STEOS, на уровне {1} их можно вывести.": "Direkt nach der Zahlung des Freundes aufs Guthaben. Auf den Stufen {0} nutzen Sie sie in STEOS, auf {1} können Sie sie auszahlen.",
  "Сразу после оплаты друга, прямо на баланс. На уровне {0} они работают внутри STEOS, на уровне {1} их можно вывести.": "Direkt nach der Zahlung des Freundes aufs Guthaben. Auf der Stufe {0} nutzen Sie sie in STEOS, auf {1} können Sie sie auszahlen.",
  "Считаются ли друзья с истёкшей привязкой?": "Zählen Freunde mit abgelaufener Bindung?",
  "Да. Процент с их оплат больше не идёт, но в счёте уровня они остаются: уровень считается по всем покупателям за всё время.": "Ja. Von ihren Zahlungen erhalten Sie keinen Anteil mehr, für die Stufe zählen sie aber weiter: Sie richtet sich nach allen Käufern seit Beginn.",
  "Кто может выводить?": "Wer kann auszahlen?",
  "Партнёры уровня {0} (от {1}) со статусом ИП, самозанятого или иностранного аналога, после входа через STEOS ID. Вывод только деньгами на счёт: здесь или на {2}.": "Partner der Stufe {0} (ab {1}) mit Status als Einzelunternehmer, Selbstständige oder ausländischem Pendant, nach Anmeldung mit STEOS ID. Auszahlung nur als Geld aufs Konto: hier oder auf {2}.",
  "Амбассадоры (от {0}) со статусом ИП, самозанятого или иностранного аналога, после входа через STEOS ID. Вывод только деньгами на счёт: здесь или на {1}.": "Botschafter (ab {0}) mit Status als Einzelunternehmer, Selbstständige oder ausländischem Pendant, nach Anmeldung mit STEOS ID. Auszahlung nur als Geld aufs Konto: hier oder auf {1}.",
  "Можно ли вывести монеты, заработанные до входа?": "Kann ich Münzen auszahlen, die ich vor der Anmeldung verdient habe?",
  "Да. Монеты Circle, заработанные на уровне {0} до входа через STEOS ID, ждут на балансе и станут доступны для вывода после входа.": "Ja. Circle, die Sie auf der Stufe {0} vor der Anmeldung mit STEOS ID verdient haben, warten auf dem Guthaben und sind nach der Anmeldung auszahlbar.",
  "Какие монеты тратятся первыми?": "Welche Münzen werden zuerst verbraucht?",
  "Можно пригласить самого себя?": "Kann ich mich selbst einladen?",
  "Нет. Покупки с вашего аккаунта и с повторных аккаунтов не учитываются.": "Nein. Käufe von Ihrem eigenen Konto und von Zweitkonten zählen nicht.",
  "Международный": "International",
  "Self-employed, sole trader или компания вне РФ": "Selbstständig, Einzelunternehmen oder Firma außerhalb Russlands",
  "Самозанятый в РФ": "Selbstständig in Russland",
  "Налог на профессиональный доход": "Steuer auf Berufseinkommen (NPD)",
  "ИП в РФ": "Einzelunternehmer in Russland",
  "Индивидуальный предприниматель": "Einzelunternehmer",
  "Имя или компания": "Name oder Firma",
  "Как в документах": "Wie in den Dokumenten",
  "TIN или номер в вашей стране": "TIN oder Steuernummer Ihres Landes",
  "ФИО": "Vollständiger Name",
  "Как в паспорте": "Wie im Pass",
  "ИНН": "INN",
  "12 цифр": "12 Ziffern",
  "Название ИП": "Name des Einzelunternehmens",
  "Как в выписке": "Wie im Registerauszug",
  "ИНН или ОГРНИП": "INN oder OGRNIP",
  "От 10 до 15 цифр": "10 bis 15 Ziffern",
  "НДС": "MwSt.",
  "Плательщик НДС": "MwSt.-pflichtig",
  "Адрес": "Adresse",
  "КПП": "KPP",
  "ОГРН": "OGRN",
  "Основной офис STEOS": "STEOS-Hauptsitz",
  "Платёжный агент STEOS в России": "Zahlungsagent von STEOS in Russland",
  "Тут откроется выбор чата Telegram с этим текстом, ссылкой и промокодом": "Hier öffnet sich die Telegram-Chatauswahl mit diesem Text, Link und Code",
  "Тут откроется выбор чата Telegram: баннер уйдёт с подписью и кнопкой «Открыть STEOS»": "Hier öffnet sich die Telegram-Chatauswahl: Das Banner geht mit Text und der Schaltfläche «STEOS öffnen»",
  "Ещё <b>{0} {1}</b> до уровня {2}": "Noch <b>{0} {1}</b> bis {2}",
  "Максимальный уровень": "Höchste Stufe",
  "До следующего уровня": "Bis zur nächsten Stufe",
  "Получайте до&nbsp;{0}% <span>с&nbsp;покупок друзей</span>": "Bis zu&nbsp;{0}&nbsp;% <span>von Käufen Ihrer Freunde</span>",
  "Период": "Zeitraum",
  "Кого показать": "Anzeigen",
  "Перешли": "Klicks",
  "Зарегистрировались": "Registriert",
  "Купили": "Gekauft",
  "Пока нет данных": "Noch keine Daten",
  "{0} к прошлому периоду": "{0} zum Vorzeitraum",
  "за {0} {1}": "{0} {1} lang",
  "Пока не считаем": "Noch nicht erfasst",
  "нет начислений": "keine Einnahmen",
  "Пик <b>{0} C</b>": "Spitze <b>{0} C</b>",
  "Начисления по месяцам": "Einnahmen pro Monat",
  "Начисления по дням": "Einnahmen pro Tag",
  "Здесь появятся начисления": "Hier erscheinen Ihre Einnahmen",
  "Подписка Про": "Pro-Abo",
  "Купила Circle": "Circle gekauft",
  "Купил Circle": "Circle gekauft",
  "Покупатель": "Käufer",
  "по промокоду": "per Code",
  "привязка истекла": "Bindung abgelaufen",
  "Это весь список · {0}": "Das ist alles · {0}",
  "Друг привязан к вам {0}: с регистрации по ссылке или с первой покупки по промокоду. Промокод работает только до первой покупки друга.": "Ein Freund bleibt {0} lang an Sie gebunden: ab Registrierung per Link oder ab dem ersten Kauf mit Code. Der Code gilt nur bis zum ersten Kauf des Freundes.",
  "Покупатели с истёкшей привязкой остаются в счёте уровня.": "Käufer mit abgelaufener Bindung zählen weiter für die Stufe.",
  "Пока никого": "Noch niemand",
  "Поделитесь ссылкой или промокодом, первые друзья появятся здесь": "Teilen Sie Ihren Link oder Code, die ersten Freunde erscheinen hier",
  "Картинка": "Bild",
  "Ссылка и промокод уже на картинке. Нажмите на шаблон, чтобы поправить подпись и опубликовать.": "Link und Code sind schon auf dem Bild. Tippen Sie auf eine Vorlage, um den Text anzupassen und zu posten.",
  "{0}, открыть и опубликовать": "{0}, öffnen und posten",
  "Для Reels, Shorts, TikTok и VK Клипов. Промокод и ссылка уже в кадре, бот пришлёт ролик в чат.": "Für Reels, Shorts, TikTok und VK Clips. Code und Link sind schon im Bild, der Bot schickt das Video in den Chat.",
  "{0}, открыть": "{0}, öffnen",
  "Ссылка и промокод уже в тексте. Скопируйте его или отправьте в чат.": "Link und Code stehen schon im Text. Kopieren oder in einen Chat senden.",
  "Картинка уйдёт в чат с подписью и кнопкой «Открыть STEOS». Подойдёт для групп, каналов и личных сообщений.": "Das Bild geht mit Text und der Schaltfläche «STEOS öffnen» in den Chat. Passt für Gruppen, Kanäle und Direktnachrichten.",
  "Баннер «{0}» с вашим промокодом": "Banner «{0}» mit Ihrem Code",
  "QR-постер: код ведёт на вашу ссылку, промокод {0}": "QR-Poster: Der Code führt zu Ihrem Link, Code {0}",
  "Кружки, фото и голос с ИИ": "KI-Rundvideos, Fotos und Stimme",
  "+{0}&nbsp;C на старт по промокоду": "+{0}&nbsp;C zum Start mit dem Code",
  "Начните по ссылке или промокоду": "Starten Sie per Link oder Code",
  "Наведите камеру телефона": "Handykamera darauf richten",
  "A4 для печати: стойки, витрины, визитки. Код ведёт на вашу ссылку, а промокод под ним можно ввести и без камеры.": "A4 zum Drucken: Aufsteller, Schaufenster, Visitenkarten. Der QR-Code führt zu Ihrem Link, den Code darunter kann man auch ohne Kamera eingeben.",
  "Цвет постера": "Posterfarbe",
  "Прислать PDF в чат": "PDF in den Chat",
  "Вывести": "Auszahlen",
  "Заявка на {0} C не подтверждена": "Antrag über {0} C nicht bestätigt",
  "Вывод сейчас недоступен": "Auszahlung derzeit nicht möglich",
  "Вывод недоступен": "Nicht verfügbar",
  "Деньгами на ваш счёт за {0}": "Aufs Konto innerhalb von {0}",
  "Вывод от {0} C": "Auszahlung ab {0} C",
  "Вывод заработает после входа через STEOS ID": "Auszahlung ist nach der Anmeldung mit STEOS ID möglich",
  "Войдите через STEOS ID": "Mit STEOS ID anmelden",
  "Вывод доступен на уровне {0}, от {1}": "Auszahlung ab Stufe {0}, ab {1}",
  "Нужен уровень {0}": "Stufe {0} nötig",
  "Вывод откроется на уровне {0}, от {1}. Пока Circle работают внутри STEOS": "Auszahlung ab Stufe {0}, ab {1}. Bis dahin nutzen Sie Circle in STEOS",
  "Не подключён": "Nicht verbunden",
  "Вход свяжет аккаунт бота с общим аккаунтом STEOS: баланс станет общим, а вывод заработает здесь и на сайте STEOS ID.": "Die Anmeldung verknüpft Ihr Bot-Konto mit dem gemeinsamen STEOS-Konto: Das Guthaben wird gemeinsam, und Auszahlungen funktionieren hier und auf der STEOS-ID-Website.",
  "Выплачено": "Ausgezahlt",
  "В обработке": "In Bearbeitung",
  "Отклонено": "Abgelehnt",
  "Не удалось загрузить историю выводов": "Auszahlungsverlauf konnte nicht geladen werden",
  "Выводов пока не было": "Noch keine Auszahlungen",
  "за всё время": "insgesamt",
  "Можно вывести": "Auszahlbar",
  "Тестовая программа: настоящих выплат нет": "Testprogramm: keine echten Auszahlungen",
  "Баланс и выводы есть и на {0}.": "Guthaben und Auszahlungen gibt es auch auf {0}.",
  "Вопрос о выводе?": "Frage zur Auszahlung?",
  "Напишите в поддержку": "Support kontaktieren",
  "Поделитесь ссылкой или промокодом": "Link oder Code teilen",
  "Друг привязывается к вам на {0}": "Der Freund wird für {0} an Sie gebunden",
  "Друг получает подарок": "Der Freund bekommt ein Geschenk",
  "+{0} C сразу и −{1}% на первый пакет Circle после подписки": "+{0} C sofort und −{1} % auf das erste Circle-Paket nach dem Abo",
  "Друг платит в STEOS": "Der Freund zahlt in STEOS",
  "Подписка и пакеты Circle звёздами или картой": "Abo und Circle-Pakete mit Stars oder Karte",
  "Вам приходит процент": "Sie erhalten einen Anteil",
  "{0}% с каждой оплаты, сразу на баланс": "{0} % jeder Zahlung, direkt aufs Guthaben",
  "Шаг {0}": "Schritt {0}",
  "От {0}": "Ab {0}",
  "С первого дня": "Ab dem ersten Tag",
  "Если {0} {1} {2}": "Bei {0} {1} mit {2}",
  "{0} C за {1}": "{0} C für {1}",
  "Хватит на {0} в месяц": "Reicht für {0} im Monat",
  "Кружок стоит {0} C": "Ein Rundvideo kostet {0} C",
  "Считаем по подписке {0}: {1} в месяц, это {2}&nbsp;C. Процент идёт с каждой оплаты друга {3} привязки.": "Gerechnet mit dem Abo {0}: {1} im Monat, das sind {2}&nbsp;C. Der Anteil kommt {3} lang aus jeder Zahlung des Freundes.",
  "Уровень считается вместе с вашими {0}.": "Ihre bisherigen Käufer zählen mit: {0}.",
  "Калькулятор дохода": "Einnahmenrechner",
  "Тариф друзей": "Tarif der Freunde",
  "Сколько друзей купят подписку": "Wie viele Freunde ein Abo kaufen",
  "Вы получите": "Sie erhalten",
  "C в месяц": "C im Monat",
  "Проценты, сроки и ограничения": "Anteile, Fristen und Grenzen",
  "Circle можно вывести": "Circle auszahlbar",
  "Circle работают внутри STEOS": "Circle nur in STEOS",
  "Привязка на {0}": "Bindung für {0}",
  "Процент идёт со всех оплат друга: с регистрации по ссылке или с первой покупки по промокоду": "Anteil an allen Zahlungen des Freundes: ab Registrierung per Link oder ab dem ersten Kauf mit Code",
  "Ссылка главнее промокода": "Link geht vor Code",
  "Если друг пришёл по ссылке, промокод привязку уже не меняет": "Kam der Freund per Link, ändert ein Code die Bindung nicht mehr",
  "Промокод только до первой покупки": "Code nur bis zum ersten Kauf",
  "После первой оплаты друга ваш промокод партнёра у него не работает": "Nach der ersten Zahlung des Freundes gilt Ihr Partnercode für ihn nicht mehr",
  "{0} C сразу, сгорят через {1}. {2} на первый пакет Circle {3} после подписки": "{0} C sofort, {1} lang gültig. {2} auf das erste Circle-Paket, {3} lang nach dem Abo",
  "Только уровень {0}": "Nur Stufe {0}",
  "От {0} {1}, после входа через STEOS ID. Для ИП, самозанятых и их аналогов в других странах": "Ab {0} {1}, nach Anmeldung mit STEOS ID. Für Einzelunternehmer, Selbstständige und Pendants im Ausland",
  "Счёт на компанию STEOS": "Rechnung an eine STEOS-Firma",
  "Плательщик появится, когда вывод откроется": "Der Zahler erscheint, sobald Auszahlungen möglich sind",
  "В РФ: {0}, в рублях. Международный статус: {1}, в евро": "In Russland: {0}, in Rubel. Internationaler Status: {1}, in Euro",
  "Выплата за {0}": "Auszahlung innerhalb von {0}",
  "После проверки счёта, от {0} C": "Nach Prüfung der Rechnung, ab {0} C",
  "Коротко о главном": "Das Wichtigste in Kürze",
  "Здесь краткое изложение. Полный текст условий на {0}": "Dies ist eine Kurzfassung. Die vollständigen Bedingungen auf {0}",
  "Понятно": "Verstanden",
  "У вас {0}.": "Sie haben {0}.",
  "Покупателей пока нет.": "Noch keine Käufer.",
  "Уровень считается по всем покупателям за всё время, с истёкшей привязкой тоже.": "Die Stufe zählt alle Käufer seit Beginn, auch mit abgelaufener Bindung.",
  "Введите сумму": "Betrag eingeben",
  "Можно вывести не больше {0} C": "Höchstens {0} C auszahlbar",
  "Заполните реквизиты": "Daten ausfüllen",
  "Загрузите счёт на оплату": "Rechnung hochladen",
  "Счёт ещё проверяется": "Rechnung wird noch geprüft",
  "Выплата в {0} · 1 C = {1} {0}": "Auszahlung in {0} · 1 C = {1} {0}",
  "Вывести {0} C": "{0} C auszahlen",
  "Счёт выставьте в {0}. Проверим его, и деньги придут за {1}.": "Stellen Sie die Rechnung in {0} aus. Nach der Prüfung kommt das Geld innerhalb von {1}.",
  "Счёт выставьте в евро. Проверим его, и деньги придут за {0}. Реквизиты сохранятся в STEOS ID.": "Stellen Sie die Rechnung in Euro aus. Nach der Prüfung kommt das Geld innerhalb von {0}. Die Daten werden in STEOS ID gespeichert.",
  "Счёт выставьте в рублях. Проверим его, и деньги придут за {0}. Реквизиты сохранятся в STEOS ID.": "Stellen Sie die Rechnung in Rubel aus. Nach der Prüfung kommt das Geld innerhalb von {0}. Die Daten werden in STEOS ID gespeichert.",
  "Скопировать {0}": "{0} kopieren",
  "юридический адрес": "Geschäftsadresse",
  "Скопировать название компании": "Firmennamen kopieren",
  "Скопировать все реквизиты": "Alle Daten kopieren",
  "Реквизиты для счёта": "Rechnungsdaten",
  "Проверяем счёт…": "Rechnung wird geprüft…",
  "PDF, JPG или PNG, до 10 МБ": "PDF, JPG oder PNG, bis 10 MB",
  "Можно вывести {0} C": "{0} C auszahlbar",
  "Сумма, C": "Betrag, C",
  "Сумма вывода, C": "Auszahlungsbetrag, C",
  "Всё": "Alles",
  "Придёт на счёт": "Sie erhalten",
  "Реквизиты": "Daten",
  "Счёт на оплату": "Rechnung",
  "Заявка на вывод принята": "Auszahlungsantrag angenommen",
  "{0} придут за {1} после проверки счёта": "{0} kommen innerhalb von {1} nach Prüfung der Rechnung",
  "Ролик принят в обработку": "Video wird vorbereitet",
  "Ролик в чате с ботом": "Video im Bot-Chat",
  "Бот пришлёт его после подготовки. Доставка пока не подтверждена.": "Der Bot schickt es, sobald es fertig ist. Zustellung noch nicht bestätigt.",
  "Сохраните его и выложите в Reels, Shorts, TikTok или VK Клипы": "Speichern und in Reels, Shorts, TikTok oder VK Clips posten",
  "Промокод и ссылка уже в кадре. Бот пришлёт ролик в чат, оттуда его можно сохранить и выложить.": "Code und Link sind schon im Bild. Der Bot schickt das Video in den Chat, dort können Sie es speichern und posten.",
  "Прислать в чат": "In den Chat senden",
  "Текст выделен: скопируйте его вручную": "Der Text ist markiert: Kopieren Sie ihn manuell",
  "Баннер готов: отправить его в чат можно из Telegram": "Banner fertig: in Telegram an einen Chat senden",
  "PDF принят в очередь": "PDF in der Warteschlange",
  "PDF в чате": "PDF im Chat",
  "Не удалось загрузить период. Попробуйте ещё раз": "Zeitraum konnte nicht geladen werden. Erneut versuchen",
  "Без начислений": "Keine Einnahmen",
  "Значение выделено: скопируйте его вручную": "Wert markiert: bitte manuell kopieren",
  "Реквизиты выделены: скопируйте их вручную": "Daten markiert: bitte manuell kopieren",
  "Нужен файл PDF, JPG или PNG": "PDF-, JPG- oder PNG-Datei nötig",
  "Файл {0}, можно до 10 МБ": "Datei hat {0}, max. 10 MB",
  "Партнёрство не загрузилось": "Partnerschaft nicht geladen",
  "Загружаем партнёрскую программу": "Partnerprogramm wird geladen",
  "за неделю": "in einer Woche",
  "за месяц": "in einem Monat",
  "Для вывода войдите через STEOS ID": "Für Auszahlungen mit STEOS ID anmelden",
  "Вывод недоступен на текущем уровне": "Auf Ihrer Stufe nicht auszahlbar",
  "Сумма больше доступной": "Betrag übersteigt das Verfügbare",
  "Сумма меньше минимальной": "Betrag unter dem Minimum",
  "Проверьте реквизиты и счёт": "Daten und Rechnung prüfen",
  "Счёт ещё не проверен. Загрузите его заново": "Rechnung noch nicht geprüft. Bitte erneut hochladen",
  "Ответ не получен. Проверьте ту же заявку: её данные и ключ сохранены": "Keine Antwort. Prüfen Sie denselben Antrag: Daten und Schlüssel sind gespeichert",
  "Не удалось загрузить список друзей": "Freundesliste konnte nicht geladen werden",
  "Не удалось восстановить прежнюю заявку. Напишите в поддержку перед новой": "Vorheriger Antrag nicht wiederherstellbar. Bitte vor einem neuen den Support kontaktieren",
  "Партнёрская программа временно недоступна": "Partnerprogramm vorübergehend nicht verfügbar",
  "Не удалось загрузить следующую страницу": "Nächste Seite konnte nicht geladen werden",
  "Не удалось подготовить баннер. Попробуйте ещё раз": "Banner konnte nicht vorbereitet werden. Erneut versuchen",
  "Бот не может подготовить материал: откройте чат с ботом и попробуйте ещё раз": "Der Bot kann das nicht vorbereiten: Bot-Chat öffnen und erneut versuchen",
  "Материал сейчас недоступен": "Material derzeit nicht verfügbar",
  "Отправка не подтверждена. Нажмите ещё раз: повтор проверит прежний запрос": "Senden nicht bestätigt. Erneut tippen: Die Wiederholung prüft die vorherige Anfrage",
  "Прежняя отправка не восстановлена. Напишите в поддержку": "Vorheriges Senden nicht wiederhergestellt. Support kontaktieren",
  "Прежняя отправка подтверждена. Нажмите ещё раз": "Vorheriges Senden bestätigt. Erneut tippen",
  "Отправка не подтверждена": "Senden nicht bestätigt",
  "Счёт не прошёл проверку. Выберите PDF, JPG или PNG до 10 МБ": "Rechnung nicht akzeptiert. PDF, JPG oder PNG bis 10 MB wählen",
  "Не удалось безопасно сохранить заявку. Отправка не выполнена": "Antrag konnte nicht sicher gespeichert werden. Nichts gesendet",
  "Тут откроется инструмент «{0}»": "Hier öffnet sich das Tool „{0}“",
  "Геральт, Цири и ещё 2 400 голосов скажут всё, что напишете": "Geralt, Ciri und 2.400 weitere Stimmen sagen alles, was Sie schreiben",
  "Снимите себя, и персонаж повторит ваши движения": "Filmen Sie sich, und die Figur macht Ihre Bewegungen nach",
  "Выберите образ, и через минуту готовы 3 кадра из одного селфи": "Wählen Sie einen Look – in einer Minute sind 3 Bilder aus einem Selfie fertig",
  "Сделать": "Erstellen",
  "2 400 голосов, 19 языков": "2.400 Stimmen, 19 Sprachen",
  "Текст в речь голосом персонажа или своим клоном": "Text zu Sprache mit der Stimme einer Figur oder Ihrem Klon",
  "Ваш голос за две минуты": "Ihre Stimme in zwei Minuten",
  "Запишите образец, и клон появится во всех инструментах с озвучкой": "Nehmen Sie eine Probe auf – der Klon erscheint in allen Tools mit Vertonung",
  "Движения": "Bewegungen",
  "бесплатно": "kostenlos",
  "/сек": "/Sek.",
  "готов": "fertig",
  "Клон · готов": "Klon · fertig",
  "студия: Мой голос": "Meine Stimme",
  "Сейчас в тренде": "Gerade im Trend",
  "Популярное за неделю": "Beliebt diese Woche",
  "Геральт скажет ваш текст": "Geralt spricht Ihren Text",
  "Вы в знаменитых сценах": "Sie in berühmten Szenen",
  "3 кадра в любом образе": "3 Bilder in jedem Look",
  "Готовый сюжет с вами": "Fertige Story mit Ihnen",
  "Вы повторите любой танец": "Sie tanzen jeden Tanz nach",
  "Ваш снимок в движении": "Ihr Foto in Bewegung",
  "Фото скажет ваш текст": "Das Foto spricht Ihren Text",
  "Легенды замка": "Burglegenden",
  "Город инков": "Stadt der Inka",
  "Неоновый дождь": "Neonregen",
  "Утренний бег": "Morgenlauf",
  "Танец теней": "Schattentanz",
  "Дорога домой": "Der Weg nach Hause",
  "Ночной рейв": "Nachtrave",
  "Снежный пик": "Schneegipfel",
  "Тайны Хейвена": "Geheimnisse von Haven",
  "Магия рун": "Runenmagie",
  "Странные дела": "Seltsame Dinge",
  "Ночной рынок": "Nachtmarkt",
  "Ретро-кадр": "Retro-Bild",
  "Утро в горах": "Morgen in den Bergen",
  "Золотой час": "Goldene Stunde",
  "Студийный свет": "Studiolicht",
  "Полароид": "Polaroid",
  "Киберпанк": "Cyberpunk",
  "Старый маяк": "Der alte Leuchtturm",
  "Шторм в заливе": "Sturm in der Bucht",
  "Кинотрейлер": "Filmtrailer",
  "Город в движении": "Stadt in Bewegung",
  "Интервью": "Interview",
  "Пустыня на закате": "Wüste bei Sonnenuntergang",
  "Подводный мир": "Unterwasserwelt",
  "Кружок «Привет»": "Rundvideo „Hallo“",
  "Спокойной ночи": "Gute Nacht",
  "Поздравляю": "Herzlichen Glückwunsch",
  "Скучаю": "Ich vermisse dich",
  "Новости дня": "Tagesnachrichten",
  "Нос корабля": "Am Bug des Schiffes",
  "Двое на носу корабля, руки раскинуты навстречу ветру": "Zwei am Bug eines Schiffes, die Arme dem Wind entgegen",
  "Героиня": "Heldin",
  "роль: Герой": "Held",
  "Уклонение от пуль": "Kugeln ausweichen",
  "Время замирает, вы прогибаетесь назад, и пули проходят мимо": "Die Zeit steht still, Sie beugen sich zurück und die Kugeln fliegen vorbei",
  "Танец в закусочной": "Tanz im Diner",
  "Пара танцует твист у стойки придорожной закусочной": "Ein Paar tanzt Twist an der Theke eines Diners",
  "Танцор": "Tänzer",
  "Танцовщица": "Tänzerin",
  "Свидание под дождём": "Date im Regen",
  "Ливень, старый дом и встреча, которую оба ждали годами": "Platzregen, ein altes Haus und ein Wiedersehen, auf das beide Jahre gewartet haben",
  "Он": "Er",
  "Она": "Sie",
  "Речь перед битвой": "Rede vor der Schlacht",
  "Вождь проезжает вдоль строя, и войско отвечает рёвом": "Der Anführer reitet die Reihen entlang, und das Heer antwortet mit Gebrüll",
  "Вождь": "Anführer",
  "Знаменосец": "Fahnenträger",
  "Погоня по крышам": "Verfolgung über die Dächer",
  "Прыжки между крышами ночного города, погоня не отстаёт": "Sprünge über die Dächer der nächtlichen Stadt, die Verfolger dicht dahinter",
  "Беглец": "Flüchtender",
  "Преследователь": "Verfolger",
  "Ограбление казино": "Casino-Coup",
  "Команда в смокингах проходит через зал, сейф уже открыт": "Eine Crew im Smoking durchquert den Saal, der Tresor ist schon offen",
  "Главарь": "Boss",
  "Напарник": "Komplize",
  "Напарница": "Komplizin",
  "Прощание на вокзале": "Abschied am Bahnhof",
  "Поезд трогается, двое держатся за руки до последнего": "Der Zug fährt an, zwei halten sich bis zuletzt an den Händen",
  "Пассажир": "Fahrgast",
  "Провожающий": "Begleitung",
  "Дуэль на закате": "Duell bei Sonnenuntergang",
  "Пустая улица, два стрелка и последние секунды тишины": "Leere Straße, zwei Revolverhelden und die letzten Sekunden Stille",
  "Шериф": "Sheriff",
  "Злодей": "Bösewicht",
  "Танец на лестнице": "Tanz auf der Treppe",
  "Злодей в ярком костюме танцует на длинной уличной лестнице": "Ein Bösewicht im knalligen Anzug tanzt auf einer langen Straßentreppe",
  "Выход в открытый космос": "Weltraumspaziergang",
  "Астронавт парит над Землёй, трос уходит к станции": "Ein Astronaut schwebt über der Erde, das Seil führt zur Station",
  "Астронавт": "Astronaut",
  "Рассвет над саванной": "Morgen über der Savanne",
  "Питомца поднимают над скалой, и вся саванна смотрит на него": "Das Haustier wird über den Felsen gehoben, und die ganze Savanne schaut zu",
  "Главная роль": "Hauptrolle",
  "Хранитель": "Hüter",
  "Полёт под луной": "Flug unter dem Mond",
  "Велосипед отрывается от земли и летит на фоне луны": "Das Fahrrad hebt ab und fliegt vor dem Mond",
  "Финальная поддержка": "Die finale Hebefigur",
  "Разбег, прыжок и поддержка над головой под аплодисменты зала": "Anlauf, Sprung und Hebefigur über dem Kopf unter dem Applaus des Saals",
  "Партнёрша": "Partnerin",
  "Партнёр": "Partner",
  "Песня на холме": "Lied auf dem Hügel",
  "Альпийский луг и ветер: вы кружитесь с песней, а дети бегут к вам навстречу": "Almwiese und Wind: Sie drehen sich singend, und die Kinder laufen auf Sie zu",
  "Бледная кожа": "Blasse Haut",
  "Хвойный лес": "Nadelwald",
  "Первый взгляд": "Der erste Blick",
  "Туман над рекой": "Nebel über dem Fluss",
  "Полночь в школе": "Mitternacht in der Schule",
  "Двое на поляне": "Zwei auf der Lichtung",
  "Луч пробивается сквозь хвою, и двое замирают посреди лесной поляны": "Ein Lichtstrahl bricht durch die Nadeln, und zwei erstarren mitten auf der Waldlichtung",
  "Глаза цвета янтаря": "Bernsteinaugen",
  "Бал выпускников": "Abschlussball",
  "Клятва": "Der Schwur",
  "Игра в грозу": "Spiel im Gewitter",
  "Гром над лесной поляной, и каждый удар битой звучит как раскат": "Donner über der Waldlichtung, jeder Schlag mit dem Schläger klingt wie Grollen",
  "Отбивающий": "Schlagmann",
  "Подающая": "Werferin",
  "Ловец": "Fänger",
  "К вершине сосны": "Zum Wipfel der Kiefer",
  "Он уносит её на спине к вершине сосны, внизу туман и весь лес": "Er trägt sie auf dem Rücken zum Wipfel einer Kiefer, unten Nebel und der ganze Wald",
  "Примерка брони": "Die Rüstung anlegen",
  "Броня защёлкивается на вас деталь за деталью, и шлем закрывает лицо": "Die Rüstung rastet Teil für Teil ein, und der Helm schließt sich über dem Gesicht",
  "Полёт над городом": "Flug über der Stadt",
  "Разгон над ночным городом, вираж между башнями и посадка на крышу": "Beschleunigung über der nächtlichen Stadt, Kurve zwischen Türmen und Landung auf dem Dach",
  "Пилот брони": "Rüstungspilot",
  "Ночь в мастерской": "Nacht in der Werkstatt",
  "Искры сварки, чертежи прямо в воздухе и первый удачный запуск": "Schweißfunken, Baupläne in der Luft und der erste gelungene Start",
  "Изобретатель": "Erfinder",
  "Последний заряд": "Die letzte Ladung",
  "Заряд брони на исходе, команда встаёт спина к спине, и всё решает последний залп": "Die Rüstung ist fast leer, das Team steht Rücken an Rücken, und der letzte Schuss entscheidet",
  "Герой в броне": "Held in Rüstung",
  "Качели на паутине": "Schwung am Netz",
  "Прыжок с карниза, паутина натягивается, и улица проносится под ногами": "Ein Sprung vom Sims, das Netz spannt sich, und die Straße rauscht unter den Füßen vorbei",
  "Герой в маске": "Maskierter Held",
  "Поцелуй под дождём": "Kuss im Regen",
  "Ночной переулок и ливень: он висит вниз головой, она приподнимает край маски": "Nächtliche Gasse und Platzregen: Er hängt kopfüber, sie hebt den Rand der Maske",
  "Крыша на закате": "Dach bei Sonnenuntergang",
  "Двое сидят на краю крыши, внизу шумит город, солнце уходит за башни": "Zwei sitzen an der Dachkante, unten rauscht die Stadt, die Sonne sinkt hinter die Türme",
  "Бой в поезде": "Kampf im Zug",
  "Схватка на крыше несущегося поезда, а потом герой останавливает вагон руками": "Ein Kampf auf dem Dach des rasenden Zuges, dann hält der Held den Wagen mit den Händen auf",
  "Пассажирка": "Passagierin",
  "Для маркетплейса": "Für Marktplätze",
  "Праздники": "Feiertage",
  "Поздравления, кружки и посты к праздникам: 1 апреля, Пасха, 8 марта": "Grüße, Rundvideos und Beiträge zu Feiertagen: 1. April, Ostern, 8. März",
  "1 апреля": "1. April",
  "Пасха": "Ostern",
  "8 марта": "8. März",
  "Мода": "Mode",
  "Аватарки": "Avatare",
  "Фильмы": "Filme",
  "Игры": "Spiele",
  "Путешествия": "Reisen",
  "Сумерки": "Dämmerung",
  "Железный человек": "Iron Man",
  "Человек-паук": "Spider-Man",
  "Романтика": "Romantik",
  "Погони": "Verfolgungsjagden",
  "Всей семьёй": "Für die ganze Familie",
  "Особая подборка": "Besondere Sammlung",
  "Особая подборка {0}, {1}": "Besondere Sammlung {0}, {1}",
  "Подборка {0}, {1}": "Sammlung {0}, {1}",
  "{0} в подборке": "{0} in der Sammlung",
  "шаблон|шаблона|шаблонов": "Vorlage|Vorlagen",
  "шаблона|шаблонов|шаблонов": "Vorlage|Vorlagen",
  "сцена|сцены|сцен": "Szene|Szenen",
  "инструмент|инструмента|инструментов": "Tool|Tools",
  "инструмента|инструментов|инструментов": "Tool|Tools",
  "стиль|стиля|стилей": "Stil|Stile",
  "кадра|кадров|кадров": "Bild|Bildern",
  "ребёнок|ребёнка|детей": "Kind|Kinder",
  "питомец|питомца|питомцев": "Haustier|Haustiere",
  "кружки": "Rundvideos",
  "голос": "Stimme",
  "текст": "Text",
  "для бизнеса": "Business",
  "Кружок из видео": "Videonachricht aus einem Video",
  "Фото в новом стиле": "Foto in neuem Stil",
  "Фото по описанию": "Foto nach Beschreibung",
  "Семейный портрет": "Familienporträt",
  "Видео в новом стиле": "Video in neuem Stil",
  "Видео по описанию": "Video nach Beschreibung",
  "Видео другим голосом": "Video mit anderer Stimme",
  "Объёмное фото": "3D-Foto",
  "Анимация из серии": "Animation aus einer Serie",
  "Видео из поездки": "Reisevideo",
  "Фильм из фотографий": "Film aus Fotos",
  "Изменить видео": "Video bearbeiten",
  "текст или запись": "Text oder Aufnahme",
  "видео до 1 минуты": "Video bis 1 Minute",
  "1 фото и текст": "1 Foto und Text",
  "запись или аудиофайл": "Aufnahme oder Audiodatei",
  "5 фото лица": "5 Gesichtsfotos",
  "1 селфи": "1 Selfie",
  "описание словами": "Beschreibung in Worten",
  "фото или описание": "Foto oder Beschreibung",
  "старое фото": "altes Foto",
  "чёрно-белое фото": "Schwarzweißfoto",
  "фото близких": "Fotos der Liebsten",
  "от 2 до 9 фото": "2 bis 9 Fotos",
  "тема поста": "Thema des Beitrags",
  "1 фото или видео": "1 Foto oder Video",
  "ваше фото": "Ihr Foto",
  "фото тех, кто сыграет": "Fotos der Mitspielenden",
  "1 видео": "1 Video",
  "видео и новый текст": "Video und neuer Text",
  "видео с речью": "Video mit Sprache",
  "текст поздравления": "Glückwunschtext",
  "от 3 фото": "ab 3 Fotos",
  "фото из поездки": "Reisefotos",
  "семейные фото": "Familienfotos",
  "сценарий": "Skript",
  "запись голоса": "Sprachaufnahme",
  "песня": "Song",
  "файл или ссылка": "Datei oder Link",
  "название товара": "Produktname",
  "от 1 до 5 фото товара": "1 bis 5 Produktfotos",
  "фото товара": "Produktfotos",
  "1 видео с вами": "1 Video mit Ihnen",
  "ваше видео": "Ihr Video",
  "картинка": "Bild",
  "идея словами": "Idee in Worten",
  "ваш промпт": "Ihr Prompt",
  "нужно: 1 фото": "1 Foto",
  "нужно: Текст": "Text",
  "нужно: Тема": "Thema",
  "нужно: Запись": "Aufnahme",
  "формат: Reels": "Reels",
  "формат: фото": "Fotos",
  "формат: видео": "Videos",
  "формат: кружков": "Rundvideos",
  "формат: шаблонов": "Vorlagen",
  "любое, где хорошо видно лицо": "beliebiges Foto, auf dem das Gesicht gut zu sehen ist",
  "лицо крупно и при хорошем свете": "Gesicht groß und bei gutem Licht",
  "селфи, лицо крупно": "Selfie, Gesicht groß",
  "снимок оживёт в ролике": "das Foto wird im Video lebendig",
  "что скажет герой": "was die Figur sagt",
  "или фото, из которых сделаем слайды": "oder Fotos, aus denen wir Folien machen",
  "Сколько стоит одна генерация": "Was kostet eine Generierung",
  "Фото стоит {0} C, фотосессия {1} C за 3 кадра, видео {2} C за 5 секунд. Помощники для текста, например описание товара, стоят {3} C. Цена всегда видна на кнопке «Создать» до списания.": "Ein Foto kostet {0} C, ein Fotoshooting {1} C für 3 Bilder, ein Video {2} C für 5 Sekunden. Texthelfer wie eine Produktbeschreibung kosten {3} C. Der Preis steht immer vor der Abbuchung auf der Schaltfläche „Erstellen“.",
  "Что такое C и как пополнить баланс": "Was ist C und wie lade ich auf",
  "C это монеты Circle, ими платят за создание. Пакеты и подписка покупаются на вкладке «Баланс», там же виден остаток.": "C sind Circle-Münzen, mit denen Sie fürs Erstellen bezahlen. Pakete und Abos kaufen Sie im Tab „Guthaben“, dort sehen Sie auch den Rest.",
  "Какие файлы можно загружать": "Welche Dateien kann ich hochladen",
  "Видео до 1 минуты и 15 МБ, фото в JPG или PNG, аудио в MP3, WAV или M4A. Ограничения показываются в самом инструменте.": "Videos bis 1 Minute und 15 MB, Fotos als JPG oder PNG, Audio als MP3, WAV oder M4A. Die Grenzen zeigt das jeweilige Tool an.",
  "Как сделать дешевле": "Wie wird es günstiger",
  "Если Circle на работу не хватает, кнопка внизу экрана откроет лист «Не хватает Circle»: в нём есть «Сделать дешевле». Скидка {0}%, на результате появится водяной знак.": "Reichen die Circle nicht, öffnet die Schaltfläche unten „Nicht genügend Circle“ mit der Option „Günstiger machen“. Sie sparen {0} %, das Ergebnis erhält ein Wasserzeichen.",
  "Где найти готовые результаты": "Wo finde ich fertige Ergebnisse",
  "В разделе «История» в меню «Ещё». Там же можно скачать файл повторно или отправить в чат.": "Im Bereich „Verlauf“ im Menü „Mehr“. Dort können Sie Dateien erneut herunterladen oder in den Chat senden.",
  "Можно ли использовать свой голос": "Kann ich meine eigene Stimme nutzen",
  "Да. Клонируйте голос на вкладке «Клон», и он появится в списке голосов во всех инструментах с озвучкой.": "Ja. Klonen Sie Ihre Stimme im Tab „Klon“ – sie erscheint dann in der Stimmenliste aller Tools mit Vertonung.",
  "Фотосессия из {0} в стиле шаблона": "Fotoshooting aus {0} im Stil der Vorlage",
  "По желанию: {0}": "Optional: {0}",
  "Тут откроется шаблон «{0}»": "Hier öffnet sich die Vorlage „{0}“",
  "Только до": "Nur vorher",
  "Только после": "Nur nachher",
  "До: {0} %": "Vorher: {0} %",
  "подборка": "Sammlung",
  "Все форматы": "Alle Formate",
  "Состав": "Besetzung",
  "Вкладки каталога": "Katalog-Tabs",
  "Найти подборку": "Sammlung finden",
  "Найти шаблон": "Vorlage finden",
  "Поиск среди {0}": "Suche in {0}",
  "По запросу «{0}» подборок нет. Поищите среди всех шаблонов": "Keine Sammlungen zu „{0}“. Suchen Sie in allen Vorlagen",
  "По запросу «{0}» в подборке «{1}» ничего нет. Поищите во всех шаблонах": "Nichts zu „{0}“ in „{1}“. Suchen Sie in allen Vorlagen",
  "По запросу «{0}» в «Рекомендуем» ничего нет. Поищите во всех шаблонах": "Nichts zu „{0}“ in „Für dich“. Suchen Sie in allen Vorlagen",
  "В подборке «{0}» нет сцен «{1}»": "Keine Szenen „{1}“ in „{0}“",
  "Посмотрите все сцены подборки": "Alle Szenen der Sammlung ansehen",
  "В подборке «{0}» нет {1}": "Keine {1} in „{0}“",
  "Посмотрите во всех форматах": "In allen Formaten ansehen",
  "В «Рекомендуем» нет {0}": "Keine {0} in „Für dich“",
  "Пока ничего нет": "Noch nichts da",
  "Шаблоны этого формата появятся совсем скоро": "Vorlagen in diesem Format kommen bald",
  "По запросу «{0}» среди {1} ничего нет. Поищите во всех форматах": "Keine {1} zu „{0}“. Suchen Sie in allen Formaten",
  "Искать во всех форматах": "In allen Formaten suchen",
  "По запросу «{0}» среди шаблонов ничего нет. Попробуйте другое слово": "Keine Vorlagen zu „{0}“. Versuchen Sie ein anderes Wort",
  "Загружаем ещё": "Mehr wird geladen",
  "Это все шаблоны": "Das sind alle Vorlagen",
  "Тренды": "Trends",
  "Вкладки страницы": "Seiten-Tabs",
  "Найти сцену": "Szene finden",
  "Найти в подборке": "In der Sammlung suchen",
  "Искать во всех сценах": "In allen Szenen suchen",
  "По запросу «{0}» подборок нет. Поищите среди всех сцен": "Keine Sammlungen zu „{0}“. Suchen Sie in allen Szenen",
  "По запросу «{0}» в подборке «{1}» ничего нет. Поищите во всех сценах": "Nichts zu „{0}“ in „{1}“. Suchen Sie in allen Szenen",
  "По запросу «{0}» в «Трендах» ничего нет. Поищите во всех сценах": "Nichts zu „{0}“ in „Trends“. Suchen Sie in allen Szenen",
  "По запросу «{0}» в «Рекомендуем» ничего нет. Поищите во всех сценах": "Nichts zu „{0}“ in „Für dich“. Suchen Sie in allen Szenen",
  "В «Трендах» нет сцен «{0}»": "Keine Szenen „{0}“ in „Trends“",
  "В «Рекомендуем» нет сцен «{0}»": "Keine Szenen „{0}“ in „Für dich“",
  "Посмотрите все сцены этой вкладки": "Alle Szenen dieses Tabs ansehen",
  "В подборке «{0}» ничего по запросу «{1}». Поищите во всех шаблонах": "Nichts in „{0}“ zu „{1}“. Suchen Sie in allen Vorlagen",
  "В этой подборке пока нет таких шаблонов. Посмотрите её целиком или выберите другую вкладку": "Diese Sammlung hat solche Vorlagen noch nicht. Sehen Sie sich alles an oder wählen Sie einen anderen Tab",
  "Поиск в подборке «{0}»: {1}": "Suche in „{0}“: {1}",
  "Вкладки подборки": "Sammlungs-Tabs",
  "Нужно: {0}": "Benötigt: {0}",
  "Нужно": "Benötigt",
  "По запросу «{0}» нет ни инструментов, ни шаблонов. Попробуйте другое слово или посмотрите все инструменты": "Keine Tools oder Vorlagen zu „{0}“. Versuchen Sie ein anderes Wort oder sehen Sie alle Tools an",
  "По запросу «{0}» в разделе «{1}» ничего нет. Поищите во всех инструментах": "Nichts zu „{0}“ in „{1}“. Suchen Sie in allen Tools",
  "Искать во всех": "Überall suchen",
  "По запросу «{0}» инструментов нет. Попробуйте другое слово": "Keine Tools zu „{0}“. Versuchen Sie ein anderes Wort",
  "Найти инструмент": "Tool finden",
  "Не удалось открыть инструмент. Обновите каталог и попробуйте снова.": "Das Tool ließ sich nicht öffnen. Aktualisieren Sie den Katalog und versuchen Sie es erneut.",
  "Не удалось открыть инструмент за 30 секунд. Обновите запрос или вернитесь назад.": "Das Tool hat sich in 30 Sekunden nicht geöffnet. Versuchen Sie es erneut oder gehen Sie zurück.",
  "Карточка товара": "Produktkarte",
  "Рилс готов": "Reel fertig",
  "Кавер не создан": "Cover nicht erstellt",
  "Фотосессия не создана": "Fotoshooting nicht erstellt",
  "Рилс не создан": "Reel nicht erstellt",
  "Карточка не создана": "Karte nicht erstellt",
  "Слайды не созданы": "Folien nicht erstellt",
  "Запись не обработана": "Aufnahme nicht verarbeitet",
  "Коллаж не создан": "Collage nicht erstellt",
  "· остаток {0} C": "· {0} C übrig",
  "Вернули {0} C": "{0} C erstattet",
  "Списано {0} C со скидкой, {1} водяной знак": "{0} C mit Rabatt abgebucht, {1} Wasserzeichen",
  "Списано {0} C": "{0} C abgebucht",
  "Рисованному стилю камера не нужна": "Ein gezeichneter Stil braucht keine Kamera",
  "У этой камеры объектив встроенный": "Diese Kamera hat ein festes Objektiv",
  "У этой камеры резкость не настраивается": "Bei dieser Kamera lässt sich die Schärfe nicht einstellen",
  "У этого объектива диафрагма постоянная": "Dieses Objektiv hat eine feste Blende",
  "Встроенный": "Fest verbaut",
  "Как у камеры": "Wie die Kamera",
  "до {0} МБ": "bis {0} MB",
  "По запросу {0} нет ни инструментов, ни шаблонов. Попробуйте другое слово или посмотрите все инструменты": "Keine Tools oder Vorlagen zu {0}. Versuchen Sie ein anderes Wort oder sehen Sie alle Tools an",
  "По запросу {0} в разделе {1} ничего нет. Поищите во всех инструментах": "Nichts zu {0} in {1}. Suchen Sie in allen Tools",
  "По запросу {0} инструментов нет. Попробуйте другое слово": "Keine Tools zu {0}. Versuchen Sie ein anderes Wort",
  "в «Трендах»": "in „Trends“",
  "в «Рекомендуем»": "in „Für dich“",
  "в подборке {0}": "in {0}",
  "По запросу {0} {1} ничего нет. Поищите во всех сценах": "Nichts zu {0} {1}. Suchen Sie in allen Szenen",
  "В подборке {0} ничего по запросу {1}. Поищите во всех шаблонах": "Nichts in {0} zu {1}. Suchen Sie in allen Vorlagen",
  "сцен {0}": "Szenen {0}",
  "В подборке {0} нет {1}": "Keine {1} in {0}",
  "В подборке {0} нет таких шаблонов": "{0} enthält solche Vorlagen nicht",
  "Посмотрите её целиком или выберите другую вкладку": "Sehen Sie sich alles an oder wählen Sie einen anderen Tab",
  "По запросу {0} в этом формате ничего нет. Поищите во всех форматах": "Nichts zu {0} in diesem Format. Suchen Sie in allen Formaten",
  "По запросу {0} среди шаблонов ничего нет. Попробуйте другое слово": "Keine Vorlagen zu {0}. Versuchen Sie ein anderes Wort",
  "Здесь нет шаблонов": "Hier gibt es keine Vorlagen",
  "Заказ принят": "Auftrag angenommen",
  "Бот пришлёт результат в чат, в отдельную тему.": "Der Bot schickt das Ergebnis in den Chat, in ein eigenes Thema.",
  "Измените запрос и попробуйте снова. Circle за проверенный заказ не возвращаются.": "Ändern Sie die Anfrage und versuchen Sie es erneut. Circle für geprüfte Aufträge werden nicht erstattet.",
  "Сбой на нашей стороне. Circle вернулись на баланс.": "Ein Fehler bei uns. Die Circle sind wieder auf Ihrem Guthaben.",
  "Инструмент ещё подключается: заказ стоит в очереди и начнётся сам, бот пришлёт результат в чат.": "Das Tool wird noch verbunden: Der Auftrag steht in der Warteschlange und startet von selbst, der Bot schickt das Ergebnis in den Chat.",
  "Сначала отметьте согласие ниже": "Bestätigen Sie zuerst die Einwilligung unten",
  "Главное фото: {0}": "Hauptfoto: {0}",
  "Загружаем превью…": "Vorschau wird geladen…",
  "Фото не подошло": "Foto ungeeignet",
  "Проверить загрузку": "Upload prüfen",
  "Опишите, что хотите увидеть": "Beschreiben Sie, was Sie sehen möchten",
  "Не помещается: до {0} знаков": "Zu lang: bis {0} Zeichen",
  "{0} во весь экран": "{0} im Vollbild",
  "Загрузить картинку": "Bild hochladen",
  "Ваша": "Ihres",
  "Убрать картинку": "Bild entfernen",
  "Этот инструмент пока недоступен": "Dieses Tool ist noch nicht verfügbar",
  "Выберите другой инструмент или вернитесь к шаблонам.": "Wählen Sie ein anderes Tool oder kehren Sie zu den Vorlagen zurück.",
  "Вернуться": "Zurück",
  "Образ": "Look",
  "Ваши селфи": "Ihre Selfies",
  "Три разных кадра: лицо крупно, при хорошем свете": "Drei verschiedene Bilder: Gesicht groß, gutes Licht",
  "Подтверждаю согласие людей на фото": "Ich bestätige die Einwilligung der Personen auf den Fotos",
  "От одного до пяти ракурсов, первый — главный": "Ein bis fünf Ansichten, die erste ist die wichtigste",
  "Категория": "Kategorie",
  "Набор сцен": "Szenen-Set",
  "Загрузите фото: нужно {0}": "Fotos hochladen: {0} benötigt",
  "Выберите: {0}": "Wählen Sie: {0}",
  "Не удалось загрузить экран.": "Der Bildschirm konnte nicht geladen werden.",
  "Сцен: {0}": "Szenen: {0}",
  "Заказ создан, следите за ним в «Истории».": "Auftrag erstellt, verfolgen Sie ihn im „Verlauf“.",
  "Старые": "Älteste",
  "Длинные": "Längste",
  "Стиль уже задаёт свет и цвет. Выберите другой, если хотите поменять": "Der Stil legt Licht und Farbe schon fest. Wählen Sie einen anderen, um sie zu ändern",
  "{0} открывается только до f/{1}": "{0} öffnet nur bis f/{1}",
  "Объектив не задаёт светосилу": "Das Objektiv gibt keine Lichtstärke vor",
  "Этот объектив открывается только до f/{0}": "Dieses Objektiv öffnet nur bis f/{0}",
  "Назад к настройкам": "Zurück zu den Einstellungen",
  "Группа": "Gruppe",
  "Нашли {0}": "{0} gefunden",
  "Ничего не нашлось. Попробуйте другое слово или сбросьте группу.": "Nichts gefunden. Versuchen Sie ein anderes Wort oder setzen Sie die Gruppe zurück.",
  "Выбор сразу вернёт к настройкам. Цена не меняется": "Die Auswahl führt direkt zurück zu den Einstellungen. Der Preis bleibt gleich",
  "Сравнить: было и стало": "Vergleichen: vorher und nachher",
  "Берём стиль: цвет, свет, обработку. Саму картинку и лица с неё не переносим": "Wir übernehmen den Stil: Farbe, Licht, Bearbeitung. Das Bild selbst und die Gesichter darauf werden nicht übertragen",
  "Берём сцену: фон, свет и подачу. Саму картинку и лица с неё не переносим": "Wir übernehmen die Szene: Hintergrund, Licht und Inszenierung. Das Bild selbst und die Gesichter darauf werden nicht übertragen",
  "Берём образ: одежду, позу, фон и свет. В кадре будете вы, лица с картинки не переносим": "Wir übernehmen den Look: Kleidung, Pose, Hintergrund und Licht. Im Bild sind Sie, Gesichter vom Bild werden nicht übertragen",
  "Картинка не подошла: не открывается, попробуйте JPG или PNG": "Bild ungeeignet: Es lässt sich nicht öffnen, versuchen Sie JPG oder PNG",
  "Картинка не подошла: больше {0} МБ": "Bild ungeeignet: größer als {0} MB",
  "Картинка не подошла: слишком маленькая, нужна от {0} px": "Bild ungeeignet: zu klein, mindestens {0} px nötig",
  "Картинка не подошла: на ней защищённое или запрещённое содержимое": "Bild ungeeignet: Es enthält geschützte oder verbotene Inhalte",
  "Загрузить картинку-референс": "Referenzbild hochladen",
  "Озвучка текста": "Text vertonen",
  "Запишите от 2 секунд речи, и бот заговорит вашим голосом": "Nehmen Sie 2 Sekunden Sprache auf – dann spricht der Bot mit Ihrer Stimme",
  "Готовые голоса стоят на вкладке «Мои» в разделе «Озвучка»": "Fertige Stimmen finden Sie im Tab „Meine“ unter „Stimmen“",
  "Под этим именем голос стоит в вашем списке. Описание видите только вы": "Unter diesem Namen steht die Stimme in Ihrer Liste. Die Beschreibung sehen nur Sie",
  "Голос появится на вкладке «Мои»": "Die Stimme erscheint im Tab „Meine“",
  "Имя в списке голосов": "Name in der Stimmenliste",
  "Уже в «Озвучке»": "Schon unter „Stimmen“",
  "Голос стоит на вкладке «Мои» с меткой «Мой голос»": "Die Stimme steht im Tab „Meine“ mit der Markierung „Meine“",
  "Карточка голоса": "Stimmkarte",
  "Нажмите на голос в списке, чтобы переименовать или удалить": "Tippen Sie auf eine Stimme, um sie umzubenennen oder zu löschen",
  "Так голос выглядит в списке": "So sieht die Stimme in der Liste aus",
  "Голос уже стоит на вкладке «Мои». Послушайте, как он звучит": "Die Stimme steht schon im Tab „Meine“. Hören Sie mal rein",
  "Идёт проверка и обучение, обычно 1–3 минуты. Голос появится на вкладке «Мои» сам": "Prüfung und Training laufen, meist 1–3 Minuten. Die Stimme erscheint dann von selbst im Tab „Meine“",
  "Голос пропадёт с вкладки «Мои». Вернуть его не получится.": "Die Stimme verschwindet aus dem Tab „Meine“. Das lässt sich nicht rückgängig machen.",
  "Обычно 1–3 минуты. Можно закрыть приложение, голос появится в списке": "Meist 1–3 Minuten. Sie können die App schließen – die Stimme erscheint in der Liste",
  "Можно закрыть приложение": "Sie können die App schließen",
  "Запишите речь или загрузите файлы: от 0:02 до 1:30. Подойдут MP3, WAV, M4A, OGG и WEBM, до 10 файлов по 20 МБ": "Sprache aufnehmen oder Dateien hochladen: 0:02 bis 1:30 insgesamt. MP3, WAV, M4A, OGG und WEBM, bis zu 10 Dateien à 20 MB",
  "Создано {n} клонов из {n}. Удалите один, чтобы добавить новый": "{n} von {n} Klonen erstellt. Löschen Sie einen, um einen neuen hinzuzufügen",
  "Без подписки можно создать {n} клона. С подпиской их будет {0}": "Ohne Abo können Sie {n} Klone erstellen. Mit Abo bis zu {0}",
  "До {0} клонов": "Bis zu {0} Klone",
  "Три клона бесплатно": "Drei Klone kostenlos",
  "Запишите ещё один, другим тоном или настроением": "Nehmen Sie noch eine auf – in anderem Ton oder anderer Stimmung",
  "С подпиской можно создать до {0}": "Mit Abo können Sie bis zu {0} erstellen",
  "Привет! Это запись для моего голоса. Я говорю спокойно и в обычном темпе, как в разговоре с другом. Чем естественнее получится сейчас, тем точнее будет звучать клон.": "Hallo! Das ist eine Aufnahme für meine Stimme. Ich spreche ruhig und in normalem Tempo, wie im Gespräch mit einem Freund. Je natürlicher es jetzt klingt, desto genauer wird der Klon.",
  "Знаете, что самое странное в готовке по видео? Смотришь, как человек за минуту режет лук, и думаешь: это же просто. А потом лук почему-то везде, кроме сковородки.": "Wissen Sie, was beim Kochen nach Video am seltsamsten ist? Man sieht, wie jemand in einer Minute eine Zwiebel schneidet, und denkt: Das ist ja einfach. Und dann ist die Zwiebel überall, nur nicht in der Pfanne.",
  "Вчера наконец разобрал коробки после переезда. Нашёл старый плеер, три зарядки от телефонов, которых уже нет, и тетрадь с планами на лето. Плеер до сих пор работает.": "Gestern habe ich endlich die Umzugskartons ausgepackt. Ich fand einen alten Player, drei Ladegeräte für Handys, die es nicht mehr gibt, und ein Heft mit Plänen für den Sommer. Der Player funktioniert immer noch.",
  "Погода сегодня странная: утром светило солнце, к обеду пошёл дождь, а к вечеру обещают снег. Самое время заварить что-нибудь горячее и никуда не торопиться.": "Das Wetter ist heute seltsam: Morgens schien die Sonne, mittags kam Regen, und für den Abend ist Schnee angesagt. Genau die richtige Zeit, etwas Heißes aufzubrühen und sich nicht zu beeilen.",
  "Раз, два, три, проверка. Меня хорошо слышно? Сейчас я прочитаю несколько фраз разным тоном: сначала спокойно, потом чуть громче, а в конце совсем тихо, почти шёпотом.": "Eins, zwei, drei, Test. Hört man mich gut? Jetzt lese ich ein paar Sätze in verschiedenem Ton: erst ruhig, dann etwas lauter und am Ende ganz leise, fast flüsternd.",
  "Мой кот считает, что клавиатура создана для сна, а монитор нужен, чтобы закрывать его хвостом. Поэтому если в записи что-то зашуршит, знайте: это была командная работа.": "Mein Kater meint, die Tastatur sei zum Schlafen da und der Monitor, um ihn mit dem Schwanz zu verdecken. Wenn es in der Aufnahme also raschelt: Das war Teamarbeit.",
  "Есть простое правило: если что-то не получается с третьей попытки, надо встать, налить чаю и вернуться через пять минут. Обычно после этого всё получается само.": "Es gibt eine einfache Regel: Wenn etwas beim dritten Versuch nicht klappt, steh auf, schenk dir Tee ein und komm in fünf Minuten zurück. Meist klappt danach alles von selbst.",
  "Тихо, слышите? Где-то рядом шаги. Сейчас аккуратно выглянем за угол, и если там никого нет, перебежим к двери. Только не шумите, пожалуйста, я серьёзно.": "Leise, hören Sie das? Irgendwo in der Nähe Schritte. Wir schauen jetzt vorsichtig um die Ecke, und wenn dort niemand ist, laufen wir zur Tür. Nur bitte keinen Lärm machen, ich meine es ernst.",
  "Проверено": "Geprüft",
  "Создание новых голосов пока недоступно": "Neue Stimmen lassen sich noch nicht erstellen",
  "От 2 секунд речи: запись в браузере или готовые файлы": "2 Sekunden Sprache: hier aufnehmen oder Dateien hochladen",
  "Внутренняя ошибка, попробуйте позже": "Interner Fehler, versuchen Sie es später erneut",
  "образцов: {n}": "Proben: {n}",
  "Образец короче 2 секунд": "Probe ist kürzer als 2 Sekunden",
  "Образец длиннее 1,5 минуты": "Probe ist länger als 1,5 Minuten",
  "Слишком шумная запись — попробуйте в тихом месте": "Aufnahme zu laut – versuchen Sie es an einem ruhigen Ort",
  "В записи слышно несколько голосов": "In der Aufnahme sind mehrere Stimmen zu hören",
  "Проверка не пройдена: голос не совпадает с образцами": "Prüfung fehlgeschlagen: Stimme passt nicht zu den Proben",
  "Голос не прошёл правила площадки": "Die Stimme verstößt gegen die Plattformregeln",
  "Проверка не пройдена: запишите образец без музыки и других людей": "Prüfung fehlgeschlagen: Nehmen Sie eine Probe ohne Musik und andere Personen auf",
  "Нужно от 2 секунд до 1,5 минуты речи в сумме": "Insgesamt 2 Sekunden bis 1,5 Minuten Sprache nötig",
  "Результат обработки уточняется, загляните чуть позже": "Das Ergebnis wird noch geprüft, schauen Sie etwas später vorbei",
  "Удалить голос «{n}»?": "Stimme „{n}“ löschen?",
  "Навсегда, вместе с образцами": "Endgültig, mit den Proben",
  "Например, спокойный, низкий": "Z. B. ruhig, tief",
  "Образец": "Probe",
  "Запись или файлы, от 2 секунд": "Aufnahme oder Dateien, ab 2 Sek.",
  "Имя, описание и согласие": "Name, Beschreibung und Einwilligung",
  "Проверка и обучение": "Prüfung und Training",
  "Модель STEOS · 1–3 минуты": "STEOS-Modell · 1–3 Min.",
  "Тихое место без эха": "Ein ruhiger Ort ohne Echo",
  "Фоновый шум и музыка попадут в голос": "Hintergrundgeräusche und Musik landen in der Stimme",
  "Хороший микрофон": "Ein gutes Mikrofon",
  "Гарнитура или настольный микрофон лучше встроенного": "Ein Headset oder Tischmikrofon ist besser als ein eingebautes",
  "То же оборудование": "Gleiche Ausrüstung",
  "Не меняйте микрофон между записями": "Wechseln Sie das Mikrofon nicht zwischen den Aufnahmen",
  "Под ним голос стоит в списке выбора": "Unter diesem Namen steht die Stimme in der Auswahl",
  "Шумоподавление": "Rauschunterdrückung",
  "Включайте, только если в записи слышен шум": "Nur einschalten, wenn in der Aufnahme Rauschen zu hören ist",
  "Согласие обязательно": "Einwilligung erforderlich",
  "Клонировать можно свой голос или с согласия владельца": "Klonen dürfen Sie Ihre eigene Stimme oder mit Einwilligung der Person",
  "Проверка образца": "Probenprüfung",
  "Один говорящий, без музыки и шума": "Eine sprechende Person, ohne Musik und Rauschen",
  "Обучение": "Training",
  "Модель STEOS, обычно 1–3 минуты": "STEOS-Modell, meist 1–3 Minuten",
  "Голос появится в списке сам": "Die Stimme erscheint von selbst in der Liste",
  "Проверьте запись": "Prüfen Sie die Aufnahme",
  "Один голос, без музыки и шума на фоне": "Eine Stimme, ohne Musik und Hintergrundgeräusche",
  "Длина образца": "Länge der Probe",
  "Нужно не меньше 2 секунд чистой речи": "Mindestens 2 Sekunden klare Sprache nötig",
  "Образцы сохранены": "Proben gespeichert",
  "Можно попробовать снова с теми же файлами": "Sie können es mit denselben Dateien erneut versuchen",
  "Не получилось — попробуйте снова": "Hat nicht geklappt – erneut versuchen",
  "Шаг {a} из {b}": "Schritt {a} von {b}",
  "Персональный": "Persönlich",
  "Дальше": "Weiter",
  "Продолжить": "Weiter",
  "К списку голосов": "Zur Stimmenliste",
  "Результат уточняется": "Wird geprüft",
  "Попробовать снова": "Erneut versuchen",
  "Голос готов": "Stimme ist fertig",
  "Опишите голос": "Stimme beschreiben",
  "Например, Мой голос": "Z. B. Meine Stimme",
  "Это мой голос или у меня есть согласие его владельца. Я не буду использовать клон для обмана, оскорблений и запрещённого контента": "Das ist meine Stimme, oder ich habe die Einwilligung der Person. Ich nutze den Klon nicht für Täuschung, Beleidigungen oder verbotene Inhalte",
  "Загружаем {a} из {b}": "Lade {a} von {b} hoch",
  "Обрабатываем голос": "Stimme wird verarbeitet",
  "Не получилось создать голос": "Stimme konnte nicht erstellt werden",
  "Результат обработки ещё уточняется. Повтор пока недоступен.": "Das Ergebnis wird noch geprüft. Ein erneuter Versuch ist noch nicht möglich.",
  "Образцы сохранены — можно попробовать снова с теми же файлами": "Proben gespeichert – Sie können es mit denselben Dateien erneut versuchen",
  "Загруженные файлы": "Hochgeladene Dateien",
  "Читаем аудио…": "Audio wird gelesen…",
  "Записать ещё": "Mehr aufnehmen",
  "Ждём разрешение…": "Warte auf Erlaubnis…",
  "Разрешите доступ в настройках браузера или загрузите файл": "Erlauben Sie den Zugriff in den Browsereinstellungen oder laden Sie eine Datei hoch",
  "Другой текст": "Anderer Text",
  "Прочитайте вслух": "Laut vorlesen",
  "Микрофон по умолчанию": "Standardmikrofon",
  "Минимум": "Minimum",
  "Хорошо": "Gut",
  "Отлично": "Ausgezeichnet",
  "Набрано {a} из {b}": "{a} von {b} erreicht",
  "из {t}": "von {t}",
  "всё готово": "alles bereit",
  "Файлов с ошибкой: {n}": "Fehlerhafte Dateien: {n}",
  "до «{n}» ещё {t}": "noch {t} bis „{n}“",
  "Ещё {t} до минимума": "Noch {t} bis zum Minimum",
  "Нужно не меньше 2 секунд": "Mindestens 2 Sekunden nötig",
  "Загрузка образцов": "Proben hochladen",
  "Образцы приняты сервером": "Der Server hat die Proben erhalten",
  "Проверка голоса": "Stimmprüfung",
  "Пройдена": "Bestanden",
  "Не запрашивалась": "Nicht angefordert",
  "Результат проверки пока недоступен": "Prüfergebnis noch nicht verfügbar",
  "Обработка голоса": "Stimmverarbeitung",
  "Не удалось обработать": "Verarbeitung fehlgeschlagen",
  "Выполняется на сервере": "Läuft auf dem Server",
  "Очистка шума": "Rauschentfernung",
  "Пропущено": "Übersprungen",
  "Модель STEOS · один говорящий, без музыки": "STEOS-Modell · eine Person, keine Musik",
  "Обучение голоса": "Stimmtraining",
  "Файл больше 20 МБ": "Datei größer als 20 MB",
  "Запись {n}": "Aufnahme {n}",
  "Не удалось прочитать аудио": "Audio konnte nicht gelesen werden",
  "Неподдерживаемый формат": "Nicht unterstütztes Format",
  "Результат прошлого создания ещё уточняется. Вернитесь к прежнему запросу, чтобы не создать второй клон.": "Das Ergebnis der letzten Erstellung wird noch geprüft. Kehren Sie zur vorherigen Anfrage zurück, um keinen zweiten Klon zu erstellen.",
  "Проверить прошлое создание": "Letzte Erstellung prüfen",
  "Остановить": "Stoppen",
  "Ждём доступ": "Warte auf Zugriff",
  "Ещё раз": "Nochmal",
  "Начать запись": "Aufnahme starten",
  "Нажмите на голос в списке, чтобы открыть его карточку: прослушать, переименовать или удалить.": "Tippen Sie auf eine Stimme, um ihre Karte zu öffnen: anhören, umbenennen oder löschen.",
  "Озвучек": "Vertonungen",
  "Знаков": "Zeichen",
  "Образцов": "Proben",
  "Доступна": "Verfügbar",
  "Недоступна": "Nicht verfügbar",
  "После обучения": "Nach dem Training",
  "Голос обучен на ваших записях: образцов {n}, всего {d}": "Mit Ihren Aufnahmen trainiert: {n} Proben, insgesamt {d}",
  "Происхождение: ваши записи. Подробнее": "Herkunft: Ihre Aufnahmen. Mehr erfahren",
  "Происхождение": "Herkunft",
  "Ваши записи": "Ihre Aufnahmen",
  "Проверка": "Prüfung",
  "Не пройдена": "Nicht bestanden",
  "Идёт": "Läuft",
  "Переозвучка аудио": "Audio-Neuvertonung",
  "Создан": "Erstellt",
  "Доступ": "Zugriff",
  "Только вы": "Nur Sie",
  "Голос пока недоступен для выбора. Обновите список.": "Die Stimme ist noch nicht auswählbar. Aktualisieren Sie die Liste.",
  "Голос ещё учится, обычно 1–3 минуты": "Die Stimme lernt noch, meist 1–3 Minuten",
  "Коротко о голосе": "Kurz zur Stimme",
  "О голосе": "Über die Stimme",
  "Голос не создан": "Stimme nicht erstellt",
  "Обработка дольше обычного": "Dauert länger als üblich",
  "Сервер ещё обрабатывает голос. Можно закрыть приложение и вернуться позже.": "Der Server verarbeitet die Stimme noch. Sie können die App schließen und später zurückkehren.",
  "Аватар {n} останется без голоса, в кружках зазвучит голос по умолчанию.": "Avatar {n} bleibt ohne Stimme, in den Kreisen erklingt die Standardstimme.",
  "Аватары {n} останутся без голоса, в кружках зазвучит голос по умолчанию.": "Die Avatare {n} bleiben ohne Stimme, in den Kreisen erklingt die Standardstimme.",
  "Записать первый голос": "Erste Stimme aufnehmen",
  "клон|клона|клонов": "Klon|Klone",
  "в месяц": "pro Monat",
  "{n} C в месяц": "{n} C pro Monat",
  "{n} своих голосов": "{n} eigene Stimmen",
  "Оформить": "Abonnieren",
  "Подписка активна": "Abo aktiv",
  "Подписка «{n}»": "Abo „{n}“",
  "{n} голосов ваши": "{n} Stimmen gehören Ihnen",
  "Доступно — своих голосов": "Eigene Stimmen verfügbar",
  "{n} голосов мало?": "{n} Stimmen zu wenig?",
  "Возьмите {n}": "Holen Sie sich {n}",
  "Нужно больше голосов?": "Mehr Stimmen nötig?",
  "До {n} с подпиской": "Bis zu {n} mit Abo",
  "Посмотрите доступные подписки": "Verfügbare Abos ansehen",
  "Занято {a} из {b}. Записывайте голоса под разные задачи и настроения": "{a} von {b} belegt. Nehmen Sie Stimmen für verschiedene Zwecke und Stimmungen auf",
  "Без подписки можно создать {a} {w}. С любой подпиской их будет {b}": "Ohne Abo können Sie {a} {w} erstellen. Mit jedem Abo bis zu {b}",
  "Без подписки: {n}. Лимит зависит от выбранной подписки.": "Ohne Abo: {n}. Das Limit hängt vom gewählten Abo ab.",
  "Занято {a} из {b}": "{a} von {b} belegt",
  "Без подписки · {n}": "Ohne Abo · {n}",
  "С подпиской · {n}": "Mit Abo · {n}",
  "Смотреть все подписки": "Alle Abos ansehen",
  "Повторить сохранение": "Erneut speichern",
  "Сохраняем изменения…": "Änderungen werden gespeichert…",
  "Управление голосами временно недоступно": "Die Stimmverwaltung ist vorübergehend nicht verfügbar",
  "клон: Мой голос": "Meine Stimme",
  "Свои голоса временно недоступны. Попробуйте обновить список позже.": "Eigene Stimmen sind vorübergehend nicht verfügbar. Aktualisieren Sie die Liste später.",
  "Сервис голосов временно недоступен. Попробуйте ещё раз позже.": "Der Stimmdienst ist vorübergehend nicht verfügbar. Versuchen Sie es später erneut.",
  "Не удалось подтвердить лимит голосов. Обновите список позже.": "Das Stimmenlimit konnte nicht bestätigt werden. Aktualisieren Sie die Liste später.",
  "Не удалось подтвердить аккаунт. Попробуйте ещё раз позже.": "Das Konto konnte nicht bestätigt werden. Versuchen Sie es später erneut.",
  "Имя голоса должно содержать от 2 до 32 символов.": "Der Stimmname muss 2 bis 32 Zeichen lang sein.",
  "Описание должно содержать не больше 120 символов.": "Die Beschreibung darf höchstens 120 Zeichen lang sein.",
  "Добавьте от 1 до 10 подходящих образцов.": "Fügen Sie 1 bis 10 passende Proben hinzu.",
  "Превью этого голоса пока недоступно.": "Die Vorschau dieser Stimme ist noch nicht verfügbar.",
  "Не удалось загрузить превью. Попробуйте позже.": "Vorschau konnte nicht geladen werden. Versuchen Sie es später.",
  "Слишком шумная запись. Попробуйте записать голос в тихом месте.": "Die Aufnahme ist zu laut. Nehmen Sie an einem ruhigen Ort auf.",
  "В записи слышно несколько голосов. Добавьте речь одного человека.": "Mehrere Stimmen sind zu hören. Fügen Sie die Sprache einer einzigen Person hinzu.",
  "Голос не прошёл правила площадки.": "Die Stimme verstößt gegen die Plattformregeln.",
  "Сервис не смог обработать голос. Проверьте статус перед повтором.": "Der Dienst konnte die Stimme nicht verarbeiten. Prüfen Sie den Status, bevor Sie es erneut versuchen.",
  "Согласие изменилось или недоступно. Обновите список и подтвердите актуальную версию перед повтором.": "Die Einwilligung hat sich geändert oder ist nicht verfügbar. Aktualisieren Sie die Liste und bestätigen Sie die aktuelle Version.",
  "Загрузка отклонена. Нажмите кнопку ещё раз, чтобы загрузить образец заново.": "Upload abgelehnt. Tippen Sie erneut auf die Schaltfläche, um die Probe neu hochzuladen.",
  "Загрузка ещё не подтверждена. Нажмите кнопку ещё раз: сначала проверим прежнюю загрузку.": "Upload noch nicht bestätigt. Tippen Sie erneut auf die Schaltfläche: Zuerst prüfen wir den vorherigen Upload.",
  "Выберите аудиофайл MP3, WAV, M4A, OGG или WebM.": "Wählen Sie eine MP3-, WAV-, M4A-, OGG- oder WebM-Audiodatei.",
  "Не удалось прочитать аудио. Попробуйте ещё раз или загрузите файл.": "Audio konnte nicht gelesen werden. Versuchen Sie es erneut oder laden Sie eine Datei hoch.",
  "Пример звучания": "Hörprobe",
  "Пример звучания пока недоступен": "Hörprobe noch nicht verfügbar",
  "Превью голоса": "Stimmvorschau",
  "Прослушать пример": "Hörprobe abspielen",
  "Скидка {0}% на первый пакет Circle действует {1} {2} после оформления подписки": "{0} % Rabatt auf das erste Circle-Paket, gültig {1} {2} nach Abschluss eines Abos",
  "Вы уже пришли по ссылке партнёра": "Sie sind bereits über einen Partnerlink gekommen",
  "Промокод партнёра уже применён": "Ein Partnercode wurde bereits eingelöst",
  "Тут откроется тема чата, куда бот прислал {0}": "Hier öffnet sich das Chat-Thema mit Ihrem Ergebnis: {0}",
  "можно вывести": "auszahlbar",
  "только в STEOS": "nur in STEOS",
  "Не короче {0} знаков": "Mindestens {0} Zeichen",
  "Введите почту и пароль": "E-Mail-Adresse und Passwort eingeben",
  "от {0} знаков": "ab {0} Zeichen",
  "После входа Circle станут общими для бота и аккаунта STEOS. Баланс и вывод есть и на {0}.": "Nach der Anmeldung teilen sich Bot und STEOS-Konto Ihre Circle. Guthaben und Auszahlung gibt es auch auf {0}.",
  "Вход или новый аккаунт": "Anmelden oder neues Konto",
  "Придумайте пароль": "Passwort festlegen",
  "Ваш пароль": "Ihr Passwort",
  "Принимаю {0} и {1} STEOS": "Ich akzeptiere die {0} und die {1} von STEOS",
  "согласие: условия": "Bedingungen",
  "согласие: политику конфиденциальности": "Datenschutzerklärung",
  "Пришлём ссылку на почту": "Wir senden Ihnen einen Link per E-Mail",
  "Откройте ссылку из письма и задайте новый пароль на {0}. Потом войдите здесь с новым паролем.": "Öffnen Sie den Link aus der E-Mail und legen Sie auf {0} ein neues Passwort fest. Melden Sie sich dann hier damit an.",
  "Ссылка для нового пароля ушла на {0}": "Der Link für ein neues Passwort wurde an {0} gesendet",
  "Письма нет? Проверьте папку «Спам».": "Keine E-Mail? Prüfen Sie den Spam-Ordner.",
  "Аккаунт создан и подключён": "Konto erstellt und verbunden",
  "Баланс бота теперь общий с аккаунтом STEOS.": "Das Bot-Guthaben ist jetzt mit Ihrem STEOS-Konto geteilt.",
  "Подтвердите почту по ссылке из письма.": "Bestätigen Sie Ihre E-Mail-Adresse über den Link in der Nachricht.",
  "Вывод работает здесь и на {0}.": "Auszahlungen gehen hier und auf {0}.",
  "Открыть {0}": "{0} öffnen",
  "Ссылка ушла на {0}. Откройте её, затем проверьте подключение здесь.": "Der Link wurde an {0} gesendet. Öffnen Sie ihn und prüfen Sie dann hier die Verbindung.",
  "Проверить подключение": "Verbindung prüfen",
  "Почти готово": "Fast fertig",
  "Почта ещё не подтверждена": "E-Mail-Adresse noch nicht bestätigt",
  "Не удалось проверить. Попробуйте позже": "Prüfung fehlgeschlagen. Versuchen Sie es später",
  "Озвучиваю тексты голосом героя": "Texte mit der Stimme eines Helden",
  "Любой голос из библиотеки или свой": "Jede Stimme aus der Bibliothek oder Ihre eigene",
  "Озвучиваю тексты голосами героев в STEOS. Попробуйте по моей ссылке, промокод {0}": "Ich vertone Texte mit Heldenstimmen in STEOS. Probiert es über meinen Link aus, Aktionscode {0}",
  "Пишу текст, персонаж говорит": "Ich schreibe, die Figur spricht",
  "Делаю кружки с персонажами в STEOS: пишу текст, а персонаж его говорит. Промокод {0}": "Ich mache Rundvideos mit Figuren in STEOS: Ich schreibe den Text, die Figur spricht ihn. Aktionscode {0}",
  "Свои фото в любом образе": "Eigene Fotos in jedem Look",
  "Фотосессия в любом образе по паре моих фото, без студии. STEOS, промокод {0}": "Ein Fotoshooting in jedem Look aus ein paar meiner Fotos, ohne Studio. STEOS, Aktionscode {0}",
  "Вы в кадре, монтаж и музыка сами": "Sie im Bild, Schnitt und Musik automatisch",
  "Снимаюсь в рилсах одной кнопкой в STEOS: сюжет, монтаж и музыка уже в шаблоне. Промокод {0}": "Ich spiele per Tipp in Reels mit, dank STEOS: Handlung, Schnitt und Musik stecken schon in der Vorlage. Aktionscode {0}",
  "Персонаж оживает": "Die Figur wird lebendig",
  "Говорит вашим текстом": "Spricht Ihren Text",
  "Персонаж говорит моим текстом и своим голосом. Попробуйте STEOS, промокод {0}": "Die Figur spricht meinen Text mit ihrer eigenen Stimme. Probiert STEOS aus, Aktionscode {0}",
  "Клон голоса за минуту": "Stimmklon in einer Minute",
  "Запишите от 2 секунд, дальше говорит клон": "2 Sekunden aufnehmen, dann spricht der Klon",
  "Клон моего голоса за минуту в STEOS: теперь он озвучивает всё сам. Промокод {0}": "Ein Klon meiner Stimme in einer Minute mit STEOS: Jetzt spricht er alles für mich. Aktionscode {0}",
  "Старому фото цвет и резкость": "Farbe und Schärfe für alte Fotos",
  "Восстановление за минуту": "Restauriert in einer Minute",
  "Возвращаю старым фото цвет и резкость в STEOS. Промокод {0}": "Ich gebe alten Fotos mit STEOS Farbe und Schärfe zurück. Aktionscode {0}",
  "По ссылке или промокоду": "Per Link oder Aktionscode",
  "Дарю +{0} C и скидку {1}% на первый пакет в STEOS по моему промокоду {2}": "Ich schenke euch +{0} C und {1} % Rabatt auf das erste Paket in STEOS mit meinem Aktionscode {2}",
  "Кавер на любую песню": "Ein Cover zu jedem Song",
  "Рок, джаз, lo-fi любым голосом": "Rock, Jazz, Lo-Fi mit jeder Stimme",
  "Кавер на любую песню любым голосом в STEOS. Промокод {0}": "Ein Cover zu jedem Song mit jeder Stimme in STEOS. Aktionscode {0}",
  "Мой аватар в любом образе": "Mein Avatar in jedem Look",
  "Свой аватар из 10 фото": "Eigener Avatar aus 10 Fotos",
  "Мой аватар в любом образе: собран из 10 фото в STEOS. Промокод {0}": "Mein Avatar in jedem Look, erstellt aus 10 Fotos mit STEOS. Aktionscode {0}",
  "Это я, только говорю вашим текстом": "Das bin ich, nur mit Ihrem Text",
  "сторис: Мой голос": "Meine Stimme",
  "на баланс сразу": "sofort aufs Guthaben",
  "на первый пакет Circle": "auf das erste Circle-Paket",
  "Сторис открыта в Telegram": "Story in Telegram geöffnet",
  "Сторис готова": "Story fertig",
  "Осталось нажать «Опубликовать» в редакторе Telegram": "Jetzt nur noch im Telegram-Editor veröffentlichen",
  "Тут откроется редактор сторис Telegram с этой картинкой и подписью": "Hier öffnet sich der Telegram-Story-Editor mit diesem Bild und Text",
  "Подпись к сторис": "Story-Text",
  "Кнопка-ссылка на сторис в Telegram есть только с Premium. Промокод на картинке видят все.": "Einen Link-Button in Stories gibt es nur mit Telegram Premium. Den Aktionscode auf dem Bild sehen alle.",
  "Опубликовать в сторис": "In Story posten",
  "Попробовать STEOS": "STEOS testen",
  "Не удалось подготовить сторис. Попробуйте ещё раз": "Story konnte nicht vorbereitet werden. Versuchen Sie es noch einmal",
  "Сторис отправляет Telegram: откройте мини-приложение в Telegram": "Stories sendet Telegram: Öffnen Sie die Mini App in Telegram",
  "Ссылка и промокод уже на картинке": "Link und Aktionscode sind schon auf dem Bild",
  "Попробуйте STEOS по моей ссылке. Промокод {0}": "Probier STEOS über meinen Link aus. Aktionscode {0}",
  "Попробуйте STEOS по моей ссылке: +{0} C и скидка {1}% на первый пакет. Промокод {2}": "Probier STEOS über meinen Link aus: +{0} C und {1} % Rabatt auf das erste Paket. Aktionscode {2}",
  "Ссылка": "Link",
  "Скопировать ссылку": "Link kopieren",
  "Друзьям {0} и {1} на первый пакет": "Freunde erhalten {0} und {1} aufs erste Paket",
  "Промокод выделен: скопируйте вручную": "Aktionscode markiert: bitte manuell kopieren",
  "Ссылка выделена: скопируйте вручную": "Link markiert: bitte manuell kopieren",
  "Ссылка скопирована": "Link kopiert",
  "Ссылка выделена: скопируйте её вручную": "Link markiert: bitte manuell kopieren",
  "Ссылка выделена": "Link markiert",
  "Вы пришли по приглашению": "Sie wurden eingeladen",
  "{0} C на баланс": "{0} C aufs Guthaben",
  "Сгорят через {0} {1}": "Gültig für {0} {1}",
  "{0} на первый пакет Circle": "{0} auf das erste Circle-Paket",
  "{0} {1} после оформления подписки": "{0} {1} nach Abschluss eines Abos",
  "Пакеты Circle можно купить с любой подпиской. Скидка начнёт действовать, как только вы её оформите.": "Circle-Pakete gibt es mit jedem Abo. Der Rabatt gilt, sobald Sie eines abschließen.",
  "Выбрать тариф": "Tarif wählen",
  "QR-код ссылки приглашения, промокод {0}": "QR-Code des Einladungslinks, Aktionscode {0}",
  "Друг наведёт камеру и откроет бота": "Ihr Freund scannt den Code und öffnet den Bot",
  "Цвет карточки": "Kartenfarbe",
  "Скачать картинку": "Bild speichern",
  "Аврора": "Aurora",
  "Закат": "Abendrot",
  "Океан": "Ozean",
  "Графит": "Graphit",
  "Партнёры": "Partner",
  "Нашёл бота, где любой персонаж скажет в кружке твой текст. Там же фото, видео и озвучка любым голосом, всё прямо в Telegram.": "Hab einen Bot gefunden, in dem jede Figur deinen Text in einer Videonachricht spricht. Dazu Fotos, Videos und Vertonung mit jeder Stimme, alles direkt in Telegram.",
  "Делюсь находкой: STEOS, бот в Telegram, где я делаю кружки с персонажами, озвучку и фото. Пишете текст, выбираете голос, и через минуту готово.": "Ein Fund zum Teilen: STEOS, ein Telegram-Bot, in dem ich Videonachrichten mit Figuren, Vertonungen und Fotos mache. Text schreiben, Stimme wählen, und in einer Minute ist es fertig.",
  "Восстанавливаю наши старые семейные фото в STEOS: за минуту возвращает цвет и резкость. Пришлите мне снимки, которые хотите обновить, или попробуйте сами.": "Ich restauriere unsere alten Familienfotos in STEOS: Farbe und Schärfe sind in einer Minute zurück. Schickt mir die Bilder, die ihr auffrischen wollt, oder probiert es selbst.",
  "Кто хотел кружок голосом любимого героя? В STEOS пишешь текст, и персонаж из игры или сериала его произносит. Это бот в Telegram.": "Wer wollte schon mal eine Videonachricht mit der Stimme seines Lieblingshelden? In STEOS schreibst du einen Text, und eine Figur aus einem Spiel oder einer Serie spricht ihn. Es ist ein Telegram-Bot.",
  "Фото товара, карточки с преимуществами и описания для маркетплейсов делаю в STEOS за пару минут, без студии и дизайнера. Может, и вам пригодится.": "Produktfotos, Karten mit Vorteilen und Beschreibungen für Marktplätze mache ich in STEOS in ein paar Minuten, ohne Studio und Designer. Vielleicht ist es auch für euch nützlich.",
  "Озвучиваю ролики своим клоном голоса, снимаюсь в рилсах по готовым шаблонам и записываю каверы. Всё в одном боте STEOS в Telegram.": "Ich vertone meine Videos mit meinem Stimmklon, spiele in Reels nach fertigen Vorlagen mit und nehme Cover auf. Alles in einem STEOS-Bot in Telegram.",
  "По моей ссылке +{0} C на старт.": "Mit meinem Link gibt es +{0} C zum Start.",
  "По моей ссылке +{0} C и −{1}% на первый пакет.": "Mit meinem Link: +{0} C und −{1}% auf das erste Paket.",
  "Попробуй сам.": "Probier’s aus.",
  "Попробуйте сами.": "Probiert es selbst aus.",
  "Актёры": "Schauspieler",
  "Персонажи и актёры": "Figuren und Schauspieler",
  "По запросу «{q}» голосов нет. Попробуйте другое слово или загляните в подборки": "Keine Stimmen zu „{q}“. Versuch ein anderes Wort oder schau in die Sammlungen",
  "Здесь пока нет голосов. Загляните в другие вкладки или подборки": "Hier gibt es noch keine Stimmen. Schau in die anderen Tabs oder Sammlungen",
  "Голос вернётся на экран создания": "Die Stimme geht zurück zur Erstellung",
  "После выбора пишите текст для озвучки в чат бота": "Danach den Text zum Vertonen im Bot-Chat senden",
  "От Я до А": "Von Z bis A",
  "Сортировка и фильтры": "Sortierung und Filter",
  "Сбросить": "Zurücksetzen",
  "Чаще всего выбирают": "Am häufigsten gewählt",
  "Сначала свежие": "Neueste zuerst",
  "Сначала давние": "Älteste zuerst",
  "Сначала недорогие": "Günstigste zuerst",
  "Сначала короткие ролики": "Kürzeste Videos zuerst",
  "По названию": "Nach Name",
  "По названию, с конца алфавита": "Nach Name, vom Ende des Alphabets",
  "Вертикальные ролики": "Hochformat-Videos",
  "Картинки и посты": "Bilder und Beiträge",
  "Горизонтальные ролики": "Querformat-Videos",
  "Видеосообщения Telegram": "Telegram-Videonachrichten",
  "Один человек в кадре": "Eine Person im Bild",
  "Трое и больше": "Drei oder mehr",
  "С ребёнком": "Mit Kind",
  "С питомцем": "Mit Haustier",
  "Двое человек в кадре": "Zwei Personen im Bild",
  "О разделе": "Über diesen Bereich",
  "Превращает текст в речь: голос из каталога или ваш клон, настройки интонации и скорости.": "Wandelt Text in Sprache um: eine Stimme aus dem Katalog oder Ihr Klon, mit Einstellungen für Intonation und Tempo.",
  "Копия вашего голоса по записи: ею можно озвучивать любые тексты.": "Eine Kopie Ihrer Stimme aus einer Aufnahme: damit können Sie beliebige Texte vertonen.",
  "AI-студия: ролики, фото, кружки и другие шаблоны с вами, близкими и персонажами.": "KI-Studio: Videos, Fotos, Kreise und andere Vorlagen mit Ihnen, Ihren Liebsten und Figuren.",
  "Кредиты (C) на счёте и пополнение. Кредиты списываются за озвучку и заказы студии.": "Credits (C) auf dem Konto und Aufladen. Credits werden für Vertonungen und Studio-Aufträge abgebucht.",
  "Задания и награды: выполняйте задания и получайте кредиты.": "Aufgaben und Belohnungen: Aufgaben erledigen und Credits erhalten.",
  "Все ваши озвучки и заказы студии: послушать, скачать или повторить.": "Alle Ihre Vertonungen und Studio-Aufträge: anhören, herunterladen oder wiederholen.",
  "Ваш профиль и данные аккаунта.": "Ihr Profil und Ihre Kontodaten.",
  "Настройки приложения: язык, валюта и уведомления.": "App-Einstellungen: Sprache, Währung und Benachrichtigungen.",
  "Ответы на частые вопросы и связь с поддержкой.": "Antworten auf häufige Fragen und Kontakt zum Support.",
  "Партнёрская программа: приглашайте друзей и получайте процент с их пополнений.": "Partnerprogramm: Freunde einladen und einen Prozentsatz ihrer Aufladungen erhalten.",
  "Озвучка больших текстов и сценариев по ролям.": "Vertonung langer Texte und Drehbücher nach Rollen.",
  "Вы или один близкий": "Sie oder eine nahestehende Person",
  "Вы и близкий": "Sie und eine nahestehende Person",
  "Товары и места": "Produkte und Orte",
  "Фото товара, блюда или места": "Foto eines Produkts, Gerichts oder Ortes",
  "В избранном": "In Favoriten",
  "Голоса и персонажи, которые вы отметили сердцем": "Stimmen und Figuren, die Sie mit einem Herz markiert haben",
  "Нажмите — выбрать голос": "Tippen, um eine Stimme zu wählen",
  "Удерживайте — карточка голоса": "Halten für die Stimmkarte",
  "Карточка голоса или персонажа": "Stimm- oder Figurenkarte",
  "Нажмите на голос, чтобы выбрать его": "Tippe auf eine Stimme, um sie zu wählen",
  "Удерживайте, чтобы открыть карточку голоса": "Gedrückt halten, um die Stimmkarte zu öffnen",
  "Удаление голоса": "Stimme löschen",
  "Подсказка": "Hinweis",
  "Пример звучания пока недоступен. Попробуйте позже.": "Die Hörprobe ist noch nicht verfügbar. Versuche es später erneut.",
  "Языков: {0}": "Sprachen: {0}",
  "Ещё языков: {0}": "Weitere Sprachen: {0}",
  "Ход примера": "Fortschritt der Hörprobe",
  "Голос говорит на {0} языках": "Die Stimme spricht {0} Sprachen",
  "Все голоса мультиязычные и озвучат текст на любом языке системы.": "Alle Stimmen sind mehrsprachig und sprechen Text in jeder Sprache des Systems.",
  "Голоса подборки": "Stimmen der Sammlung",
  "Удерживайте голос, чтобы открыть его": "Halte eine Stimme gedrückt, um sie zu öffnen",
  "Назад к голосу": "Zurück zur Stimme",
  "Оригинал голоса говорил на {0} языке": "Die Originalstimme sprach {0}",
  "Происхождение: {0}. Подробнее": "Herkunft: {0}. Details",
  "Новый": "Neu",
  "Официальный": "Offiziell",
  "Актёр": "Schauspieler",
  "Удерживайте, чтобы послушать": "Gedrückt halten zum Anhören",
  "Удерживайте строку голоса или нажмите её правой кнопкой мыши, чтобы открыть карточку голоса. Персонаж открывается обычным нажатием.": "Halte eine Stimmzeile gedrückt oder klicke mit der rechten Maustaste, um die Stimmkarte zu öffnen. Eine Figur öffnet sich mit einfachem Tippen.",
  "Подборка · Голосов: {0}": "Sammlung · Stimmen: {0}",
  "Доступные голоса появятся в каталоге. Здесь можно будет прослушать пример и выбрать голос для бота.": "Verfügbare Stimmen erscheinen im Katalog. Hier kannst du eine Hörprobe anhören und eine Stimme für den Bot wählen.",
  "Зажмите голос": "Halte eine Stimme gedrückt",
  "Удерживайте строку голоса, чтобы открыть его карточку: прослушать и посмотреть подборки. Короткое нажатие выбирает голос.": "Halte eine Stimmzeile gedrückt, um ihre Karte zu öffnen: anhören und Sammlungen ansehen. Kurzes Tippen wählt die Stimme.",
  "Нажмите на аватарку": "Tippe auf den Avatar",
  "Круглая аватарка в строке проигрывает пример голоса. Нажмите ещё раз, чтобы остановить. Нажатие на саму строку выбирает голос.": "Der runde Avatar in der Zeile spielt eine Hörprobe ab. Tippe erneut zum Stoppen. Tippen auf die Zeile wählt die Stimme.",
  "Сохраняйте в избранное": "In Favoriten speichern",
  "Нажмите сердце в карточке голоса или персонажа — они соберутся в подборке «Избранное», первой в «Подборках» и на «Рекомендуем». Нажмите ещё раз, чтобы убрать.": "Tippe auf das Herz in einer Stimm- oder Figurenkarte – sie landen in der Sammlung „Favoriten“, ganz vorne unter „Sammlungen“ und „Empfohlen“. Erneut tippen zum Entfernen.",
  "Запишите свой голос": "Nimm deine Stimme auf",
  "30 секунд речи или пара файлов, и через две минуты ваш голос появится во всех инструментах с озвучкой. Нажмите «Записать» и читайте текст с экрана.": "30 Sekunden Sprache oder ein paar Dateien, und in zwei Minuten erscheint deine Stimme in allen Werkzeugen mit Vertonung. Tippe auf „Aufnehmen“ und lies den Text vom Bildschirm.",
  "Читать полностью": "Weiterlesen",
  "Голос STEOS": "STEOS-Stimme",
  "Назад к персонажу": "Zurück zur Figur",
  "Назад к списку": "Zurück zur Liste",
  "Актёр STEOS": "STEOS-Schauspieler",
  "Персонаж STEOS": "STEOS-Figur",
  "Об актёре": "Über den Schauspieler",
  "О персонаже": "Über die Figur",
  "Голоса актёра": "Stimmen des Schauspielers",
  "Голоса персонажа": "Stimmen der Figur",
  "шапка: Мой голос": "Meine Stimme",
  "Пример голоса «{0}»": "Hörprobe der Stimme „{0}“",
  "Ещё языки": "Weitere Sprachen",
  "Юзеры": "Nutzer",
  "Лайки": "Likes",
  "Пол": "Geschlecht",
  "В каталоге с": "Im Katalog seit",
  "Автор": "Autor",
  "Откуда": "Aus",
  "Характер": "Charakter",
  "Голосов": "Stimmen",
  "Мужской": "Männlich",
  "Женский": "Weiblich",
  "Детский": "Kinder",
  "Не указан": "Nicht angegeben",
  "Голос персонажа": "Stimme der Figur",
  "Выберите поддерживаемый аудиофайл до {0} МБ.": "Wähle eine unterstützte Audiodatei bis {0} MB.",
  "пол: Детский": "Kinderstimme",
  "Состав подборки": "Inhalt der Sammlung",
  "Закрыть выбор голоса": "Stimmauswahl schließen",
  "Не удалось открыть запись для прослушивания.": "Die Aufnahme konnte nicht zum Anhören geöffnet werden.",
  "Использовать готовую запись": "Fertige Aufnahme verwenden",
  "Подтвердите права на материалы, чтобы взять запись.": "Bestätige deine Rechte an den Materialien, um die Aufnahme zu verwenden.",
  "Работа из доната": "Werk aus einer Spende",
  "Модель синтеза": "Synthesemodell",
  "Новая модель": "Neues Modell",
  "Прежняя модель": "Bisheriges Modell",
  "Удерживайте — карточка голоса и модель синтеза": "Gedrückt halten: Stimmkarte und Synthesemodell",
  "Модель для озвучки в чате": "Modell für die Vertonung im Chat",
  "Новая модель: эмоции и живая интонация, вопросы, много языков, клоны голоса": "Neues Modell: Emotionen und natürliche Intonation, Fragen, viele Sprachen, Stimmklone",
  "Прежняя модель: только пять языков, без эмоций и вопросительной интонации, без клонов": "Bisheriges Modell: nur fünf Sprachen, ohne Emotionen und Frageintonation, ohne Klone",
  "Активная модель: STEOS Voice": "Aktives Modell: STEOS Voice",
  "Активная модель:": "Aktives Modell:",
  "Новая модель: 19 языков, естественное звучание с живыми интонациями — без металла и роботизированности, качественное клонирование голоса": "Neues Modell: 19 Sprachen, natürlicher Klang mit lebendiger Intonation – ohne Metall und Roboterklang, hochwertiges Stimmklonen",
  "Прежняя модель: только 5 языков, без эмоций и вопросительной интонации, без клонов голоса": "Bisheriges Modell: nur 5 Sprachen, ohne Emotionen und Frageintonation, ohne Stimmklone",
  "На модели STEOS Voice {0} все голоса мультиязычные и озвучат текст на любом из этих языков.": "Im Modell STEOS Voice {0} sind alle Stimmen mehrsprachig und sprechen Text in jeder dieser Sprachen.",
  "На модели STEOS Voice {0} все голоса мультиязычные и озвучат текст на любом из {1}.": "Im Modell STEOS Voice {0} sind alle Stimmen mehrsprachig und sprechen Text in jeder {1}.",
  "этих языков": "dieser Sprachen",
  "Языки озвучки": "Sprachen für die Vertonung",
  "Любой голос на модели STEOS Voice {0} озвучит текст на каждом из этих языков": "Jede Stimme im Modell STEOS Voice {0} spricht Text in jeder dieser Sprachen",
  "Все голоса": "Alle Stimmen",
  "Озвучка текста и переозвучка": "Sprachausgabe und Stimmwechsel",
  "Переозвучка записи": "Stimmwechsel in Aufnahmen",
  "Меняют голос в вашей записи": "Ändern die Stimme in deiner Aufnahme",
  "Выберите голос для переозвучки записи": "Wähle eine Stimme für den Stimmwechsel deiner Aufnahme",
  "Голос выбран — вернитесь в чат и нажмите «Продолжить переозвучку»": "Stimme gewählt – kehre zum Chat zurück und tippe auf „Stimmwechsel fortsetzen“"
}
